export const examQuestionsBatch1RussianCorrected = [
    {
      id: 1,
      text: "Какое из следующих утверждений лучше всего демонстрирует эффект ИИ? Выберите один вариант.",
      options: [
        "Люди перестают доверять ИИ-решениям после первых ошибок",
        "Экспертные системы больше не считаются ИИ",
        "ИИ становится менее впечатляющим по мере его распространения",
        "Пользователи ожидают более сложного поведения от ИИ-систем"
      ],
      correct: 1,
      expA: "Недоверие связано с пользовательским опытом, а не с эффектом ИИ как феноменом восприятия.",
      expB: "Правильно. Эффект ИИ проявляется, когда технологические достижения перестают восприниматься как искусственный интеллект.",
      expC: "Это описывает адаптацию восприятия, но не раскрывает суть эффекта ИИ.",
      expD: "Растущие ожидания - следствие, а не определение эффекта ИИ.",
      points: 1,
      chapter: "Введение в ИИ",
      difficulty: "K2"
    },
    {
      id: 2,
      text: "Какая из следующих технологий чаще всего используется для реализации ИИ? Выберите один вариант.",
      options: [
        "Блокчейн-сети",
        "Нейронные сети",
        "Реляционные базы данных",
        "Веб-сервисы"
      ],
      correct: 1,
      expA: "Блокчейн используется для распределённых реестров, а не для реализации ИИ.",
      expB: "Верно. Нейронные сети являются основной технологией для построения систем ИИ.",
      expC: "Базы данных хранят данные, но не реализуют функциональность ИИ.",
      expD: "Веб-сервисы обеспечивают связь, а не возможности ИИ.",
      points: 1,
      chapter: "Введение в ИИ",
      difficulty: "K1"
    },
    {
      id: 3,
      text: "Какое из следующих утверждений правильно описывает различие между узким и общим ИИ? Выберите один вариант.",
      options: [
        "Узкий ИИ выполняет много задач, общий ИИ - одну задачу",
        "Узкий ИИ решает конкретные задачи, общий ИИ - любые задачи",
        "Узкий ИИ использует меньше данных, общий ИИ - больше данных",
        "Узкий ИИ работает быстрее, общий ИИ - медленнее"
      ],
      correct: 1,
      expA: "Это неверно - узкий ИИ специализирован на конкретных задачах, а не многозадачен.",
      expB: "Правильно. Узкий ИИ специализирован на определённых задачах, тогда как общий ИИ способен решать любые интеллектуальные задачи.",
      expC: "Объём используемых данных не является определяющим различием между этими типами ИИ.",
      expD: "Скорость обработки не является отличительным признаком между узким и общим ИИ.",
      points: 1,
      chapter: "Введение в ИИ",
      difficulty: "K2"
    },
    {
      id: 4,
      text: "Какой из перечисленных является популярным фреймворком для разработки ИИ? Выберите один вариант.",
      options: [
        "MySQL",
        "Apache Kafka",
        "TensorFlow",
        "Docker"
      ],
      correct: 2,
      expA: "MySQL - это система управления базами данных, а не фреймворк для ИИ.",
      expB: "Kafka предназначена для потоковой передачи данных, а не для разработки ИИ.",
      expC: "Верно. TensorFlow широко используется для разработки моделей машинного обучения.",
      expD: "Docker используется для контейнеризации, а не для разработки моделей ИИ.",
      points: 1,
      chapter: "Введение в ИИ",
      difficulty: "K1"
    },
    {
      id: 5,
      text: "Компания выбирает между внедрением узкого ИИ и общего ИИ. Какое утверждение наиболее точное? Выберите один вариант.",
      options: [
        "Общий ИИ подходит для экспериментальных исследований",
        "Узкий ИИ существует сегодня для решения конкретных задач",
        "Общий ИИ проще в разработке для начинающих команд",
        "Узкий ИИ требует больше ресурсов для обучения"
      ],
      correct: 1,
      expA: "Общий ИИ остаётся теоретической концепцией и недоступен даже для исследований.",
      expB: "Верно. Узкий ИИ успешно применяется сегодня для решения специализированных задач.",
      expC: "Общий ИИ был бы значительно сложнее в разработке, если бы существовал.",
      expD: "Требования к ресурсам зависят от конкретной задачи, а не от типа ИИ.",
      points: 1,
      chapter: "Введение в ИИ",
      difficulty: "K2"
    },
    {
      id: 6,
      text: "Какое утверждение о различиях между традиционными системами и системами ИИ является верным? Выберите один вариант.",
      options: [
        "Системы ИИ адаптируются к изменяющимся данным",
        "Системы ИИ способны обучаться на данных и выявлять закономерности",
        "Традиционные системы лучше обрабатывают неструктурированные данные",
        "Традиционные системы более эффективны в распознавании паттернов"
      ],
      correct: 1,
      expA: "Адаптивность важна, но не является главным отличием от традиционных систем.",
      expB: "Верно. Способность к обучению на данных - ключевое отличие систем ИИ от традиционных программных систем.",
      expC: "Системы ИИ превосходят традиционные в обработке неструктурированных данных.",
      expD: "Системы ИИ, как правило, значительно превосходят традиционные системы в распознавании паттернов.",
      points: 1,
      chapter: "Введение в ИИ",
      difficulty: "K2"
    },
    {
      id: 7,
      text: "Производственная компания внедряет ИИ для контроля качества. Какой подход к интеграции оптимален? Выберите один вариант.",
      options: [
        "Использовать ИИ как инструмент поддержки решений операторов",
        "Полностью автоматизировать процесс без человеческого контроля",
        "Применять ИИ только для архивирования результатов контроля",
        "Внедрить ИИ исключительно для отчётности руководству"
      ],
      correct: 0,
      expA: "Правильно. ИИ как вспомогательный инструмент усиливает экспертизу операторов и повышает точность контроля.",
      expB: "Полная автоматизация без человеческого надзора создаёт неприемлемые риски для качества продукции.",
      expC: "Использование ИИ только для архивирования не реализует его потенциал в анализе и предсказании.",
      expD: "Ограничение ИИ только отчётностью игнорирует возможности улучшения самого процесса контроля.",
      points: 2,
      chapter: "Введение в ИИ",
      difficulty: "K3"
    },
    {
      id: 8,
      text: "Розничная сеть рассматривает внедрение ИИ для персонализации. Какой фактор критически важен на этапе планирования? Выберите один вариант.",
      options: [
        "Скорость обработки транзакций",
        "Выбор облачного провайдера",
        "Качество данных о поведении клиентов",
        "Количество точек продаж в сети"
      ],
      correct: 2,
      expA: "Скорость транзакций важна, но качественные данные — основа успешной персонализации.",
      expB: "Выбор провайдера — техническое решение, не влияющее на качество персонализации.",
      expC: "Верно. Без качественных данных о клиентах ИИ не сможет создать эффективную персонализацию.",
      expD: "Количество точек влияет на масштаб, но не на принципиальную возможность персонализации.",
      points: 2,
      chapter: "Введение в ИИ",
      difficulty: "K3"
    },
    {
      id: 9,
      text: "Логистическая компания внедряет ИИ для оптимизации маршрутов. Какой показатель лучше всего измеряет успех? Выберите один вариант.",
      options: [
        "Количество используемых алгоритмов",
        "Скорость генерации отчётов",
        "Снижение времени доставки и топливных затрат",
        "Число обученных сотрудников"
      ],
      correct: 2,
      expA: "Количество алгоритмов не отражает качество оптимизации маршрутов.",
      expB: "Скорость отчётов важна для управления, но не измеряет эффективность оптимизации.",
      expC: "Правильно. Сокращение времени доставки и затрат напрямую демонстрирует ценность ИИ-оптимизации.",
      expD: "Обучение персонала поддерживает внедрение, но не измеряет результативность системы.",
      points: 2,
      chapter: "Введение в ИИ",
      difficulty: "K3"
    },
    {
      id: 10,
      text: "Страховая компания использует ИИ для оценки рисков. Какая характеристика наиболее важна для доверия клиентов? Выберите один вариант.",
      options: [
        "Высокая скорость обработки заявок",
        "Низкая стоимость внедрения системы",
        "Прозрачность принятия решений ИИ",
        "Совместимость с существующим ПО"
      ],
      correct: 2,
      expA: "Скорость важна для удобства, но не создаёт доверия к справедливости оценки рисков.",
      expB: "Стоимость внедрения не влияет на восприятие клиентами справедливости решений.",
      expC: "Верно. Возможность понять, как ИИ принял решение, критически важна для доверия в страховании.",
      expD: "Техническая совместимость — внутренний вопрос, не связанный с доверием клиентов.",
      points: 2,
      chapter: "Введение в ИИ",
      difficulty: "K3"
    },
    {
      id: 11,
      text: "Технологическая компания оценивает зрелость своих ИИ-проектов. Какой критерий указывает на высокую зрелость? Выберите один вариант.",
      options: [
        "Использование самых современных алгоритмов",
        "Большая команда специалистов по ИИ",
        "Интеграция ИИ в критически важные бизнес-процессы",
        "Наличие собственных вычислительных мощностей"
      ],
      correct: 2,
      expA: "Новейшие алгоритмы не гарантируют зрелости — важна устойчивая интеграция в бизнес.",
      expB: "Размер команды отражает ресурсы, а не зрелость использования ИИ в организации.",
      expC: "Правильно. Интеграция в критически важные процессы демонстрирует доверие и зрелость ИИ-решений.",
      expD: "Собственная инфраструктура — технический выбор, не связанный с зрелостью применения ИИ.",
      points: 2,
      chapter: "Введение в ИИ",
      difficulty: "K3"
    },
    {
      id: 12,
      text: "Банк разрабатывает стратегию ИИ с учётом регулятивных требований. Какой подход наиболее сбалансирован? Выберите один вариант.",
      options: [
        "Максимальное использование ИИ для всех процессов",
        "Внедрение ИИ только после полного изменения регулирования",
        "Поэтапное внедрение с постоянным мониторингом соответствия",
        "Ограничение ИИ только внутренними операциями"
      ],
      correct: 2,
      expA: "Максимальное использование игнорирует регулятивные ограничения и риски.",
      expB: "Ожидание полного изменения регулирования приводит к упущению возможностей.",
      expC: "Правильно. Поэтапный подход позволяет соблюдать требования при постепенном расширении применения ИИ.",
      expD: "Ограничение только внутренними операциями не реализует полный потенциал ИИ в банковском деле.",
      points: 2,
      chapter: "Введение в ИИ",
      difficulty: "K3"
    },
    {
      id: 13,
      text: "Образовательная организация внедряет ИИ для персонализированного обучения. Какой принцип должен быть приоритетным? Выберите один вариант.",
      options: [
        "Максимальная автоматизация образовательного процесса",
        "Сохранение роли преподавателя как наставника",
        "Стандартизация всех образовательных маршрутов",
        "Фокус на самых успешных учащихся"
      ],
      correct: 1,
      expA: "Максимальная автоматизация может лишить образование человеческого элемента и адаптивности.",
      expB: "Правильно. ИИ должен усиливать, а не заменять роль преподавателя в качестве наставника и мотиватора.",
      expC: "Стандартизация противоречит идее персонализированного обучения с помощью ИИ.",
      expD: "Фокус только на успешных учащихся противоречит принципам инклюзивного образования.",
      points: 3,
      chapter: "Введение в ИИ",
      difficulty: "K4"
    },
    {
      id: 14,
      text: "Медицинский центр интегрирует ИИ в диагностические процессы. Какой подход обеспечивает оптимальный баланс? Выберите один вариант.",
      options: [
        "Использовать ИИ как инструмент поддержки принятия врачебных решений",
        "Полностью заменить врачей-диагностов системами ИИ для повышения точности",
        "Применять только традиционные методы диагностики для безопасности пациентов",
        "Внедрять ИИ без предварительной клинической валидации для ускорения процесса"
      ],
      correct: 0,
      expA: "Правильно. ИИ как вспомогательный инструмент усиливает врачебную экспертизу и улучшает результаты лечения.",
      expB: "Полная замена врачей игнорирует необходимость человеческого опыта и эмпатии в медицине.",
      expC: "Отказ от ИИ лишает возможности повысить точность и скорость диагностики.",
      expD: "Внедрение без валидации создаёт неприемлемые риски для здоровья пациентов.",
      points: 3,
      chapter: "Введение в ИИ",
      difficulty: "K4"
    },
    {
      id: 15,
      text: "Промышленное предприятие внедряет ИИ в системы предиктивного обслуживания. Какая стратегия управления изменениями наиболее эффективна? Выберите один вариант.",
      options: [
        "Немедленная замена всех существующих процессов обслуживания",
        "Обучение персонала работе с ИИ-рекомендациями и постепенная интеграция",
        "Полная автоматизация без участия технических специалистов",
        "Внедрение только в наименее критичных системах предприятия"
      ],
      correct: 1,
      expA: "Немедленная замена создаёт чрезмерные риски и сопротивление персонала.",
      expB: "Правильно. Обучение персонала и постепенная интеграция обеспечивают успешное принятие технологии.",
      expC: "Полная автоматизация без участия специалистов игнорирует ценность человеческой экспертизы.",
      expD: "Ограничение некритичными системами не реализует потенциал предиктивного обслуживания.",
      points: 3,
      chapter: "Введение в ИИ",
      difficulty: "K4"
    },
    {
      id: 16,
      text: "Розничная сеть внедряет ИИ для управления запасами в условиях сезонного спроса. Какой подход к данным наиболее важен? Выберите один вариант.",
      options: [
        "Использование исторических данных за последние 5 лет с учётом сезонных паттернов",
        "Фокус только на самых популярных товарах для упрощения анализа",
        "Использование данных конкурентов для бенчмаркинга",
        "Ограничение анализом продаж только в пиковые периоды"
      ],
      correct: 0,
      expA: "Правильно. Исторические данные с сезонными паттернами позволяют ИИ точно прогнозировать спрос.",
      expB: "Фокус только на популярных товарах игнорирует полную картину управления запасами.",
      expC: "Данные конкурентов могут быть недоступны и не отражают специфику конкретной сети.",
      expD: "Анализ только пиковых периодов не учитывает полный цикл сезонных изменений.",
      points: 3,
      chapter: "Введение в ИИ",
      difficulty: "K4"
    },
    {
      id: 17,
      text: "Финансовая организация разрабатывает этическую политику использования ИИ. Какой принцип должен быть основополагающим? Выберите один вариант.",
      options: [
        "Максимизация прибыли от использования ИИ-решений",
        "Обеспечение справедливости и прозрачности ИИ-решений для всех клиентов",
        "Использование самых передовых технологий ИИ",
        "Минимизация человеческого участия в принятии решений"
      ],
      correct: 1,
      expA: "Максимизация прибыли без этических ограничений может привести к дискриминации клиентов.",
      expB: "Правильно. Справедливость и прозрачность — основа этичного использования ИИ в финансовых услугах.",
      expC: "Передовые технологии не гарантируют этичности их применения.",
      expD: "Минимизация человеческого участия может привести к потере контроля над этическими аспектами.",
      points: 3,
      chapter: "Введение в ИИ",
      difficulty: "K4"
    },
    {
      id: 18,
      text: "Транспортная компания разрабатывает долгосрочную стратегию ИИ с учётом эффекта ИИ. Какой подход обеспечит устойчивое преимущество? Выберите один вариант.",
      options: [
        "Внедрить базовый ИИ и остановить дальнейшее развитие",
        "Создать культуру непрерывного совершенствования ИИ-решений",
        "Ограничиться текущими возможностями ИИ",
        "Игнорировать изменения в ожиданиях клиентов"
      ],
      correct: 1,
      expA: "Остановка развития гарантирует отставание от конкурентов и ожиданий рынка.",
      expB: "Правильно. Культура постоянного улучшения позволяет опережать растущие ожидания, вызванные эффектом ИИ.",
      expC: "Ограничение текущими возможностями не учитывает будущие потребности в инновациях.",
      expD: "Игнорирование изменений в ожиданиях приводит к потере клиентов.",
      points: 3,
      chapter: "Введение в ИИ",
      difficulty: "K4"
    },
    {
      id: 19,
      text: "Автомобильная компания внедряет ИИ в системы безопасности. Какой подход к управлению сложностью наиболее эффективен? Выберите один вариант.",
      options: [
        "Одновременное внедрение всех функций ИИ",
        "Поэтапное внедрение с постепенным расширением функциональности",
        "Начало с наиболее сложных функций",
        "Развёртывание без предварительного тестирования"
      ],
      correct: 1,
      expA: "Одновременное внедрение создаёт чрезмерные риски и усложняет управление.",
      expB: "Правильно. Поэтапный подход позволяет контролировать риски и накапливать опыт.",
      expC: "Начало со сложных функций игнорирует необходимость создания надёжного фундамента.",
      expD: "Отсутствие тестирования в системах безопасности недопустимо и опасно.",
      points: 3,
      chapter: "Введение в ИИ",
      difficulty: "K4"
    },
    {
      id: 20,
      text: "Финансовая организация разрабатывает стратегию ИИ, балансируя инновации и управление рисками. Какой подход наиболее комплексный? Выберите один вариант.",
      options: [
        "Приоритет инноваций без учёта рисков",
        "Полный отказ от ИИ из-за потенциальных рисков",
        "Интеграция оценки рисков в процесс внедрения инноваций",
        "Использование только проверенных временем ИИ-технологий"
      ],
      correct: 2,
      expA: "Игнорирование рисков в финансовом секторе может привести к серьёзным последствиям.",
      expB: "Полный отказ от ИИ лишает конкурентных преимуществ и возможностей роста.",
      expC: "Правильно. Интегрированный подход обеспечивает инновационное развитие при контролируемых рисках.",
      expD: "Ограничение только проверенными технологиями может привести к упущению перспективных возможностей.",
      points: 3,
      chapter: "Введение в ИИ",
      difficulty: "K4"
    },
    {
        id: 21,
        text: "Какое утверждение лучше всего описывает адаптивность в системах на основе ИИ? Выберите один вариант.",
        options: [
          "Системы, способные изменять поведение на основе новых данных",
          "Системы, корректирующие параметры при изменении среды", 
          "Системы, настраивающие алгоритмы под конкретные задачи",
          "Системы, оптимизирующие производительность в реальном времени"
        ],
        correct: 0,
        expA: "Точно! Адаптивность означает способность ИИ-систем корректировать поведение при изменении входных паттернов или условий работы.",
        expB: "Коррекция параметров - аспект адаптивности, но адаптивность шире и включает изменение поведенческих стратегий.",
        expC: "Настройка под задачи - это кастомизация, адаптивность же происходит автоматически в ответ на новые данные.",
        expD: "Оптимизация производительности - следствие, а не определение адаптивности ИИ-систем.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 22,
        text: "Какая характеристика позволяет использовать системы ИИ в автономных приложениях? Выберите один вариант.",
        options: [
          "Способность принимать решения без вмешательства человека",
          "Возможность самостоятельного обучения на новых данных",
          "Умение адаптироваться к изменяющимся условиям среды",
          "Способность к самодиагностике и восстановлению после сбоев"
        ],
        correct: 0,
        expA: "Именно! Автономность означает способность системы работать и принимать решения самостоятельно, без постоянного человеческого контроля.",
        expB: "Самообучение поддерживает автономность, но ключевая характеристика - это независимость в принятии решений.",
        expC: "Адаптивность важна для автономных систем, но автономность конкретно означает независимость от человека.",
        expD: "Самовосстановление полезно, но автономность прежде всего означает самостоятельное принятие решений.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 23,
        text: "Какое утверждение об эволюции системы ИИ является правильным? Выберите один вариант.",
        options: [
          "Эволюция происходит только во время фазы обучения",
          "Эволюция требует полной замены системы",
          "Эволюция может происходить в процессе эксплуатации",
          "Эволюция невозможна в развернутых системах"
        ],
        correct: 2,
        expA: "Это неверно - многие системы ИИ продолжают обучаться и развиваться уже после развертывания.",
        expB: "Эволюция обычно происходит постепенно, через обновления и улучшения, а не через полную замену системы.",
        expC: "Правильно! Современные системы ИИ часто продолжают эволюционировать через дообучение, обновления и адаптацию прямо во время работы.",
        expD: "Это устаревший подход - многие современные системы специально проектируются для продолжения обучения после развертывания.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 24,
        text: "Какой тип смещения возникает, когда обучающие данные недостаточно представляют целевую популяцию? Выберите один вариант.",
        options: [
          "Смещение выборки",
          "Алгоритмическое смещение",
          "Смещение подтверждения",
          "Смещение измерения"
        ],
        correct: 0,
        expA: "Верно! Смещение выборки возникает, когда обучающие данные не отражают все разнообразие реальных пользователей или ситуаций.",
        expB: "Алгоритмическое смещение связано с тем, как модель обрабатывает данные, а не с репрезентативностью самих данных.",
        expC: "Смещение подтверждения - это когнитивное искажение, когда человек ищет информацию, подтверждающую его убеждения.",
        expD: "Смещение измерения связано со способом сбора или записи данных, а не с их репрезентативностью.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 25,
        text: "Какой этический принцип в первую очередь нарушается, когда система ИИ по-разному относится к различным группам людей? Выберите один вариант.",
        options: [
          "Прозрачность",
          "Конфиденциальность",
          "Справедливость",
          "Безопасность"
        ],
        correct: 2,
        expA: "Прозрачность важна для понимания решений системы, но неравное обращение - это вопрос другого принципа.",
        expB: "Конфиденциальность касается защиты персональных данных, а не равенства в обращении.",
        expC: "Именно так! Справедливость - это ключевой принцип, требующий равного и непредвзятого отношения ко всем группам пользователей.",
        expD: "Безопасность важна для защиты системы и данных, но не связана напрямую с этической справедливостью.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 26,
        text: "Что представляет собой эксплуатация функции вознаграждения (reward hacking) в системах ИИ? Выберите один вариант.",
        options: [
          "Оптимизация метрик без достижения истинных целей",
          "Нахождение непредусмотренных способов максимизировать вознаграждение",
          "Манипулирование обучающим процессом для получения преимуществ",
          "Изменение целевых функций для повышения производительности"
        ],
        correct: 1,
        expA: "Это близко, но reward hacking конкретно означает использование неожиданных лазеек в системе вознаграждения.",
        expB: "Точно! Системы ИИ иногда находят технически корректные, но нежелательные способы получить максимальное вознаграждение.",
        expC: "Манипулирование процессом - более широкое понятие, reward hacking специфически связан с функциями вознаграждения.",
        expD: "Изменение целевых функций - это модификация системы, а не эксплуатация существующих функций.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 27,
        text: "Что лучше всего характеризует объяснимость в системах ИИ? Выберите один вариант.",
        options: [
          "Способность системы документировать свои действия",
          "Возможность интерпретации внутренних процессов модели",
          "Способность предоставить понятные людям обоснования решений",
          "Умение системы обосновать свои рекомендации техническими терминами"
        ],
        correct: 2,
        expA: "Документирование действий полезно, но объяснимость требует понятности для людей, а не просто записи событий.",
        expB: "Интерпретируемость внутренних процессов - это более технический аспект, объяснимость должна быть понятна пользователям.",
        expC: "Правильно! Объяснимость означает, что ИИ может предоставить понятные человеку обоснования своих решений.",
        expD: "Технические термины могут затруднить понимание - объяснимость должна быть доступной для целевых пользователей.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 28,
        text: "Какая характеристика затрудняет использование систем на основе ИИ в приложениях, связанных с безопасностью? Выберите один вариант.",
        options: [
          "Высокая интерпретируемость решений",
          "Стабильное детерминированное поведение", 
          "Непредсказуемое недетерминированное поведение",
          "Прозрачность процессов принятия решений"
        ],
        correct: 2,
        expA: "Высокая интерпретируемость, наоборот, помогает в приложениях безопасности, делая систему более понятной.",
        expB: "Стабильное детерминированное поведение как раз желательно для критически важных систем безопасности.",
        expC: "Верно! Недетерминированность делает поведение ИИ непредсказуемым, что создает риски для систем безопасности.",
        expD: "Прозрачность процессов важна для систем безопасности и помогает, а не мешает их использованию.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K1"
      },
      {
        id: 29,
        text: "Что из перечисленного НЕ является типичной причиной смещения в системах ИИ? Выберите один вариант.",
        options: [
          "Техническая оптимизация производительности алгоритма",
          "Культурные предрассудки в исторических данных",
          "Демографически нерепрезентативные выборки",
          "Субъективная разметка данных экспертами"
        ],
        correct: 0,
        expA: "Правильно! Техническая оптимизация направлена на улучшение работы алгоритма и обычно не вводит дискриминационных смещений.",
        expB: "Культурные предрассудки в исторических данных - один из основных источников смещения в ИИ-системах.",
        expC: "Нерепрезентативные выборки - классическая причина смещения, когда некоторые группы недостаточно представлены.",
        expD: "Субъективность экспертов при разметке часто привносит человеческие предубеждения в обучающие данные.",
        points: 1,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K1"
      },
      {
        id: 30,
        text: "Компания разрабатывает систему ИИ для медицинской диагностики. Какой подход лучше всего обеспечит этическое внедрение? Выберите один вариант.",
        options: [
          "Максимизировать точность с учетом справедливости для всех групп",
          "Балансировать скорость диагностики с качеством объяснений",
          "Внедрить прозрачность с сохранением врачебного контроля",
          "Оптимизировать затраты при соблюдении регуляторных требований"
        ],
        correct: 2,
        expA: "Точность и справедливость важны, но в медицине критично сохранение роли врача в принятии решений.",
        expB: "Скорость и объяснимость полезны, но этическое внедрение требует более комплексного подхода с человеческим контролем.",
        expC: "Отлично! В медицине критически важно, чтобы врачи понимали логику ИИ и сохраняли контроль над решениями о лечении.",
        expD: "Оптимизация затрат не может быть приоритетом в медицинских системах, где на кону здоровье пациентов.",
        points: 2,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 31,
        text: "Что следует предпринять при обнаружении побочных эффектов в работающей системе ИИ? Выберите один вариант.",
        options: [
          "Немедленно отключить систему до полного исправления",
          "Постепенно снизить влияние побочных эффектов через мониторинг",
          "Игнорировать незначительные побочные эффекты ради общей пользы",
          "Документировать эффекты и продолжить нормальную работу"
        ],
        correct: 1,
        expA: "Полное отключение может быть излишним, если побочные эффекты не критичны и их можно контролировать.",
        expB: "Правильно! Постепенное снижение с мониторингом позволяет управлять рисками без полной остановки полезной системы.",
        expC: "Игнорирование побочных эффектов может привести к накоплению проблем и этическим нарушениям.",
        expD: "Простое документирование без действий по устранению неприемлемо для ответственного использования ИИ.",
        points: 2,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 32,
        text: "Банковская система ИИ показывает разную эффективность для клиентов разных возрастных групп. Какой тип тестирования следует провести в первую очередь? Выберите один вариант.",
        options: [
          "Функциональное тестирование алгоритма",
          "Нагрузочное тестирование системы",
          "Тестирование на смещение и справедливость",
          "Тестирование безопасности данных"
        ],
        correct: 2,
        expA: "Функциональное тестирование проверит работу алгоритма, но не выявит причины различий между группами.",
        expB: "Нагрузочное тестирование оценивает производительность, а не равенство обслуживания разных групп.",
        expC: "Именно! Различная эффективность для разных групп - явный признак потенциального смещения.",
        expD: "Тестирование безопасности важно, но данный сценарий указывает на проблему справедливости, а не безопасности.",
        points: 2,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 33,
        text: "Система ИИ для рекрутинга начинает отдавать предпочтение кандидатам определенного профиля. Какая характеристика качества нарушена в первую очередь? Выберите один вариант.",
        options: [
          "Производительность системы",
          "Безопасность обработки данных", 
          "Справедливость и отсутствие смещения",
          "Прозрачность принятия решений"
        ],
        correct: 2,
        expA: "Производительность может оставаться высокой даже при наличии смещения в решениях.",
        expB: "Безопасность данных не связана напрямую с предвзятостью в выборе кандидатов.",
        expC: "Правильно! Предпочтение определенного профиля указывает на смещение и нарушение справедливости.",
        expD: "Прозрачность важна для понимания причин предпочтений, но основная проблема - в самой несправедливости.",
        points: 2,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 34,
        text: "Какой фактор наиболее важен при оценке эволюции системы ИИ в производственной среде? Выберите один вариант.",
        options: [
          "Мониторинг изменений производительности и управление дрейфом модели",
          "Снижение вычислительных затрат на обслуживание системы",
          "Увеличение скорости обработки входящих запросов",
          "Минимизация требований к хранению данных"
        ],
        correct: 0,
        expA: "Правильно! Отслеживание деградации производительности и контроль дрейфа критичны для поддержания качества эволюционирующей системы.",
        expB: "Снижение затрат полезно, но не является ключевым фактором при управлении эволюцией системы ИИ.",
        expC: "Увеличение скорости важно для пользователей, но главное при эволюции - контролировать изменения в качестве решений.",
        expD: "Оптимизация хранения - второстепенная задача по сравнению с контролем качества работы системы.",
        points: 2,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 35,
        text: "Медицинская система ИИ выдает рекомендации по лечению, но не может объяснить причины выбора конкретных методов. Какую характеристику необходимо улучшить? Выберите один вариант.",
        options: [
          "Скорость генерации рекомендаций",
          "Прозрачность и интерпретируемость решений",
          "Эффективность использования вычислительных ресурсов",
          "Удобство пользовательского интерфейса"
        ],
        correct: 1,
        expA: "Скорость не проблема - система работает, но врачам необходимо понимать логику её решений.",
        expB: "Точно! В медицине критически важно понимать, почему ИИ рекомендует именно такое лечение.",
        expC: "Эффективность ресурсов не связана с проблемой понимания логики принятия решений.",
        expD: "Улучшение интерфейса может помочь, но корневая проблема - в непрозрачности самого процесса принятия решений.",
        points: 2,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 36,
        text: "Финансовая система ИИ должна адаптироваться к изменениям рынка, соблюдая нормативные требования. Система показывает высокую точность, но регуляторы обеспокоены потенциальным системным риском от широкого использования похожих алгоритмов. Какая комплексная стратегия управления рисками будет наиболее эффективной? Выберите один вариант.",
        options: [
          "Приоритизация индивидуальной точности над системными рисками",
          "Внедрение алгоритмического разнообразия с координированным мониторингом рисков",
          "Ограничение адаптивности для минимизации непредсказуемости",
          "Делегирование управления рисками регуляторным органам"
        ],
        correct: 1,
        expA: "Фокус только на индивидуальной точности игнорирует системные риски, которые могут возникнуть при массовом использовании похожих алгоритмов.",
        expB: "Правильно! Алгоритмическое разнообразие снижает системные риски, а координированный мониторинг обеспечивает соблюдение нормативных требований.",
        expC: "Ограничение адаптивности снижает эффективность системы и не решает проблему системных рисков.",
        expD: "Управление рисками - ответственность самой организации, регуляторы только контролируют соблюдение требований.",
        points: 3,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 37,
        text: "Компания внедряет автономную систему ИИ в критически важные бизнес-процессы. Какой баланс между автономностью и прозрачностью обеспечит оптимальное управление рисками? Выберите один вариант.",
        options: [
          "Максимальная автономность с периодической отчетностью",
          "Минимальная автономность с полным человеческим контролем",
          "Высокая автономность с объяснимостью ключевых решений",
          "Отложенная прозрачность после полного внедрения системы"
        ],
        correct: 2,
        expA: "Периодическая отчетность может быть недостаточной для критически важных процессов, где нужен контроль ключевых решений.",
        expB: "Минимальная автономность сводит на нет преимущества использования ИИ в бизнес-процессах.",
        expC: "Идеально! Система работает самостоятельно в рутинных случаях, но может объяснить критически важные решения.",
        expD: "Прозрачность необходимо закладывать с самого начала - добавить её после внедрения будет намного сложнее.",
        points: 3,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 38,
        text: "Международная корпорация разрабатывает глобальную ИИ-платформу, которая должна соответствовать различным культурным и регуляторным требованиям. Какая стратегия обеспечения справедливости будет наиболее эффективной? Выберите один вариант.",
        options: [
          "Единые глобальные стандарты справедливости для всех регионов",
          "Локализованные подходы к справедливости с общими принципами",
          "Минимальные требования к справедливости для упрощения внедрения",
          "Отсрочка решения вопросов справедливости до завершения технической разработки"
        ],
        correct: 1,
        expA: "Единые стандарты могут не учитывать культурные различия и специфические потребности разных регионов.",
        expB: "Правильно! Локализованные подходы с общими этическими принципами позволяют учесть региональные особенности при сохранении основных ценностей.",
        expC: "Минимальные требования к справедливости неприемлемы для корпоративной социальной ответственности.",
        expD: "Вопросы справедливости должны решаться с самого начала проектирования, а не откладываться на потом.",
        points: 3,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 39,
        text: "Какая стратегия лучше всего предотвращает эксплуатацию функции вознаграждения в сложных системах ИИ? Выберите один вариант.",
        options: [
          "Использование только простых и понятных функций вознаграждения",
          "Полный отказ от системы вознаграждений в пользу детерминированных алгоритмов",
          "Внедрение функций вознаграждения только после полного развертывания системы",
          "Разработка многоуровневых функций с встроенными ограничениями и защитными механизмами"
        ],
        correct: 3,
        expA: "Простые функции тоже могут быть эксплуатированы, и они часто не могут учесть все важные аспекты сложных задач.",
        expB: "Без функций вознаграждения невозможно эффективно направлять поведение ИИ к достижению желаемых целей.",
        expC: "Функции вознаграждения должны быть тщательно спроектированы и протестированы еще до развертывания системы.",
        expD: "Правильно! Многоуровневые функции с защитными механизмами и ограничениями минимизируют возможности для reward hacking.",
        points: 3,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 40,
        text: "Медицинская система ИИ проходит регуляторное одобрение и должна демонстрировать адаптивность, этичность и объяснимость при соблюдении критических требований безопасности. Регуляторы требуют доказательств устойчивости системы к различным сценариям. Какая стратегия тестирования обеспечит наиболее убедительную валидацию для регуляторного одобрения? Выберите один вариант.",
        options: [
          "Последовательное тестирование каждой характеристики с формальной документацией результатов",
          "Приоритизация безопасности над остальными характеристиками качества в процессе тестирования",
          "Интегрированное стресс-тестирование всех характеристик в критических медицинских сценариях",
          "Поэтапная валидация с постепенным увеличением сложности тестовых сценариев"
        ],
        correct: 2,
        expA: "Изолированное тестирование не покажет регуляторам, как характеристики взаимодействуют в реальных критических ситуациях.",
        expB: "В медицине все характеристики критичны - нельзя принести в жертву этичность или объяснимость ради безопасности.",
        expC: "Отлично! Интегрированное стресс-тестирование продемонстрирует регуляторам, как все характеристики работают вместе в самых сложных медицинских сценариях.",
        expD: "Поэтапная валидация полезна, но регуляторы хотят видеть доказательства работы в критических ситуациях с самого начала.",
        points: 3,
        chapter: "Характеристики качества для систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 41,
        text: "Какое из следующих утверждений о контролируемом обучении является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Использует неразмеченные данные для изучения скрытых структур",
          "Использует размеченные данные для прогнозирования результатов", 
          "Изучает поведение через взаимодействие с окружающей средой",
          "Применяет кластеризацию для группировки похожих объектов"
        ],
        correct: 1,
        expA: "Неправильно - это описывает неконтролируемое обучение, которое работает без размеченных данных.",
        expB: "Точно! Контролируемое обучение использует размеченные данные для изучения соответствий вход-выход.",
        expC: "Неправильно - это описывает обучение с подкреплением, основанное на системе вознаграждений.",
        expD: "Неправильно - это описывает задачу кластеризации, относящуюся к неконтролируемому обучению.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K2"
      },
      {
        id: 42,
        text: "Какое из следующих утверждений является ЛУЧШИМ примером классификации? Выберите ОДИН вариант.",
        options: [
          "Прогнозирование температуры завтра",
          "Определение является ли письмо спамом",
          "Поиск групп похожих клиентов",
          "Создание SQL-запросов к базе данных"
        ],
        correct: 1,
        expA: "Неправильно - это регрессия, прогнозирующая непрерывные значения.",
        expB: "Идеально! Классификация относит элементы к заранее определенным дискретным категориям как спам/не спам.",
        expC: "Неправильно - это кластеризация, группирующая похожие элементы без заранее заданных категорий.",
        expD: "Неправильно - это задача из области баз данных, не относящаяся к машинному обучению.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K1"
      },
      {
        id: 43,
        text: "Какое из следующих утверждений является ЛУЧШИМ примером регрессии? Выберите ОДИН вариант.",
        options: [
          "Распознавание объектов на изображении",
          "Прогнозирование цены дома по характеристикам",
          "Настройка веб-сервера Apache",
          "Сегментация рынка на группы потребителей"
        ],
        correct: 1,
        expA: "Неправильно - это классификация, относящая объекты к предопределенным категориям.",
        expB: "Именно! Регрессия прогнозирует непрерывные числовые значения, такие как цены.",
        expC: "Неправильно - это системное администрирование, не связанное с машинным обучением.",
        expD: "Неправильно - это кластеризация, группирующая похожие элементы без предсказания значений.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K1"
      },
      {
        id: 44,
        text: "Какое из следующих утверждений о кластеризации является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Требует заранее размеченных данных для обучения",
          "Использует алгоритмы контролируемого обучения для группировки",
          "Предсказывает непрерывные числовые значения для объектов",
          "Автоматически группирует похожие объекты без размеченных данных"
        ],
        correct: 3,
        expA: "Неправильно - кластеризация работает с неразмеченными данными, это неконтролируемое обучение.",
        expB: "Неправильно - кластеризация использует алгоритмы неконтролируемого обучения.",
        expC: "Неправильно - предсказание непрерывных значений это задача регрессии, а не кластеризации.",
        expD: "Точно! Кластеризация - это неконтролируемое обучение, группирующее похожие объекты без размеченных данных.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K2",
        improvement: "УЛУЧШЕНО K2: Все дистракторы из AI/ML области с тонкими различиями между типами задач"
      },
      {
        id: 45,
        text: "Какое из следующих утверждений о обучении с подкреплением является НАИБОЛЕЕ точным? Выберите ОДИН вариант.",
        options: [
          "Работает только с текстовыми данными большого объема",
          "Требует полностью размеченных обучающих наборов данных", 
          "Использует алгоритмы глубокого обучения исключительно для NLP",
          "Изучает поведение через взаимодействие и систему вознаграждений"
        ],
        correct: 3,
        expA: "Неправильно - обучение с подкреплением может работать с различными типами данных и сред.",
        expB: "Неправильно - это характеристика контролируемого обучения, а не обучения с подкреплением.", 
        expC: "Неправильно - это описание применения глубокого обучения в NLP, не обучения с подкреплением.",
        expD: "Правильно! Обучение с подкреплением основано на взаимодействии агента со средой через систему вознаграждений.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор", 
        difficulty: "K2",
        improvement: "УЛУЧШЕНО K2: Все дистракторы из AI/ML с четким различием концепций машинного обучения"
      },
      {
        id: 46,
        text: "Какая из следующих характеристик ЛУЧШЕ всего отличает неконтролируемое обучение? Выберите ОДИН вариант.",
        options: [
          "Требует больших вычислительных ресурсов для обучения нейросетей",
          "Использует функции потерь для оптимизации весов модели", 
          "Обнаруживает скрытые паттерны в данных без размеченных примеров",
          "Применяет методы градиентного спуска для минимизации ошибки"
        ],
        correct: 2,
        expA: "Неправильно - высокие вычислительные требования характерны для многих типов машинного обучения.",
        expB: "Неправильно - функции потерь используются в контролируемом обучении для оптимизации по известным целям.",
        expC: "Точно! Неконтролируемое обучение находит скрытые структуры и паттерны без использования размеченных данных.",
        expD: "Неправильно - градиентный спуск это общий метод оптимизации, используемый в разных типах обучения.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K2", 
        improvement: "УЛУЧШЕНО K2: Все дистракторы из AI/ML области с техническими нюансами обучения"
      },
      {
        id: 47,
        text: "Какое из следующих утверждений о трансферном обучении является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Переносит знания из предобученной модели для новой задачи",
          "Требует обучения модели полностью с нуля каждый раз",
          "Работает только с алгоритмами линейной регрессии", 
          "Использует исключительно методы случайного леса"
        ],
        correct: 0,
        expA: "Отлично! Трансферное обучение использует предобученные модели и адаптирует их для новых задач.",
        expB: "Неправильно - это противоречит основной идее трансферного обучения, которое использует предобученные модели.",
        expC: "Неправильно - трансферное обучение чаще применяется с нейронными сетями, а не только линейной регрессией.",
        expD: "Неправильно - случайный лес не является основным алгоритмом для трансферного обучения.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K2",
        improvement: "УЛУЧШЕНО K2: Все дистракторы из AI/ML с ясными различиями в подходах к обучению"
      },
      {
        id: 48,
        text: "Какое из следующих утверждений о онлайн-обучении является НАИБОЛЕЕ точным? Выберите ОДИН вариант.",
        options: [
          "Модель обновляется последовательно по мере поступления новых данных",
          "Требует полной переобучение модели при каждом новом примере",
          "Работает исключительно с большими пакетами данных", 
          "Использует только статические наборы данных для обучения"
        ],
        correct: 0,
        expA: "Правильно! Онлайн-обучение инкрементально обновляет модель по мере поступления новых данных.",
        expB: "Неправильно - полная переобучение противоречит концепции инкрементального онлайн-обучения.",
        expC: "Неправильно - онлайн-обучение обрабатывает данные по частям, а не большими пакетами.",
        expD: "Неправильно - статические наборы данных характерны для офлайн-обучения, а не онлайн.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K2"
      },
      {
        id: 49,
        text: "Какое из следующих утверждений о дрейфе данных является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Происходит только при использовании нейронных сетей глубокого обучения",
          "Влияет исключительно на алгоритмы неконтролируемого обучения",
          "Может снижать точность модели при изменении распределения данных",
          "Решается только увеличением размера обучающего набора данных"
        ],
        correct: 2,
        expA: "Неправильно - дрейф данных может затрагивать любые типы моделей машинного обучения, не только глубокие сети.",
        expB: "Неправильно - дрейф данных влияет как на контролируемое, так и на неконтролируемое обучение.",
        expC: "Точно! Дрейф данных происходит при изменении распределения данных и может значительно снизить производительность модели.",
        expD: "Неправильно - увеличение размера данных не решает проблему дрейфа, нужны специальные методы адаптации.",
        points: 1,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K2"
      },
      {
        id: 50,
        text: "Компания разрабатывает систему рекомендаций для e-commerce. Какой подход к машинному обучению будет НАИБОЛЕЕ подходящим? Выберите ОДИН вариант.",
        options: [
          "Использовать только кластеризацию пользователей по демографии",
          "Комбинировать коллаборативную и контентную фильтрацию",
          "Применить исключительно методы случайного выбора товаров",
          "Ограничиться анализом популярности товаров"
        ],
        correct: 1,
        expA: "Недостаточно - только демографическая кластеризация упускает индивидуальные предпочтения и поведение.",
        expB: "Отлично! Гибридный подход сочетает преимущества анализа пользовательского поведения и характеристик товаров.",
        expC: "Неэффективно - случайный выбор не использует данные о предпочтениях пользователей.",
        expD: "Слишком простой - анализ только популярности не учитывает индивидуальные потребности пользователей.",
        points: 2,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K3"
      },
      {
        id: 51,
        text: "При анализе производительности модели классификации обнаружено переобучение на обучающих данных. Какая стратегия будет НАИБОЛЕЕ эффективной? Выберите ОДИН вариант.",
        options: [
          "Увеличить количество эпох обучения для лучшей сходимости",
          "Применить регуляризацию и упростить архитектуру модели",
          "Уменьшить размер валидационного набора данных",
          "Повысить скорость обучения для ускорения конвергенции"
        ],
        correct: 1,
        expA: "Неправильно - больше эпох обучения усугубит переобучение на тренировочных данных.",
        expB: "Правильно! Регуляризация и упрощение модели это классические методы борьбы с переобучением.",
        expC: "Неправильно - уменьшение валидационного набора ухудшит оценку реальной производительности модели.",
        expD: "Неправильно - высокая скорость обучения может привести к нестабильности и не решает переобучение.",
        points: 2,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K3"
      },
      {
        id: 52,
        text: "Команда ML-инженеров выбирает между ансамблевыми методами для задачи прогнозирования. Какое утверждение о ансамблях является НАИБОЛЕЕ точным? Выберите ОДИН вариант.",
        options: [
          "Всегда требуют одинаковые алгоритмы базовых моделей",
          "Эффективны только при большом количестве признаков в данных",
          "Снижают дисперсию и повышают устойчивость прогнозов",
          "Работают исключительно с проблемами бинарной классификации"
        ],
        correct: 2,
        expA: "Неправильно - ансамбли часто используют разнообразные алгоритмы для улучшения производительности.",
        expB: "Неправильно - ансамбли эффективны независимо от количества признаков.",
        expC: "Точно! Ансамблевые методы объединяют несколько моделей для снижения дисперсии и повышения надежности.",
        expD: "Неправильно - ансамбли применимы к различным типам задач машинного обучения.",
        points: 2,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K3"
      },
      {
        id: 53,
        text: "При создании системы обнаружения аномалий для финансовых транзакций, какой фактор является КРИТИЧЕСКИМ? Выберите ОДИН вариант.",
        options: [
          "Максимизация чувствительности даже за счет большого числа ложных тревог",
          "Использование только исторических данных без учета новых паттернов",
          "Фокусирование исключительно на минимизации времени обработки транзакций",
          "Балансирование между обнаружением аномалий и минимизацией ложных срабатываний"
        ],
        correct: 3,
        expA: "Неоптимально - чрезмерное количество ложных тревог приведет к блокировке легальных транзакций.",
        expB: "Опасно - игнорирование новых паттернов мошенничества сделает систему уязвимой.",
        expC: "Недостаточно - скорость важна, но не может быть единственным критерием для финансовой безопасности.",
        expD: "Правильно! Баланс между чувствительностью и специфичностью критичен для эффективной системы обнаружения.",
        points: 2,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K3"
      },
      {
        id: 54,
        text: "При оценке применимости модели машинного обучения в production, какой аспект требует ПЕРВООЧЕРЕДНОГО внимания? Выберите ОДИН вариант.",
        options: [
          "Исключительно точность модели на тестовых данных",
          "Только вычислительная эффективность и скорость инференса",
          "Исключительно интерпретируемость модели для бизнес-пользователей",
          "Комплексная оценка производительности, устойчивости и эксплуатационных требований"
        ],
        correct: 3,
        expA: "Недостаточно - высокая точность на тестовых данных не гарантирует успех в реальных условиях.",
        expB: "Неполно - производительность важна, но без учета качества модели может быть бесполезна.",
        expC: "Ограничено - интерпретируемость важна, но не единственный критерий для production-готовности.",
        expD: "Верно! Production-развертывание требует всесторонней оценки множества факторов для надежной работы.",
        points: 2,
        chapter: "Машинное обучение (ML) - Обзор", 
        difficulty: "K3"
      },
      {
        id: 55,
        text: "При выборе модели между смещением и дисперсией, какая стратегия оптимизации является НАИБОЛЕЕ эффективной? Выберите ОДИН вариант.",
        options: [
          "Найти баланс, минимизирующий общую ошибку модели",
          "Всегда минимизировать смещение независимо от дисперсии",
          "Фокусироваться исключительно на снижении дисперсии",
          "Игнорировать компромисс и максимизировать сложность модели"
        ],
        correct: 0,
        expA: "Отлично! Компромисс смещение-дисперсия требует балансирования для минимизации общей ошибки.",
        expB: "Неправильно - чрезмерное снижение смещения может привести к высокой дисперсии и переобучению.",
        expC: "Неправильно - фокус только на дисперсии может привести к высокому смещению и недообучению.",
        expD: "Неправильно - игнорирование компромисса и максимизация сложности обычно ведет к переобучению.",
        points: 2,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K3"
      },
      {
        id: 56,
        text: "Компания внедряет ML-систему для автоматизации найма сотрудников. Какие этические соображения требуют ПЕРВООЧЕРЕДНОГО внимания? Выберите ОДИН вариант.",
        options: [
          "Обеспечение справедливости и предотвращение дискриминации кандидатов",
          "Максимизация скорости обработки резюме без учета качества отбора",
          "Фокус исключительно на минимизации затрат на персонал HR",
          "Приоритет автоматизации над человеческим контролем процесса"
        ],
        correct: 0,
        expA: "Правильно! Справедливость и предотвращение алгоритмической дискриминации критически важны в системах найма.",
        expB: "Неэтично - скорость не должна превалировать над справедливым и качественным отбором кандидатов.",
        expC: "Недальновидно - экономия на качестве найма может привести к долгосрочным проблемам с персоналом.",
        expD: "Опасно - полная автоматизация без человеческого надзора может усилить алгоритмические предвзятости.",
        points: 3,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K4"
      },
      {
        id: 57,
        text: "При разработке критической медицинской диагностической системы ИИ, какой подход к валидации модели является НАИБОЛЕЕ подходящим? Выберите ОДИН вариант.",
        options: [
          "Многоуровневая валидация с независимыми клиническими испытаниями",
          "Простое разделение данных на обучающие и тестовые выборки",
          "Валидация исключительно на синтетических медицинских данных",
          "Кросс-валидация только на данных одной медицинской организации"
        ],
        correct: 0,
        expA: "Правильно! Критические медицинские системы требуют строгой многоуровневой валидации с клиническими испытаниями.",
        expB: "Недостаточно - простое разделение данных не обеспечивает необходимый уровень валидации для медицины.",
        expC: "Рискованно - синтетические данные не могут полностью заменить реальные клинические наблюдения.",
        expD: "Ограничено - данные одной организации могут не отражать разнообразие пациентов и условий.",
        points: 3,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K4"
      },
      {
        id: 58,
        text: "При обнаружении катастрофического забывания в модели непрерывного обучения, какая стратегия митигации является НАИБОЛЕЕ эффективной? Выберите ОДИН вариант.",
        options: [
          "Комплексный подход с эластичной консолидацией весов и буфером воспроизведения",
          "Простое увеличение размера модели без дополнительных техник",
          "Полная переобучение модели с нуля при каждой новой задаче",
          "Фиксация всех весов модели после первоначального обучения"
        ],
        correct: 0,
        expA: "Отлично! Сочетание нескольких техник обеспечивает наиболее эффективную защиту от катастрофического забывания.",
        expB: "Неэффективно - простое увеличение размера не решает проблему переписывания старых знаний.",
        expC: "Неэкономично - переобучение с нуля исключает преимущества непрерывного обучения.",
        expD: "Контрпродуктивно - полная фиксация весов препятствует изучению новых задач.",
        points: 3,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K4"
      },
      {
        id: 59,
        text: "При проектировании федеративного обучения для конфиденциальных данных, какая архитектура обеспечивает ОПТИМАЛЬНЫЙ баланс между конфиденциальностью и производительностью? Выберите ОДИН вариант.",
        options: [
          "Дифференциальная приватность с адаптивной агрегацией и гомоморфным шифрованием",
          "Простое усреднение весов без дополнительных мер безопасности",
          "Полная централизация всех данных для лучшего качества модели", 
          "Изоляция всех участников без обмена любой информацией"
        ],
        correct: 0,
        expA: "Превосходно! Этот подход сочетает сильную защиту конфиденциальности с эффективным обучением модели.",
        expB: "Небезопасно - простое усреднение может раскрывать информацию о частных данных участников.",
        expC: "Противоречит принципам - централизация данных нарушает основную цель федеративного обучения.",
        expD: "Неэффективно - полная изоляция делает невозможным совместное обучение модели.",
        points: 3,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K4"
      },
      {
        id: 60,
        text: "Команда обнаружила сильное переобучение в глубокой нейронной сети для компьютерного зрения. Какой подход является ЛУЧШИМ? Выберите ОДИН вариант.",
        options: [
          "Увеличить сложность модели дальше",
          "Использовать более сложные алгоритмы",
          "Комбинировать регуляризацию, dropout, и аугментацию данных",
          "Уменьшить размер обучающих данных"
        ],
        correct: 2,
        expA: "Неправильно - увеличение сложности усугубит проблему переобучения.",
        expB: "Неэффективно - более сложные алгоритмы скорее усилят переобучение.",
        expC: "Идеально! Комбинация методов регуляризации это классический и эффективный подход против переобучения.",
        expD: "Контрпродуктивно - меньше данных обычно ухудшает переобучение.",
        points: 3,
        chapter: "Машинное обучение (ML) - Обзор",
        difficulty: "K4"
      },
      {
        id: 61,
        text: "Что из перечисленного ЛУЧШЕ ВСЕГО описывает понятие «метка» в контексте машинного обучения?",
        options: [
          "Правильный ответ для обучающих данных",
          "Идентификатор версии набора данных",
          "Временная отметка обработки данных", 
          "Категория типа нейронной сети"
        ],
        correct: 0,
        expA: "Отлично! Метка — это именно правильный ответ или целевое значение, которое модель должна научиться предсказывать.",
        expB: "Версионирование важно, но идентификаторы версий — это не то, что называют метками в ML.",
        expC: "Временные отметки полезны для отслеживания, но это не связано с концепцией меток.",
        expD: "Категории сетей важны для понимания архитектуры, но метки относятся к данным, а не к типам моделей.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K1"
      },
      {
        id: 62,
        text: "Какой метод предобработки данных больше всего подходит для работы с отсутствующими значениями в числовых признаках?",
        options: [
          "Удаление всех строк с пропусками",
          "Замена нулями во всех случаях",
          "Заполнение средним или медианным значением",
          "Преобразование в категориальные переменные"
        ],
        correct: 2,
        expA: "Удаление может привести к значительной потере данных, особенно если пропусков много.",
        expB: "Нули могут исказить распределение и не всегда логически обоснованы.",
        expC: "Правильно! Среднее или медиана сохраняют статистические свойства распределения и минимизируют искажения.",
        expD: "Преобразование числовых данных в категории приводит к потере важной количественной информации.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K1"
      },
      {
        id: 63,
        text: "Компания TechVision обнаружила, что их модель распознавания лиц работает отлично на тестовых данных, но плохо на реальных пользователях. Какая проблема наиболее вероятна?",
        options: [
          "Недостаточная вычислительная мощность при развертывании",
          "Смещение в обучающем наборе данных",
          "Переобучение модели на тестовых данных",
          "Неправильная настройка гиперпараметров модели"
        ],
        correct: 1,
        expA: "Вычислительная мощность влияет на скорость, но не объясняет разницу в точности между тестом и реальностью.",
        expB: "Точно! Смещение в данных означает, что обучающая выборка не представляет разнообразие реальных пользователей.",
        expC: "Переобучение обычно проявляется как хорошая производительность на обучающих, но не на тестовых данных.",
        expD: "Неправильные гиперпараметры повлияли бы на производительность и на тестовых данных тоже.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K2"
      },
      {
        id: 64,
        text: "Что из перечисленного дает ЛУЧШИЙ пример структурированных данных?",
        options: [
          "Цифровые изображения с пиксельными значениями",
          "Таблицы клиентской базы данных",
          "CSV-файлы с отсутствующими значениями",
          "XML-документы с фиксированной схемой"
        ],
        correct: 1,
        expA: "Изображения - это неструктурированные данные с пиксельными массивами.",
        expB: "Правильно! Таблицы базы данных имеют четкую структуру строк и столбцов.",
        expC: "CSV могут быть структурированными, но пропуски нарушают эту структуру.",
        expD: "XML может быть структурированным, но гибкость схемы делает его полуструктурированным.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K2"
      },
      {
        id: 65,
        text: "Какой из методов лучше всего подходит для обнаружения выбросов в наборе данных?",
        options: [
          "Линейная регрессия с регуляризацией",
          "Кластеризация методом k-средних",
          "Анализ главных компонент",
          "Статистический анализ межквартильных размахов"
        ],
        correct: 3,
        expA: "Линейная регрессия предназначена для предсказания, а не обнаружения выбросов.",
        expB: "K-средние может группировать данные, но не специализируется на выбросах.",
        expC: "PCA снижает размерность, но не является основным методом детекции выбросов.",
        expD: "Правильно! IQR-анализ статистически определяет значения, значительно отклоняющиеся от нормы.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K2"
      },
      {
        id: 66,
        text: "Какой подход НАИБОЛЕЕ эффективен для работы с несбалансированными классами в задачах классификации?",
        options: [
          "Увеличение размера обучающей выборки",
          "Техники передискретизации меньшинства",
          "Использование только точности как метрики",
          "Применение простых линейных моделей"
        ],
        correct: 1,
        expA: "Простое увеличение размера может сохранить дисбаланс классов.",
        expB: "Точно! SMOTE и подобные техники создают синтетические примеры недопредставленного класса.",
        expC: "Точность вводит в заблуждение при несбалансированных данных - нужны F1-мера, precision, recall.",
        expD: "Сложность модели не решает проблему дисбаланса классов напрямую.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K2"
      },
      {
        id: 67,
        text: "Что является основной целью нормализации признаков в машинном обучении?",
        options: [
          "Уменьшение количества признаков в модели",
          "Ускорение времени обучения алгоритмов",
          "Приведение признаков к одинаковому масштабу",
          "Автоматическое улучшение точности предсказаний"
        ],
        correct: 2,
        expA: "Снижение размерности - это отдельная задача, не связанная с нормализацией.",
        expB: "Ускорение может быть побочным эффектом, но не основной целью нормализации.",
        expC: "Правильно! Нормализация устраняет влияние разных масштабов признаков на обучение модели.",
        expD: "Нормализация не гарантирует автоматического улучшения точности - это зависит от данных и алгоритма.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K2"
      },
      {
        id: 68,
        text: "Какой тип валидации лучше всего подходит для временных рядов данных?",
        options: [
          "Случайная кросс-валидация",
          "Стратифицированная кросс-валидация",
          "К-блочная кросс-валидация",
          "Валидация с временным разбиением"
        ],
        correct: 3,
        expA: "Случайное разделение нарушает временную структуру данных.",
        expB: "Стратификация полезна для классификации, но не учитывает временную последовательность.",
        expC: "К-блочная валидация может перемешать временную структуру.",
        expD: "Именно! Временное разбиение сохраняет хронологический порядок, что критично для временных рядов.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K2"
      },
      {
        id: 69,
        text: "Что из перечисленного является основной целью этапа извлечения данных в конвейере машинного обучения?",
        options: [
          "Проверка качества и целостности исходных данных",
          "Получение данных из различных источников для анализа",
          "Предварительная обработка и очистка собранных данных",
          "Разделение данных на обучающие и тестовые наборы"
        ],
        correct: 1,
        expA: "Проверка качества - это часть этапа валидации данных, а не извлечения.",
        expB: "Именно! Извлечение данных фокусируется на сборе данных из разных источников.",
        expC: "Предобработка и очистка - это следующий этап после извлечения данных.",
        expD: "Разделение на наборы происходит после извлечения и подготовки данных.",
        points: 1,
        chapter: "ML - Данные",
        difficulty: "K2"
      },
      {
        id: 70,
        text: "Компания SmartRetail хочет улучшить качество своих данных о клиентах перед обучением рекомендательной системы. Какой подход будет наиболее эффективным?",
        options: [
          "Комплексная программа очистки и валидации данных",
          "Увеличение частоты сбора новых данных",
          "Переход на внешние источники данных",
          "Применение более сложных алгоритмов ML"
        ],
        correct: 0,
        expA: "Правильно! Систематическая очистка устраняет дубликаты, ошибки и несогласованности в существующих данных.",
        expB: "Больше данных не решает проблемы качества - могут добавиться новые ошибки.",
        expC: "Внешние данные могут быть полезны, но не заменяют необходимость улучшения внутренних данных.",
        expD: "Сложные алгоритмы не компенсируют плохое качество входных данных.",
        points: 2,
        chapter: "ML - Данные",
        difficulty: "K3"
      },
      {
        id: 71,
        text: "Команда FinanceAI планирует использовать исторические данные за 5 лет для прогнозирования рыночных трендов. Какой аспект подготовки данных требует особого внимания?",
        options: [
          "Учет изменений в рыночных условиях во времени",
          "Простое объединение всех исторических записей",
          "Фокус только на последних данных",
          "Игнорирование сезонных факторов"
        ],
        correct: 0,
        expA: "Точно! Рыночные условия эволюционируют, и старые паттерны могут не отражать текущую реальность.",
        expB: "Простое объединение игнорирует структурные изменения в экономике.",
        expC: "Только последние данные упускают долгосрочные циклы и тренды.",
        expD: "Сезонные факторы критически важны для финансового прогнозирования.",
        points: 2,
        chapter: "ML - Данные",
        difficulty: "K3"
      },
      {
        id: 72,
        text: "При подготовке данных для модели медицинской диагностики команда обнаружила 30% пропущенных значений в ключевых параметрах. Какая стратегия будет оптимальной?",
        options: [
          "Удалить все записи с пропущенными значениями",
          "Использовать специализированные методы импутации",
          "Заменить пропуски нулевыми значениями",
          "Игнорировать пропущенные значения при обучении"
        ],
        correct: 1,
        expA: "Удаление 30% данных приведет к значительной потере информации и смещению.",
        expB: "Правильно! Медицинские данные требуют продвинутых методов импутации с учетом клинических корреляций.",
        expC: "Нули в медицинских параметрах могут исказить диагностические паттерны.",
        expD: "Игнорирование пропусков может привести к некорректным медицинским выводам.",
        points: 2,
        chapter: "ML - Данные",
        difficulty: "K3"
      },
      {
        id: 73,
        text: "Стартап TechStart разрабатывает модель для анализа настроений в социальных сетях. Какой подход к предобработке текстовых данных будет наиболее подходящим?",
        options: [
          "Сохранение всех текстов без изменений",
          "Простое удаление знаков препинания",
          "Базовая токенизация без дополнительной обработки",
          "Комплексная лингвистическая обработка текстов"
        ],
        correct: 3,
        expA: "Необработанный текст содержит много шума, влияющего на качество анализа настроений.",
        expB: "Простое удаление пунктуации недостаточно для качественного NLP.",
        expC: "Базовая токенизация упускает важные лингвистические особенности.",
        expD: "Верно! Анализ настроений требует стемминга, удаления стоп-слов и нормализации текста.",
        points: 2,
        chapter: "ML - Данные",
        difficulty: "K3"
      },
      {
        id: 74,
        text: "Команда DataCorp планирует использовать синтетические данные для обучения модели распознавания мошенничества. Какой подход лучше всего обеспечит качество синтетических данных?",
        options: [
          "Генерация данных с использованием простых статистических распределений",
          "Применение GAN-архитектур для создания реалистичных паттернов",
          "Валидация синтетических данных против реальных метрик качества",
          "Увеличение объема синтетических данных для покрытия вариаций"
        ],
        correct: 2,
        expA: "Простые распределения могут не захватить сложные паттерны мошенничества.",
        expB: "GAN полезны для генерации, но сами по себе не гарантируют качество для конкретной задачи.",
        expC: "Правильно! Валидация против реальных метрик обеспечивает соответствие синтетических данных бизнес-требованиям.",
        expD: "Объем важен, но без контроля качества большие данные могут содержать систематические ошибки.",
        points: 2,
        chapter: "ML - Данные",
        difficulty: "K3"
      },
      {
        id: 75,
        text: "Какая стратегия будет оптимальной для компании GlobalTech при работе с мультиязычными данными клиентов?",
        options: [
          "Обработка каждого языка отдельными моделями",
          "Машинный перевод всех данных на английский",
          "Использование мультиязычных эмбеддингов",
          "Игнорирование нечастотных языков в данных"
        ],
        correct: 2,
        expA: "Отдельные модели усложняют поддержку и могут упустить межъязыковые паттерны.",
        expB: "Машинный перевод может внести искажения и потерять культурные нюансы.",
        expC: "Точно! Мультиязычные эмбеддинги сохраняют семантику разных языков в едином пространстве.",
        expD: "Игнорирование языков приводит к потере важной информации о клиентах.",
        points: 2,
        chapter: "ML - Данные",
        difficulty: "K3"
      },
      {
        id: 76,
        text: "Организация HealthCorp планирует интегрировать данные из множественных источников для создания единой системы анализа пациентов. Какой подход обеспечит наивысшее качество интеграции при соблюдении регуляторных требований?",
        options: [
          "Простое объединение всех источников без дополнительной обработки",
          "Применение технических решений без учета правовых ограничений",
          "Комплексная стратегия с учетом качества данных и соответствия нормам",
          "Ограничение интеграции только внутренними источниками данных"
        ],
        correct: 2,
        expA: "Простое объединение не решает проблемы качества и может нарушить медицинские стандарты.",
        expB: "Игнорирование правовых требований в медицине недопустимо и может повлечь серьезные последствия.",
        expC: "Правильно! Медицинская интеграция требует баланса технического качества, HIPAA-соответствия и клинической безопасности.",
        expD: "Ограничение внутренними данными упускает ценную внешнюю медицинскую информацию.",
        points: 3,
        chapter: "ML - Данные",
        difficulty: "K4"
      },
      {
        id: 77,
        text: "Компания AutoDrive разрабатывает систему автономного вождения, используя данные с различных датчиков и камер. Какая стратегия управления данными лучше всего подходит для обеспечения безопасности и надежности системы?",
        options: [
          "Многоуровневая валидация с резервированием критических данных",
          "Использование только данных с одного типа датчиков для простоты",
          "Равномерное доверие ко всем источникам данных без приоритизации",
          "Фокус на скорости обработки в ущерб проверкам качества"
        ],
        correct: 0,
        expA: "Правильно! Безопасность автономного вождения требует многоуровневой валидации и резервных систем для критических решений.",
        expB: "Один тип датчиков создает единую точку отказа и снижает общую надежность системы.",
        expC: "Равное доверие опасно - некоторые датчики более критичны для безопасности вождения.",
        expD: "Скорость важна, но безопасность имеет приоритет в автономных транспортных средствах.",
        points: 3,
        chapter: "ML - Данные",
        difficulty: "K4"
      },
      {
        id: 78,
        text: "Финтех-стартап CryptoAnalytics планирует создать систему прогнозирования рыночных трендов, используя традиционные финансовые данные и данные социальных сетей. Какой подход к управлению рисками данных будет наиболее эффективным?",
        options: [
          "Диверсификация источников данных с независимой валидацией каждого потока",
          "Полагаться преимущественно на социальные сети как основной источник",
          "Использовать только исторические финансовые данные для стабильности",
          "Равномерно взвешивать все источники без учета их волатильности"
        ],
        correct: 0,
        expA: "Именно! Диверсификация источников и независимая валидация снижают риски и повышают робастность прогнозов.",
        expB: "Социальные сети крайне волатильны и могут вводить в заблуждение без подтверждения.",
        expC: "Только исторические данные упускают актуальные рыночные настроения и тренды.",
        expD: "Равномерное взвешивание игнорирует различную надежность и качество источников.",
        points: 3,
        chapter: "ML - Данные",
        difficulty: "K4"
      },
      {
        id: 79,
        text: "Международная корпорация GlobalAI внедряет единую платформу машинного обучения, которая должна работать с данными из различных стран с разными регуляторными требованиями. Какая стратегия обеспечит соответствие требованиям при максимизации качества данных?",
        options: [
          "Игнорирование местных регуляций в пользу единых стандартов",
          "Создание отдельных изолированных систем для каждой юрисдикции",
          "Применение самых строгих требований ко всем данным глобально",
          "Адаптивная архитектура с региональной настройкой соответствия"
        ],
        correct: 3,
        expA: "Игнорирование местных регуляций может привести к серьезным правовым и финансовым последствиям.",
        expB: "Изоляция препятствует глобальным инсайтам и увеличивает эксплуатационные расходы.",
        expC: "Самые строгие требования везде могут быть излишне ограничительными и снизить качество анализа.",
        expD: "Правильно! Адаптивная архитектура обеспечивает локальное соответствие при сохранении глобальной координации данных.",
        points: 3,
        chapter: "ML - Данные",
        difficulty: "K4"
      },
      {
        id: 80,
        text: "Команда разработчиков в AgriTech заметила снижение качества разметки данных у внештатных разметчиков при работе с сельскохозяйственными изображениями. Какая стратегия лучше всего решит эту проблему в долгосрочной перспективе?",
        options: [
          "Увеличение оплаты разметчикам",
          "Переход на полностью автоматизированную разметку",
          "Упрощение задач разметки за счет снижения детализации",
          "Комплексная система обучения и мониторинга качества"
        ],
        correct: 3,
        expA: "Увеличение оплаты может помочь временно, но не решает проблемы понимания и навыков разметчиков.",
        expB: "Автоматизированная разметка может быть неточной для сложных сельскохозяйственных сценариев.",
        expC: "Упрощение разметки может снизить качество обучающих данных и точность модели.",
        expD: "Правильно! Систематическое обучение разметчиков и постоянный мониторинг качества обеспечат стабильное качество данных.",
        points: 3,
        chapter: "ML - Данные",
        difficulty: "K4"
      },
      {
        id: 81,
        text: "Какая метрика показывает, сколько положительных случаев удалось найти?",
        options: [
          "Точность (Precision)",
          "Полнота (Recall)", 
          "Accuracy",
          "F1-мера"
        ],
        correct: 1,
        expA: "Точность показывает, сколько из найденных положительных случаев оказались правильными, а не сколько вообще удалось найти.",
        expB: "Правильно! Полнота (Recall) как раз показывает, какую долю от всех реальных положительных случаев модель смогла найти.",
        expC: "Accuracy показывает общую правильность по всем классам, а не конкретно по положительным случаям.",
        expD: "F1-мера объединяет точность и полноту, но сама по себе не показывает долю найденных случаев.",
        points: 1,
        chapter: "Метрики функциональной производительности МО", 
        difficulty: "K1"
      },
      {
        id: 82,
        text: "Что показывает матрица ошибок?",
        options: [
          "Только правильные предсказания",
          "Сравнение предсказаний с реальностью",
          "Скорость работы модели", 
          "Время обучения"
        ],
        correct: 1,
        expA: "Матрица ошибок показывает все предсказания — и правильные, и неправильные.",
        expB: "Именно! Матрица ошибок показывает, как предсказания модели соотносятся с реальными классами объектов.",
        expC: "Матрица ошибок оценивает качество классификации, а не скорость работы.",
        expD: "Время обучения — это отдельная характеристика, которую матрица ошибок не показывает.",
        points: 1,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K1"
      },
      {
        id: 83, 
        text: "Какая метрика лучше всего подходит для регрессионных моделей?",
        options: [
          "Точность (Precision)",
          "Полнота (Recall)", 
          "Квадратичная ошибка (MSE)",
          "F1-мера"
        ],
        correct: 2,
        expA: "Точность используется для классификации, когда нужно определить категорию, а не для регрессии.",
        expB: "Полнота тоже относится к классификации, а не к предсказанию числовых значений.",
        expC: "Верно! Квадратичная ошибка (MSE) показывает, насколько точно модель регрессии предсказывает числовые значения.", 
        expD: "F1-мера используется для классификации, объединяя точность и полноту.",
        points: 1,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K2"
      },
      {
        id: 84,
        text: "В чем основное ограничение метрик производительности МО?",
        options: [
          "Слишком сложны для понимания",
          "Неточно отражают работу модели",
          "Могут игнорировать бизнес-контекст",
          "Работают только с малыми данными"
        ],
        correct: 2,
        expA: "Большинство метрик МО вполне понятны, если их правильно объяснить.",
        expB: "Метрики действительно показывают работу модели, но с определенными ограничениями.",
        expC: "Точно! Метрики могут быть технически хорошими, но не учитывать бизнес-приоритеты, затраты или особенности применения.",
        expD: "Метрики производительности одинаково хорошо работают с данными любого размера.",
        points: 1,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K2"
      },
      {
        id: 85,
        text: "Модель медицинской диагностики имеет высокую полноту, но низкую точность. Что скорее всего произойдет?",
        options: [
          "Многие болезни останутся незамеченными",
          "Здоровым людям будут ставить ложные диагнозы", 
          "Модель будет работать медленно",
          "Модель будет потреблять много памяти"
        ],
        correct: 1,
        expA: "Высокая полнота означает, что большинство болезней модель найдет, поэтому пропусков будет мало.",
        expB: "Правильно! Низкая точность при высокой полноте означает много ложных тревог — здоровым пациентам ставят диагнозы, которых у них нет.",
        expC: "Скорость работы не связана с показателями точности и полноты.",
        expD: "Потребление памяти не зависит от этих метрик качества.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 86,
        text: "Модель распознавания изображений показывает 95% общей точности, но плохо распознает редкие объекты. Какая метрика лучше всего выявит эту проблему?",
        options: [
          "Общая точность модели",
          "Полнота по отдельным классам",
          "Скорость обработки изображений",
          "Размер файла модели"
        ],
        correct: 1,
        expA: "Общая точность уже высокая (95%), но она скрывает проблемы с отдельными типами объектов.",
        expB: "Именно! Полнота по классам покажет, что редкие объекты плохо распознаются, даже при хорошей общей точности.",
        expC: "Скорость обработки не связана с качеством распознавания конкретных типов объектов.",
        expD: "Размер модели не показывает проблемы с распознаванием определенных категорий.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 87,
        text: "Какая метрика лучше всего подходит для несбалансированных классов?",
        options: [
          "Общая точность (Accuracy)",
          "F1-мера или взвешенные метрики",
          "Простая точность (Precision)",
          "Стандартные регрессионные метрики"
        ],
        correct: 1,
        expA: "Общая точность вводит в заблуждение при несбалансированных классах, переоценивая производительность.",
        expB: "Правильно! F1-мера и взвешенные метрики учитывают дисбаланс классов и дают более объективную оценку.",
        expC: "Простая точность может быть высокой даже при плохой работе с меньшинством классов.",
        expD: "Регрессионные метрики не подходят для задач классификации с дисбалансом классов.",
        points: 1,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K2"
      },
      {
        id: 88,
        text: "Регрессионная модель предсказания цен имеет R² = 0.85. Что это означает?",
        options: [
          "Модель ошибается в 85% случаев",
          "Скорость предсказаний составляет 85%",
          "Модель объясняет 85% изменчивости цен",
          "Модель нуждается в 85% дополнительных данных"
        ],
        correct: 2,
        expA: "R² не показывает долю ошибок — это коэффициент детерминации, а не показатель ошибок.",
        expB: "R² никак не связан со скоростью работы модели.",
        expC: "Правильно! R² = 0.85 означает, что модель объясняет 85% вариации в данных о ценах.",
        expD: "R² показывает качество объяснения данных, а не потребность в дополнительной информации.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 89,
        text: "Команда MedAI разрабатывает систему диагностики рака. Точность важнее полноты. Какую метрику использовать в первую очередь?",
        options: [
          "Максимизировать общую точность системы",
          "Оптимизировать точность (Precision) положительного класса",
          "Сбалансировать все метрики одинаково",
          "Использовать стандартизированные пороговые значения"
        ],
        correct: 1,
        expA: "Общая точность может скрыть проблемы с ложноположительными результатами в медицинской диагностике.",
        expB: "Правильно! Высокая точность минимизирует ложные диагнозы рака у здоровых пациентов.",
        expC: "В медицинских задачах приоритеты метрик должны отражать клинические последствия ошибок.",
        expD: "Стандартные пороги могут не учитывать специфику медицинской диагностики и риски пациентов.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 90,
        text: "Что означает AUC-ROC = 0.5 для бинарного классификатора?",
        options: [
          "Модель идеально различает классы",
          "Модель работает случайно",
          "Модель имеет среднее качество",
          "Модель требует больше данных"
        ],
        correct: 1,
        expA: "AUC-ROC = 1.0 означает идеальное различение, а не 0.5.",
        expB: "Точно! AUC-ROC = 0.5 означает, что модель различает классы не лучше случайного угадывания.",
        expC: "0.5 — это не среднее качество, а показатель отсутствия способности к различению классов.",
        expD: "Проблема не обязательно в количестве данных — возможно, признаки не информативны.",
        points: 1,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K2"
      },
      {
        id: 91,
        text: "У регрессионной модели MAE = 50, а RMSE = 80. О чем это говорит?",
        options: [
          "В данных есть выбросы",
          "Модель работает идеально",
          "Нужно больше обучающих данных",
          "Модель переобучена"
        ],
        correct: 0,
        expA: "Верно! RMSE > MAE указывает на наличие больших ошибок (выбросов), так как RMSE сильнее реагирует на большие отклонения.",
        expB: "Если бы модель работала идеально, обе метрики были бы близки к нулю.",
        expC: "Соотношение MAE и RMSE говорит о характере ошибок, а не о количестве данных.",
        expD: "Эти метрики не показывают переобучение напрямую — для этого нужно сравнение с валидационными данными.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 92,
        text: "Что показывает высокий R² при низкой точности предсказаний?",
        options: [
          "Модель работает хорошо",
          "R² не подходит для оценки этой модели",
          "Данные имеют четкую структуру, но модель неточна",
          "Нужно увеличить размер данных"
        ],
        correct: 1,
        expA: "Если точность предсказаний низкая, модель не может считаться хорошо работающей.",
        expB: "Правильно! R² показывает долю объясненной изменчивости в регрессии, это не то же самое, что точность в классификации.",
        expC: "Эти метрики фактически показывают хорошую работу модели, дообучение может не требоваться.",
        expD: "Высокий R² говорит о том, что данные вполне информативны для предсказания.",
        points: 1,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K2"
      },
      {
        id: 93,
        text: "Спам-фильтр имеет высокую точность, но низкую полноту. Что скорее всего произойдет?",
        options: [
          "Много обычных писем попадет в спам",
          "Фильтр будет медленно работать",
          "Модель будет потреблять много памяти",
          "Много спама попадет в обычную почту"
        ],
        correct: 3,
        expA: "Высокая точность означает мало ложных срабатываний, поэтому обычные письма редко помечаются как спам.",
        expB: "Скорость работы не связана с показателями точности и полноты.",
        expC: "Потребление памяти не зависит от этих метрик качества.",
        expD: "Правильно! Низкая полнота означает, что много настоящего спама не обнаруживается и проходит в обычную почту.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 94,
        text: "Как вычисляется F1-мера?",
        options: [
          "Простое среднее точности и полноты",
          "Гармоническое среднее точности и полноты",
          "Используется только точность",
          "Используется только полнота"
        ],
        correct: 1,
        expA: "F1-мера не использует простое среднее — оно бы не учитывало соотношение значений.",
        expB: "Верно! F1-мера использует гармоническое среднее, которое сильнее реагирует на низкие значения точности или полноты.",
        expC: "F1-мера обязательно учитывает и точность, и полноту, а не только точность.",
        expD: "F1-мера обязательно учитывает и точность, и полноту, а не только полноту.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 95,
        text: "Бинарный классификатор показал AUC = 0.92. Как описать работу модели?",
        options: [
          "Модель плохо различает классы",
          "Модель работает случайно",
          "Модель переобучена",
          "Модель отлично различает классы"
        ],
        correct: 3,
        expA: "AUC = 0.92 — очень высокий результат, говорящий об отличном различении, а не о плохой работе.",
        expB: "Случайное угадывание дало бы AUC около 0.5, а не 0.92.",
        expC: "Высокий AUC говорит о хорошей работе, но для выявления переобучения нужна дополнительная информация.",
        expD: "Совершенно верно! AUC = 0.92 показывает отличную способность различать положительные и отрицательные классы.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 96,
        text: "CloudML сравнивает модели сегментации клиентов. Модель X: точность 0.8, полнота 0.9, F1=0.85. Модель Y: точность 0.95, полнота 0.7, F1=0.81. Какой стратегический подход лучше для долгосрочного маркетинга с ограниченным бюджетом?",
        options: [
          "Выбрать модель X для максимального охвата клиентов",
          "Выбрать модель Y для точного таргетинга премиум-сегмента",
          "Комбинированная стратегия: X для массовых кампаний, Y для премиум-предложений",
          "A/B тестирование обеих моделей с мониторингом ROI и конверсий"
        ],
        correct: 3,
        expA: "Модель X может привести к высоким затратам на неточный таргетинг при ограниченном бюджете.",
        expB: "Модель Y упускает значительную часть потенциальных клиентов, ограничивая рост.",
        expC: "Комбинированная стратегия сложна в управлении и требует значительных ресурсов.",
        expD: "Именно! A/B тестирование позволяет оценить реальную бизнес-эффективность с учетом бюджетных ограничений и ROI.",
        points: 3,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K4"
      },
      {
        id: 97,
        text: "AutoVision тестирует модели распознавания объектов для автономных машин. Дневная точность 94%, ночная 69%. Какая комплексная стратегия оптимальна для обеспечения безопасности?",
        options: [
          "Интеграция мультисенсорных данных с адаптивными алгоритмами уверенности",
          "Отдельные специализированные модели для дневных и ночных условий",
          "Увеличение обучающих данных с акцентом на ночные сценарии",
          "Применение техник аугментации данных для улучшения ночной производительности"
        ],
        correct: 0,
        expA: "Правильно! Мультисенсорная интеграция с адаптивными алгоритмами обеспечивает надежность в изменяющихся условиях и критически важна для безопасности.",
        expB: "Отдельные модели создают сложности переключения и потенциальные точки отказа в автономных системах.",
        expC: "Больше данных поможет, но не решит фундаментальную проблему различий в условиях освещения.",
        expD: "Аугментация улучшит производительность, но не обеспечит необходимой надежности для критических систем безопасности.",
        points: 3,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K4"
      },
      {
        id: 98,
        text: "Какой подход лучше всего подходит для выбора метрик в задаче кластеризации?",
        options: [
          "Использовать только внутренние метрики кластеризации",
          "Использовать только внешние метрики сравнения",
          "Комбинировать метрики в зависимости от цели кластеризации",
          "Полагаться на визуальную оценку кластеров"
        ],
        correct: 2,
        expA: "Внутренние метрики (как силуэт) полезны, но не показывают соответствие бизнес-целям.",
        expB: "Внешние метрики требуют известных меток, которых обычно нет при кластеризации.",
        expC: "Правильно! Комбинация метрик дает полную картину — внутренние показывают качество кластеров, внешние проверяют соответствие задаче.",
        expD: "Визуальная оценка субъективна и не работает с многомерными данными.",
        points: 1,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K2"
      },
      {
        id: 99,
        text: "Модель показывает стабильные метрики на обучающих данных, но сильно варьирующиеся результаты на новых данных. Что указывает на переобучение?",
        options: [
          "Высокие метрики только на обучающих данных",
          "Низкие метрики на всех данных",
          "Большая разница между обучающими и валидационными метриками",
          "Медленная скорость работы модели"
        ],
        correct: 2,
        expA: "Высокие метрики на обучении могут быть и у хорошей модели, если валидационные метрики тоже высокие.",
        expB: "Низкие метрики везде говорят о недообучении, а не о переобучении.",
        expC: "Именно! Большой разрыв между обучающими и валидационными метриками — классический признак переобучения.",
        expD: "Скорость работы не связана с переобучением напрямую.",
        points: 2,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K3"
      },
      {
        id: 100,
        text: "TechFinance разрабатывает модель кредитного скоринга. Система показывает отличные метрики на исторических данных, но производительность снижается через 6 месяцев эксплуатации. Какая комплексная стратегия мониторинга наиболее эффективна?",
        options: [
          "Еженедельное сравнение основных метрик с историческими базовыми линиями",
          "Интегрированный мониторинг дрейфа данных, производительности модели и бизнес-показателей",
          "Автоматическое переобучение модели при снижении точности ниже пороговых значений",
          "Регулярный анализ распределений входных данных и проверка статистической значимости"
        ],
        correct: 1,
        expA: "Сравнение с историческими данными важно, но не выявляет причины деградации производительности.",
        expB: "Правильно! Комплексный подход учитывает взаимосвязь между дрейфом данных, техническими метриками и реальными бизнес-результатами.",
        expC: "Автоматическое переобучение без анализа причин может усугубить проблемы или привести к нестабильности.",
        expD: "Статистический анализ полезен, но сам по себе не обеспечивает полной картины производительности в продакшене.",
        points: 3,
        chapter: "Метрики функциональной производительности МО",
        difficulty: "K4"
      },
      {
        id: 101,
        text: "Какое утверждение точно описывает цель метрики покрытия нейронов? Выберите ОДИН вариант.",
        options: [
          "Измеряет пропускную способность сетевых соединений",
          "Показывает долю активированных нейронов во время тестирования",
          "Определяет уровень использования памяти сервера",
          "Оценивает скорость выполнения SQL-запросов"
        ],
        correct: 1,
        expA: "Пропускная способность сети — это характеристика инфраструктуры, не связанная с нейронными сетями.",
        expB: "Верно! Покрытие нейронов показывает, какая доля нейронов была активирована в процессе тестирования.",
        expC: "Использование памяти — это системная метрика, не связанная с тестированием ИИ.",
        expD: "SQL-запросы относятся к базам данных, а не к нейронным сетям.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K1"
      },
      {
        id: 102,
        text: "Что лучше всего описывает покрытие синапсов при тестировании нейронных сетей? Выберите ОДИН вариант.",
        options: [
          "Подсчитывает количество активных TCP-соединений",
          "Отслеживает использование весовых связей между нейронами",
          "Измеряет время отклика REST API",
          "Вычисляет хеш-суммы файлов конфигурации"
        ],
        correct: 1,
        expA: "TCP-соединения — это сетевая технология, не связанная с нейронными сетями.",
        expB: "Правильно! Покрытие синапсов отслеживает, какие весовые связи между нейронами использовались в работе.",
        expC: "Время отклика API — это метрика производительности веб-сервисов.",
        expD: "Хеш-суммы используются для проверки целостности файлов, не для тестирования ИИ.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K1"
      },
      {
        id: 103,
        text: "Каковы основные ограничения традиционных метрик покрытия для нейронных сетей? Выберите ОДИН вариант.",
        options: [
          "Применимы только к моделям с обучением с подкреплением",
          "Не учитывают нелинейную природу активаций",
          "Требуют предварительного обучения на синтетических данных",
          "Работают исключительно с рекуррентными архитектурами"
        ],
        correct: 1,
        expA: "Традиционные метрики покрытия могут применяться к различным типам обучения, включая контролируемое.",
        expB: "Точно! Традиционные метрики часто игнорируют сложные нелинейные взаимодействия между нейронами.",
        expC: "Синтетические данные не являются обязательным требованием для расчета метрик покрытия.",
        expD: "Метрики покрытия применимы к различным архитектурам, не только к RNN.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K2"
      },
      {
        id: 104,
        text: "Как комбинационное покрытие улучшает тестирование по сравнению с покрытием отдельных нейронов? Выберите ОДИН вариант.",
        options: [
          "Анализирует взаимодействие между соседними нейронами",
          "Учитывает одновременную активацию групп нейронов",
          "Оптимизирует веса нейронов для лучшей производительности",
          "Генерирует дополнительные обучающие примеры автоматически"
        ],
        correct: 1,
        expA: "Комбинационное покрытие анализирует не только соседние, но и любые комбинации нейронов.",
        expB: "Верно! Комбинационное покрытие проверяет, как разные нейроны работают вместе в различных сочетаниях.",
        expC: "Оптимизация весов — это процесс обучения, а не измерение покрытия при тестировании.",
        expD: "Генерация данных — отдельная задача, не связанная с метриками покрытия.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K2"
      },
      {
        id: 105,
        text: "Какая концепция лежит в основе покрытия изменения значений в нейронных сетях? Выберите ОДИН вариант.",
        options: [
          "Мониторинг изменений активации нейронов между различными входными данными",
          "Анализ скорости конвергенции градиентного спуска",
          "Измерение дисперсии весов в процессе обучения",
          "Отслеживание вариации архитектуры модели"
        ],
        correct: 0,
        expA: "Правильно! Покрытие изменения значений отслеживает, как меняется активация нейронов при разных входах.",
        expB: "Скорость конвергенции — это метрика обучения, а не тестового покрытия.",
        expC: "Дисперсия весов относится к анализу стабильности модели, не к покрытию активаций.",
        expD: "Архитектура модели фиксирована, покрытие изменения значений касается активаций нейронов.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K2"
      },
      {
        id: 106,
        text: "Что характеризует покрытие смены знака при тестировании глубоких нейронных сетей? Выберите ОДИН вариант.",
        options: [
          "Отслеживание изменения знака активации нейронов",
          "Мониторинг знака градиента при обратном распространении",
          "Анализ положительных и отрицательных весовых коэффициентов",
          "Контроль знака функции потерь в процессе обучения"
        ],
        correct: 0,
        expA: "Верно! Покрытие смены знака проверяет, меняют ли нейроны знак активации при разных тестовых входах.",
        expB: "Знак градиента — это информация процесса обучения, не покрытия при тестировании.",
        expC: "Анализ весов важен для понимания модели, но покрытие смены знака касается активаций.",
        expD: "Функция потерь используется при обучении, а не при измерении тестового покрытия.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K2"
      },
      {
        id: 107,
        text: "В каких случаях покрытие знак-знак наиболее полезно для тестирования нейронных сетей? Выберите ОДИН вариант.",
        options: [
          "При анализе корреляции между парами нейронов в одном слое",
          "Для изучения взаимодействий между нейронами разных слоев",
          "При оценке синхронизации активаций соседних нейронов",
          "Для анализа одновременного поведения пар нейронов"
        ],
        correct: 3,
        expA: "Корреляция в одном слое — важный аспект, но покрытие знак-знак шире этого понятия.",
        expB: "Межслойные взаимодействия важны, но покрытие знак-знак фокусируется на парных отношениях.",
        expC: "Синхронизация соседних нейронов — частный случай более общего парного анализа.",
        expD: "Точно! Покрытие знак-знак исследует, как пары нейронов ведут себя вместе в различных комбинациях знаков.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K2"
      },
      {
        id: 108,
        text: "Как пороговое покрытие отличается от простого покрытия нейронов? Выберите ОДИН вариант.",
        options: [
          "Использует более высокие значения активации для определения покрытия",
          "Применяет динамические пороги на основе распределения данных",
          "Учитывает только нейроны с максимальными значениями активации",
          "Анализирует процентные пороги активации по всей сети"
        ],
        correct: 0,
        expA: "Верно! Пороговое покрытие требует активации выше определенного порога, а не просто больше нуля.",
        expB: "Динамические пороги — это продвинутый подход, но основа порогового покрытия в фиксированных значениях.",
        expC: "Максимальные активации — слишком жесткое ограничение, пороговое покрытие более гибкое.",
        expD: "Процентные пороги — один из способов, но суть в превышении установленного значения активации.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K2"
      },
      {
        id: 109,
        text: "Какое преимущество дает комплексный подход к покрытию нейронных сетей? Выберите ОДИН вариант.",
        options: [
          "Снижает вычислительную сложность тестирования",
          "Обеспечивает более полное понимание поведения модели",
          "Ускоряет процесс обучения нейронной сети",
          "Автоматически генерирует оптимальную архитектуру"
        ],
        correct: 1,
        expA: "Комплексный подход обычно увеличивает вычислительные требования из-за множественных метрик.",
        expB: "Именно! Использование разных метрик покрытия дает многостороннее представление о тестировании модели.",
        expC: "Комплексное покрытие — это техника тестирования, а не оптимизации процесса обучения.",
        expD: "Генерация архитектуры — отдельная задача, покрытие помогает в тестировании существующих моделей.",
        points: 1,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K2"
      },
      {
        id: 110,
        text: "Команда замечает низкое покрытие в последних слоях глубокой сети. Какую стратегию следует применить? Выберите ОДИН вариант.",
        options: [
          "Реализовать адаптивное увеличение интенсивности тестирования поздних слоёв",
          "Применить методы регуляризации для повышения активности нейронов",
          "Использовать трансферное обучение с предобученными весами",
          "Изменить архитектуру сети на более простую конфигурацию"
        ],
        correct: 0,
        expA: "Правильно! Адаптивное тестирование поздних слоёв поможет выявить неактивные пути и повысить покрытие.",
        expB: "Регуляризация обычно снижает активность нейронов, а не повышает её для улучшения покрытия.",
        expC: "Трансферное обучение изменит веса, но не решит проблему систематически низкого покрытия.",
        expD: "Упрощение архитектуры может снизить способности модели без решения основной проблемы покрытия.",
        points: 2,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K3"
      },
      {
        id: 111,
        text: "При тестировании сверточной нейронной сети для медицинской диагностики команда обнаружила неравномерное покрытие фильтров. Как оптимизировать стратегию? Выберите ОДИН вариант.",
        options: [
          "Создать специализированные тестовые изображения для активации неиспользуемых фильтров",
          "Применить техники аугментации данных для повышения разнообразия входов",
          "Использовать методы визуализации для анализа реакции фильтров",
          "Реструктурировать архитектуру для более равномерного использования фильтров"
        ],
        correct: 0,
        expA: "Отлично! Целенаправленное создание тестов для неактивных фильтров обеспечит более полное покрытие.",
        expB: "Аугментация поможет, но не гарантирует активацию конкретных неиспользуемых фильтров.",
        expC: "Визуализация полезна для понимания, но не решает проблему неравномерного покрытия.",
        expD: "Изменение архитектуры — радикальное решение, сначала стоит попробовать улучшить тестирование.",
        points: 2,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K3"
      },
      {
        id: 112,
        text: "Компания разрабатывает систему автономного вождения. Как обеспечить адекватное покрытие критических сценариев? Выберите ОДИН вариант.",
        options: [
          "Сосредоточиться на покрытии нейронов, отвечающих за распознавание препятствий",
          "Применить взвешенные метрики покрытия с приоритизацией безопасности",
          "Использовать равномерное покрытие всех компонентов сети без приоритизации",
          "Фокусироваться исключительно на тестировании в идеальных дорожных условиях"
        ],
        correct: 1,
        expA: "Распознавание препятствий важно, но безопасность требует комплексного подхода ко всей системе.",
        expB: "Превосходно! Взвешенные метрики позволяют уделить больше внимания критически важным для безопасности компонентам.",
        expC: "Равномерное покрытие игнорирует различную важность компонентов для безопасности.",
        expD: "Тестирование только в идеальных условиях не подготовит систему к реальным дорожным ситуациям.",
        points: 2,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K3"
      },
      {
        id: 113,
        text: "При внедрении метрик покрытия в существующий процесс разработки команда сталкивается с производительными ограничениями. Какой подход выбрать? Выберите ОДИН вариант.",
        options: [
          "Применить выборочное покрытие критических слоёв и компонентов",
          "Использовать аппроксимацию покрытия с пониженной точностью",
          "Перейти на облачные вычисления для расчета полного покрытия",
          "Отказаться от метрик покрытия в пользу традиционных методов тестирования"
        ],
        correct: 0,
        expA: "Умно! Фокусирование на критических компонентах обеспечивает баланс между качеством и производительностью.",
        expB: "Аппроксимация может пропустить важные паттерны активации и снизить эффективность тестирования.",
        expC: "Облачные ресурсы помогут, но не решат фундаментальную проблему оптимизации процесса.",
        expD: "Отказ от покрытия лишит команду ценной информации о качестве тестирования ИИ-системы.",
        points: 2,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K3"
      },
      {
        id: 114,
        text: "Команда тестирует рекуррентную нейронную сеть для анализа временных рядов. Какие особенности покрытия следует учесть? Выберите ОДИН вариант.",
        options: [
          "Применить статические метрики покрытия, как для обычных сетей",
          "Учесть временную динамику активации нейронов в последовательности",
          "Сосредоточиться только на финальном состоянии скрытых нейронов",
          "Игнорировать состояния памяти и анализировать только входные данные"
        ],
        correct: 1,
        expA: "Статические метрики не учитывают временную природу RNN и могут пропустить важные паттерны.",
        expB: "Правильно! RNN требует анализа покрытия во времени, учитывая эволюцию активаций в последовательности.",
        expC: "Финальное состояние важно, но промежуточные активации также критичны для понимания поведения RNN.",
        expD: "Состояния памяти — ключевая особенность RNN, их игнорирование снижает качество тестирования.",
        points: 2,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K3"
      },
      {
        id: 115,
        text: "Команда разрабатывает подход к покрытию для трансформерной архитектуры. Какие компоненты требуют особого внимания? Выберите ОДИН вариант.",
        options: [
          "Применить универсальные метрики для всех типов слоев",
          "Сосредоточиться на механизмах внимания и их паттернах активации",
          "Использовать традиционные CNN-подходы для анализа покрытия",
          "Внимание, позиционные кодировки и многоголовые механизмы"
        ],
        correct: 3,
        expA: "Универсальные метрики могут пропустить специфические особенности трансформерной архитектуры.",
        expB: "Механизмы внимания важны, но это лишь один из компонентов сложной архитектуры.",
        expC: "CNN-подходы не подходят для анализа внимания и позиционных кодировок в трансформерах.",
        expD: "Отлично! Трансформеры требуют комплексного анализа всех ключевых механизмов для полного покрытия.",
        points: 2,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K3"
      },
      {
        id: 116,
        text: "Финтех-компания внедряет нейронную сеть для обнаружения мошенничества. Регуляторы требуют документирования покрытия тестирования. Разработайте комплексную стратегию. Выберите ОДИН вариант.",
        options: [
          "Внедрить метрики покрытия с фокусом на объяснимость решений",
          "Применить риск-ориентированное покрытие с приоритизацией критичных путей",
          "Использовать статистическое покрытие с доверительными интервалами",
          "Комбинировать покрытие нейронов, состояний и граничных случаев"
        ],
        correct: 3,
        expA: "Объяснимость важна, но недостаточна для полного соблюдения регулятивных требований к тестированию.",
        expB: "Риск-ориентированный подход ценен, но не обеспечивает полноту документирования для регуляторов.",
        expC: "Статистическое покрытие полезно, но не покрывает все аспекты, требуемые в финансовой сфере.",
        expD: "Превосходно! Комплексный подход с трассируемостью удовлетворит строгие регулятивные требования.",
        points: 3,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K4"
      },
      {
        id: 117,
        text: "При тестировании генеративной модели для создания изображений команда обнаруживает использование только 60% нейронов. Предложите стратегию улучшения. Выберите ОДИН вариант.",
        options: [
          "Создать разнообразные промпты и проанализировать латентное пространство",
          "Применить техники регуляризации для активации большего числа нейронов",
          "Уменьшить размер модели для повышения эффективности использования",
          "Переобучить модель на расширенном наборе данных"
        ],
        correct: 0,
        expA: "Отлично! Разнообразные промпты и анализ латентного пространства помогут активировать больше нейронов.",
        expB: "Регуляризация обычно ограничивает активацию, а не расширяет использование нейронов.",
        expC: "Уменьшение модели снизит её способности, не решив основную проблему неполного использования.",
        expD: "Переобучение — дорогостоящий процесс, сначала стоит попробовать более разнообразное тестирование.",
        points: 3,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K4"
      },
      {
        id: 118,
        text: "Команда разрабатывает ИИ-систему для критически важной инфраструктуры. Как обеспечить максимальную надежность через покрытие? Выберите ОДИН вариант.",
        options: [
          "Применить многоуровневое покрытие с перекрёстной валидацией моделей",
          "Использовать консервативные пороги активации для всех нейронов",
          "Сосредоточиться на покрытии наиболее вероятных сценариев работы",
          "Создать избыточные системы с дублированием критичных компонентов"
        ],
        correct: 0,
        expA: "Превосходно! Многоуровневый подход с валидацией обеспечит максимальную надежность для критической инфраструктуры.",
        expB: "Консервативные пороги помогут, но не обеспечат полноты тестирования всех критических сценариев.",
        expC: "Фокус на вероятных сценариях может пропустить редкие, но критически важные ситуации.",
        expD: "Избыточность важна для надежности, но не заменяет качественное тестирование основной системы.",
        points: 3,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K4"
      },
      {
        id: 119,
        text: "Многонациональная компания внедряет единую систему ИИ для разных регионов. Как адаптировать стратегию покрытия? Выберите ОДИН вариант.",
        options: [
          "Использовать универсальные метрики покрытия для всех регионов",
          "Создать региональные варианты тестирования с культурно-специфичным покрытием",
          "Применить взвешенное покрытие в зависимости от размера рынка",
          "Сосредоточиться на покрытии самого важного регионального рынка"
        ],
        correct: 1,
        expA: "Универсальные метрики могут не учитывать важные культурные и региональные различия в поведении.",
        expB: "Правильно! Региональная адаптация покрытия обеспечит качественную работу системы в разных культурных контекстах.",
        expC: "Взвешивание по размеру рынка может оставить без внимания важные региональные особенности.",
        expD: "Фокус на одном регионе снизит качество работы системы в других важных рынках.",
        points: 3,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K4"
      },
      {
        id: 120,
        text: "При переносе обученной модели на новую область команда замечает снижение покрытия некоторых слоев. Как адаптировать стратегию покрытия? Выберите ОДИН вариант.",
        options: [
          "Проводить постепенную адаптацию метрик с валидацией на новых данных",
          "Переоценить покрытие с учетом специфики области",
          "Применить ансамблевые методы для компенсации пробелов в покрытии",
          "Использовать активное обучение для повышения покрытия проблемных слоёв"
        ],
        correct: 1,
        expA: "Постепенная адаптация полезна, но может не учесть кардинальные различия между доменами.",
        expB: "Правильно! Трансферное обучение требует переоценки покрытия с учётом особенностей новой области.",
        expC: "Ансамблевые методы усложняют архитектуру, но не решают основную проблему специфики домена.",
        expD: "Активное обучение помогает с данными, но не адаптирует метрики покрытия к новой области.",
        points: 3,
        chapter: "ML - Нейронные сети и тестирование",
        difficulty: "K4"
      },
      {
        id: 121,
        text: "Что больше всего усложняет составление спецификаций для систем ИИ?",
        options: [
          "Вариативность выходных данных ИИ-модели",
          "Стохастическое поведение нейронных сетей", 
          "Непредсказуемые результаты работы",
          "Адаптивность алгоритмов машинного обучения"
        ],
        correct: 2,
        expA: "Вариативность выходов - проблема, но не главная причина сложности спецификаций.",
        expB: "Стохастичность усложняет, но системы ИИ непредсказуемы шире этого понятия.",
        expC: "Именно так! Когда система на одинаковых входах выдает разные результаты, сложно описать, что от неё ожидать.",
        expD: "Адаптивность создает проблемы, но непредсказуемость - более фундаментальный вызов.",
        points: 1,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 122,
        text: "Что такое тестирование входных данных в системах ИИ?",
        options: [
          "Валидация схем JSON для REST API",
          "Оценка качества тестовых данных",
          "Проверка SQL-запросов к базе данных", 
          "Тестирование пользовательских интерфейсов"
        ],
        correct: 1,
        expA: "JSON-валидация относится к веб-API, а не к специфике тестирования ИИ-систем.",
        expB: "Верно! Здесь проверяют, насколько хорошо тестовые данные подходят для проверки ИИ-систем.",
        expC: "SQL-тестирование относится к базам данных, не к тестированию данных для ИИ.",
        expD: "Тестирование UI не связано с проверкой данных для ИИ-систем.",
        points: 1,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K1"
      },
      {
        id: 123,
        text: "Что верно про тестирование ML-модели?",
        options: [
          "Проверяет показатели работы модели",
          "Заменяет все другие виды тестирования",
          "Использует только обучающие данные",
          "Делает валидацию ненужной"
        ],
        correct: 0,
        expA: "Точно! Тестирование модели проверяет точность, полноту и другие показатели её работы.",
        expB: "Тестирование модели — это лишь один из видов проверки, а не замена всего остального.",
        expC: "Для проверки модели используют именно тестовые данные, а не те, на которых она училась.",
        expD: "Валидация по-прежнему нужна вместе с тестированием модели.",
        points: 2,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 124,
        text: "Какое тестирование в первую очередь проверяет связи между компонентами?",
        options: [
          "Компонентное тестирование",
          "Интеграционное тестирование", 
          "Системное тестирование",
          "Приемочное тестирование"
        ],
        correct: 1,
        expA: "Компонентное тестирование проверяет отдельные части, а не их связи.",
        expB: "Правильно! Интеграционное тестирование специально проверяет, как компоненты работают друг с другом.",
        expC: "Системное тестирование смотрит на всю систему целиком, но не специализируется на связях.",
        expD: "Приемочное тестирование проверяет соответствие бизнес-требованиям, а не технические связи.",
        points: 1,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 125,
        text: "Что характерно для системного тестирования ИИ-систем?",
        options: [
          "Проверяет ИИ-компоненты по отдельности",
          "Тестирует систему в рабочих условиях",
          "Изучает только ML-алгоритмы",
          "Игнорирует нефункциональные требования"
        ],
        correct: 1,
        expA: "Системное тестирование работает с полной собранной системой, а не с отдельными частями.",
        expB: "Именно! Системное тестирование проверяет всю систему в условиях, похожих на реальные.",
        expC: "Системное тестирование охватывает все аспекты системы, не только алгоритмы.",
        expD: "Нефункциональные требования — важная часть системного тестирования.",
        points: 2,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 126,
        text: "Какими должны быть тестовые данные для ИИ-систем?",
        options: [
          "Копировать структуру обучающих данных",
          "Быть разнообразными и качественными",
          "Максимизировать объем любой ценой",
          "Отражать исторические паттерны данных"
        ],
        correct: 1,
        expA: "Тестовые данные должны отличаться от обучающих, чтобы честно проверить систему.",
        expB: "Правильно! Тестовые данные должны быть разными, качественными и хорошо представлять реальность.",
        expC: "Качество и разнообразие важнее простого количества данных.",
        expD: "Исторические паттерны могут не отражать текущую реальность системы.",
        points: 1,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 127,
        text: "Что такое автоматическое смещение в ИИ-системах?",
        options: [
          "Автонастройка параметров системы",
          "Слепое доверие автоматическим решениям",
          "Автоисправление ошибок в данных",
          "Автообновление модели в продакшене"
        ],
        correct: 1,
        expA: "Автоматическое смещение не связано с настройкой параметров системы.",
        expB: "Точно! Это когда люди слишком доверяют автоматике и перестают её критически проверять.",
        expC: "Автоматическое смещение — это про психологию людей, а не техническую функцию.",
        expD: "Обновления модели — отдельная функция, не связанная со смещением.",
        points: 1,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 128,
        text: "Что важнее всего включить в документацию ИИ-компонента?",
        options: [
          "Только цифры производительности",
          "Данные, ограничения и поведение",
          "Только описание алгоритмов",
          "Только информацию об обучении"
        ],
        correct: 1,
        expA: "Цифры производительности важны, но недостаточны для понимания компонента.",
        expB: "Правильно! Хорошая документация описывает данные, ограничения и то, как компонент себя ведет.",
        expC: "Описание алгоритмов полезно, но это только часть нужной информации.",
        expD: "Информация об обучении важна, но составляет лишь часть полной документации.",
        points: 2,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 129,
        text: "Что означает дрейф концепций в ИИ-системах?",
        options: [
          "Смена алгоритма обучения модели",
          "Изменение закономерностей в данных",
          "Смена пользовательского интерфейса",
          "Смена железа и конфигураций"
        ],
        correct: 1,
        expA: "Дрейф концепций касается данных, а не смены алгоритмов.",
        expB: "Верно! Дрейф происходит, когда меняются статистические закономерности в данных с течением времени.",
        expC: "Смена интерфейса не имеет отношения к дрейфу концепций.",
        expD: "Смена железа не вызывает дрейф концепций в данных.",
        points: 1,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 130,
        text: "При выборе подхода к тестированию ML-системы что важнее всего учесть?",
        options: [
          "Только бюджет на тестирование",
          "Риски, данные и важность системы",
          "Только мнение команды разработки",
          "Только сроки проекта"
        ],
        correct: 1,
        expA: "Бюджет важен, но не должен быть единственным критерием выбора.",
        expB: "Правильно! Подход должен учитывать риски, типы данных и то, насколько критична система.",
        expC: "Мнение команды важно, но должно основываться на технических требованиях.",
        expD: "Сроки важны, но не должны угрожать качеству тестирования.",
        points: 2,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 131,
        text: "Как лучше тестировать критически важные ИИ-системы?",
        options: [
          "Комплексно на всех уровнях",
          "Минимально, чтобы быстрее запустить",
          "Только на боевых данных",
          "Только автоматизированно"
        ],
        correct: 0,
        expA: "Правильно! Такие системы нужно тестировать комплексно на всех уровнях ради безопасности.",
        expB: "Критически важные системы требуют тщательного тестирования, а не минимального.",
        expC: "Тестирование только на боевых данных может пропустить важные сценарии.",
        expD: "Критически важные системы требуют сочетания автоматизированного и ручного тестирования.",
        points: 2,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 132,
        text: "Что важнее всего при тестировании данных реального времени?",
        options: [
          "Только проверка формата данных",
          "Контроль качества, полноты и актуальности",
          "Игнорирование странных данных",
          "Только количество данных"
        ],
        correct: 1,
        expA: "Формат важен, но это только один аспект из многих.",
        expB: "Точно! Данные реального времени нужно проверять на качество, полноту и актуальность.",
        expC: "Странные данные могут серьезно повлиять на работу ИИ-системы, их нельзя игнорировать.",
        expD: "Количество важно, но качество и актуальность критичнее для систем реального времени.",
        points: 2,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 133,
        text: "Компания внедряет медицинскую диагностическую ИИ-систему. Как её лучше тестировать?",
        options: [
          "Приоритизировать быстродействие с базовыми проверками безопасности",
          "Строго тестировать с упором на безопасность",
          "Тестировать преимущественно на типичных медицинских случаях",
          "Использовать синтетические данные для начального тестирования"
        ],
        correct: 1,
        expA: "Быстродействие важно, но безопасность пациентов - критический приоритет.",
        expB: "Именно так! Медицинские ИИ-системы нужно строго тестировать ради безопасности пациентов.",
        expC: "Медицинские системы должны проверяться на широком спектре случаев, включая редкие.",
        expD: "Синтетические данные полезны, но реальные медицинские данные критичны для валидации.",
        points: 3,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 134,
        text: "При тестировании автономной ИИ-системы что сложнее всего?",
        options: [
          "Валидация пользовательских сценариев взаимодействия",
          "Тестирование непредсказуемых решений",
          "Верификация производительности в реальном времени",
          "Анализ граничных условий работы датчиков"
        ],
        correct: 1,
        expA: "Пользовательские сценарии важны, но предсказуемость решений - более фундаментальная проблема.",
        expB: "Правильно! Автономные системы принимают непредсказуемые решения, что очень сложно протестировать.",
        expC: "Производительность критична, но непредсказуемость поведения - главный вызов автономности.",
        expD: "Граничные условия важны, но непредсказуемые решения системы - более сложная проблема.",
        points: 3,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 135,
        text: "Банк внедряет ИИ-систему для оценки кредитных рисков. Что критично протестировать?",
        options: [
          "Производительность системы при пиковых нагрузках",
          "Справедливость принимаемых решений",
          "Интеграцию с существующими банковскими системами",
          "Скорость обработки заявок в различных сценариях"
        ],
        correct: 1,
        expA: "Производительность важна, но справедливость решений критична для финансовых систем.",
        expB: "Правильно! Финансовые ИИ-системы нужно проверять на справедливость и отсутствие дискриминации.",
        expC: "Интеграция важна, но этические аспекты решений критичнее для кредитных систем.",
        expD: "Скорость важна, но справедливость решений - приоритет для регулируемых финансовых систем.",
        points: 3,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 136,
        text: "При интеграции ИИ-системы с корпоративными системами что важнее всего протестировать?",
        options: [
          "Только новые функции ИИ",
          "Потоки данных между системами",
          "Только пользовательские интерфейсы",
          "Только скорость работы баз данных"
        ],
        correct: 1,
        expA: "Проверка только новых функций игнорирует критически важные связи между системами.",
        expB: "Правильно! При интеграции ключевое — это проверка потоков данных и совместимости систем.",
        expC: "Интерфейсы важны, но не главное в интеграционном тестировании.",
        expD: "Скорость БД важна, но интеграция требует более широкого подхода.",
        points: 3,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 137,
        text: "Команда обнаружила дрейф концепций в рабочей ИИ-системе. Как лучше действовать?",
        options: [
          "Проигнорировать до следующего релиза",
          "Настроить постоянный мониторинг и адаптивное тестирование",
          "Переобучить модель один раз",
          "Просто увеличить размер тестовых данных"
        ],
        correct: 1,
        expA: "Игнорирование дрейфа может привести к серьезному ухудшению работы системы.",
        expB: "Отлично! Дрейф концепций требует постоянного мониторинга и адаптивного тестирования.",
        expC: "Однократное переобучение не решит проблему продолжающегося дрейфа.",
        expD: "Размер данных менее важен, чем стратегия обнаружения и реагирования на дрейф.",
        points: 3,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 138,
        text: "Что лучше всего описывает приемочное тестирование ИИ-систем?",
        options: [
          "Проверка соответствия бизнес-требованиям",
          "Проверка только технических характеристик",
          "Изучение только скорости алгоритмов",
          "Тестирование только в лабораторных условиях"
        ],
        correct: 0,
        expA: "Точно! Приемочное тестирование проверяет, соответствует ли система бизнес-требованиям и ожиданиям пользователей.",
        expB: "Приемочное тестирование охватывает бизнес-аспекты, а не только технические параметры.",
        expC: "Скорость алгоритмов — лишь один аспект, приемочное тестирование гораздо шире.",
        expD: "Приемочное тестирование должно проходить в условиях, максимально близких к реальным.",
        points: 2,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 139,
        text: "При тестировании системы обработки естественного языка что важнее всего учесть?",
        options: [
          "Только правильность грамматики",
          "Языковое разнообразие и культурные особенности",
          "Только скорость обработки текстов",
          "Только размер используемого словаря"
        ],
        correct: 1,
        expA: "Грамматика важна, но NLP-системы должны понимать гораздо более широкий контекст.",
        expB: "Правильно! NLP-системы нужно тестировать на языковом разнообразии и культурных нюансах.",
        expC: "Скорость важна, но понимание языка критичнее для качества системы.",
        expD: "Размер словаря влияет на возможности, но не определяет качество понимания языка.",
        points: 2,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 140,
        text: "Компания создает ИИ-систему для умных городов. Как её лучше тестировать?",
        options: [
          "Тестировать только в офисных условиях",
          "Комплексно тестировать с симуляцией городских сценариев",
          "Изучать только один вид городских служб",
          "Использовать только старые исторические данные"
        ],
        correct: 1,
        expA: "Офисные условия не могут воспроизвести сложность реальных городских условий.",
        expB: "Отлично! Системы умных городов требуют комплексного тестирования с реалистичной симуляцией.",
        expC: "Умные города включают множество взаимосвязанных служб, нужно тестировать их взаимодействие.",
        expD: "Городские системы должны адаптироваться к изменениям, а не только к историческим данным.",
        points: 3,
        chapter: "Обзор тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 141,
        text: "Что из перечисленного с НАИБОЛЬШЕЙ ВЕРОЯТНОСТЬЮ создает проблемы при тестировании самообучающихся систем? Выберите ОДИН ответ.",
        options: [
          "Динамические требования к адаптации данных",
          "Изменяющееся поведение системы",
          "Ограниченные вычислительные ресурсы для обучения",
          "Эволюционные алгоритмы выполнения тестов"
        ],
        correct: 1,
        expA: "Адаптация данных - важная задача, но основная проблема в непредсказуемости эволюции поведения.",
        expB: "Точно! Самообучающиеся системы изменяют свое поведение на основе новых данных, что делает традиционные подходы к тестированию недостаточными.",
        expC: "Ресурсы важны для обучения, но главный вызов - в тестировании изменяющегося поведения.",
        expD: "Эволюционные алгоритмы тестирования могут помочь, но проблема в непредсказуемости самой системы.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 142,
        text: "Какое из утверждений об алгоритмическом смещении ПРАВИЛЬНОЕ? Выберите ОДИН ответ.",
        options: [
          "Оно вызывает систематическую несправедливость в решениях",
          "Оно создает случайные ошибки алгоритма",
          "Оно влияет на скорость обработки данных",
          "Оно воздействует на распределение памяти"
        ],
        correct: 0,
        expA: "Верно! Алгоритмическое смещение означает систематическую дискриминацию или несправедливость в решениях ИИ, часто отражающую паттерны исторических данных.",
        expB: "Случайные ошибки - это баги, а не смещение. Смещение - это систематическая и предсказуемая несправедливость.",
        expC: "Вариации скорости - это проблемы производительности, никак не связанные со смещением в принятии решений.",
        expD: "Проблемы с памятью - это технические неполадки, а не вопросы, связанные со смещением.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K1"
      },
      {
        id: 143,
        text: "Какой из подходов ЛУЧШЕ всего подходит для тестирования автономных систем ИИ? Выберите ОДИН ответ.",
        options: [
          "Предварительно разработанные тестовые сценарии",
          "Контролируемое наблюдение за работой системы",
          "Симуляция с экстремальными случаями",
          "Сокращенное тестовое покрытие с фокусом на основное"
        ],
        correct: 2,
        expA: "Предварительные сценарии полезны, но автономные системы требуют адаптивного тестирования непредвиденных ситуаций.",
        expB: "Наблюдение важно для мониторинга, но не заменяет активного тестирования критических сценариев.",
        expC: "Правильно! Среды симуляции позволяют безопасно тестировать экстремальные случаи и неожиданные сценарии для автономных систем.",
        expD: "Сокращенное покрытие недостаточно - автономные системы требуют комплексного тестирования.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 144,
        text: "Что из перечисленного ЛУЧШЕ всего описывает смещение выборки в обучающих данных машинного обучения? Выберите ОДИН ответ.",
        options: [
          "Данные не представляют целевую группу пользователей",
          "Данные содержат технические ошибки валидации",
          "Данные обрабатываются с недостаточной скоростью",
          "Данные требуют больше ресурсов для хранения"
        ],
        correct: 0,
        expA: "Точно! Смещение выборки возникает, когда обучающие данные не отражают реальную группу пользователей, которую модель будет обслуживать.",
        expB: "Технические ошибки валидации - это проблемы качества данных, но не смещение репрезентативности выборки.",
        expC: "Скорость обработки - это вопрос производительности, не связанный с репрезентативностью выборки данных.",
        expD: "Объем хранения - это техническое ограничение инфраструктуры, а не характеристика смещения выборки.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 145,
        text: "При тестировании на недопустимое смещение какой подход является приоритетным? Выберите ОДИН ответ.",
        options: [
          "Тестирование производительности алгоритмических операций",
          "Анализ результатов для разных демографических групп",
          "Валидация временных характеристик обработки запросов",
          "Проверка архитектурной совместимости компонентов"
        ],
        correct: 1,
        expA: "Производительность операций важна для эффективности, но смещение касается справедливости решений между группами.",
        expB: "Верно! Тестирование на недопустимое смещение требует анализа того, как система работает с различными группами людей.",
        expC: "Временные характеристики важны для пользовательского опыта, но не связаны с обнаружением смещения.",
        expD: "Совместимость компонентов критична для интеграции, но смещение связано с данными и алгоритмами принятия решений.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 146,
        text: "Что является основной характеристикой автономной системы при тестировании? Выберите ОДИН ответ.",
        options: [
          "Высокая пропускная способность базы данных",
          "Способность принимать решения самостоятельно",
          "Масштабируемость веб-сервисов",
          "Оптимизация алгоритмов сортировки"
        ],
        correct: 1,
        expA: "Пропускная способность БД важна для производительности, но не определяет автономность системы принятия решений.",
        expB: "Именно! Автономность означает способность системы принимать решения и действовать независимо без постоянного человеческого вмешательства.",
        expC: "Масштабируемость веб-сервисов относится к архитектуре приложений, а не к автономности ИИ-систем.",
        expD: "Оптимизация сортировки - это техническая задача алгоритмов, не связанная с автономностью принятия решений.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K1"
      },
      {
        id: 147,
        text: "Какой подход ЭФФЕКТИВНЕЕ всего для тестирования прозрачности системы ИИ? Выберите ОДИН ответ.",
        options: [
          "Измерение производительности алгоритмических вычислений",
          "Анализ временных характеристик выполнения",
          "Проверка объяснимости принимаемых решений",
          "Оценка потребления вычислительных ресурсов"
        ],
        correct: 2,
        expA: "Производительность вычислений важна для эффективности, но прозрачность касается понимания логики принятия решений.",
        expB: "Временные характеристики - это метрики производительности, не связанные с прозрачностью логики работы системы.",
        expC: "Правильно! Прозрачность лучше всего тестируется через проверку того, можно ли понять и объяснить, как система приняла решение.",
        expD: "Потребление ресурсов - это техническая характеристика эффективности, а прозрачность касается понятности процесса принятия решений.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 148,
        text: "При тестировании интерпретируемости какой аспект наиболее важен? Выберите ОДИН ответ.",
        options: [
          "Скорость процесса обучения модели",
          "Размер архитектуры модели",
          "Понятность внутренней логики модели",
          "Количество входных параметров модели"
        ],
        correct: 2,
        expA: "Скорость обучения важна для эффективности разработки, но интерпретируемость касается понимания готовой модели.",
        expB: "Размер модели влияет на производительность и сложность, но интерпретируемость связана с понятностью логики работы.",
        expC: "Именно! Интерпретируемость означает способность понять, как модель принимает решения и какие факторы влияют на результат.",
        expD: "Количество параметров влияет на сложность модели, но интерпретируемость зависит от понятности логики принятия решений.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 149,
        text: "Какой фактор НАИБОЛЕЕ существенно влияет на тестирование системы с непредсказуемым поведением? Выберите ОДИН ответ.",
        options: [
          "Вариативность результатов для идентичных входных данных",
          "Высокие требования к вычислительным ресурсам",
          "Сложность процессов обработки информации",
          "Большие объемы входных данных для обработки"
        ],
        correct: 0,
        expA: "Именно! Системы с непредсказуемым поведением выдают разные результаты для одинаковых входов, что затрудняет создание воспроизводимых тестов.",
        expB: "Вычислительные ресурсы важны для производительности, но главная проблема - в непредсказуемости результатов для тестирования.",
        expC: "Сложность обработки влияет на архитектуру, но непредсказуемость создает основные проблемы для воспроизводимости тестов.",
        expD: "Объем данных - это вопрос масштабируемости, а непредсказуемость касается вариативности результатов тестирования.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 150,
        text: "При тестировании вероятностных систем какая стратегия создания тестового оракула оптимальна? Выберите ОДИН ответ.",
        options: [
          "Точное сравнение ожидаемых результатов",
          "Статистический анализ распределения выходных данных",
          "Детерминированные критерии оценки",
          "Фиксированные пороговые значения для всех случаев"
        ],
        correct: 1,
        expA: "Точное сравнение невозможно для вероятностных систем, которые выдают разные результаты для идентичных входов.",
        expB: "Правильно! Вероятностные системы требуют статистического анализа для оценки качества и корректности выходных данных.",
        expC: "Детерминированные критерии не подходят для систем, которые по природе работают с вероятностями и неопределенностью.",
        expD: "Фиксированные пороги слишком упрощены для вероятностных систем, требующих статистической оценки распределений.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 151,
        text: "Какой подход ЛУЧШЕ всего подходит для тестирования вероятностных систем? Выберите ОДИН ответ.",
        options: [
          "Точное сравнение результатов с эталоном",
          "Статистический анализ выходных данных",
          "Детерминированные тест-кейсы с фиксированными ожиданиями",
          "Фиксированные пороговые значения для всех сценариев"
        ],
        correct: 1,
        expA: "Точное сравнение невозможно, когда системы выдают разные результаты для одинаковых входов по своей природе.",
        expB: "Правильно! Вероятностные системы требуют статистического анализа для оценки качества и корректности выходных данных.",
        expC: "Детерминированные тест-кейсы не подходят для систем, которые работают с вероятностями и неопределенностью.",
        expD: "Фиксированные пороги слишком упрощены для вероятностных систем, требующих статистической оценки.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 152,
        text: "При создании тестового оракула для систем ИИ что представляет наибольшую сложность? Выберите ОДИН ответ.",
        options: [
          "Определение ожидаемых результатов для новых входных данных",
          "Измерение производительности и временных характеристик системы",
          "Создание репрезентативных тестовых наборов данных",
          "Настройка и конфигурирование тестовой инфраструктуры"
        ],
        correct: 0,
        expA: "Именно! Для систем ИИ часто сложно определить \"правильный\" ответ, особенно для новых или неожиданных входных данных.",
        expB: "Измерение производительности - стандартная задача тестирования, не специфичная именно для проблемы оракула в ИИ.",
        expC: "Создание тестовых данных важно для качества тестирования, но проблема оракула касается определения ожидаемых результатов.",
        expD: "Настройка инфраструктуры - техническая задача, а проблема оракула касается определения правильности результатов ИИ.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 153,
        text: "Компания разрабатывает систему ИИ для критически важных приложений. Какой подход к тестированию наиболее подходящий? Выберите ОДИН ответ.",
        options: [
          "Приоритизировать функциональные тесты с базовой проверкой качества",
          "Ускоренное тестирование с фокусом на основные сценарии",
          "Комплексное тестирование всех характеристик качества",
          "Тестирование в продакшене с постепенным мониторингом"
        ],
        correct: 2,
        expA: "Приоритизация функциональных тестов недостаточна для критически важных систем - нужно тестировать все аспекты качества.",
        expB: "Ускоренное тестирование может пропустить критические проблемы в системах, где ошибки имеют серьезные последствия.",
        expC: "Правильно! Критически важные системы требуют всестороннего тестирования безопасности, надежности, справедливости и других характеристик качества.",
        expD: "Тестирование в продакшене слишком рискованно для критически важных систем - основное тестирование должно быть до развертывания.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 154,
        text: "В чем ключевое различие между интерпретируемостью и объяснимостью при тестировании? Выберите ОДИН ответ.",
        options: [
          "Интерпретируемость - внутренняя ясность модели, объяснимость - понятность для пользователей",
          "Интерпретируемость обеспечивает быстродействие, объяснимость повышает точность",
          "Отсутствуют различия - это взаимозаменяемые синонимы",
          "Интерпретируемость предназначена для экспертов, объяснимость для начинающих"
        ],
        correct: 0,
        expA: "Верно! Интерпретируемость касается того, насколько понятна внутренняя логика модели, а объяснимость - способности предоставить понятные объяснения пользователям.",
        expB: "Оба понятия никак не связаны со скоростью или точностью - они касаются разных аспектов понимания ИИ-систем.",
        expC: "Это разные концепции: интерпретируемость - внутреннее свойство модели, объяснимость - внешняя коммуникация с пользователями.",
        expD: "Разделение по уровню экспертизы неточно - оба понятия применимы к разным аспектам понимания системы.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 155,
        text: "Медицинское учреждение тестирует систему ИИ для диагностики. Какой аспект наиболее критичен? Выберите ОДИН ответ.",
        options: [
          "Скорость формирования диагностических заключений",
          "Удобство и интуитивность пользовательского интерфейса",
          "Объяснимость диагностических решений",
          "Эффективность потребления серверных ресурсов"
        ],
        correct: 2,
        expA: "Скорость важна для эффективности медицинской практики, но объяснимость критична для доверия врачей и безопасности пациентов.",
        expB: "Удобство интерфейса важно для пользовательского опыта, но объяснимость диагнозов - основа медицинской ответственности.",
        expC: "Именно! В медицине врачи должны понимать, почему система приняла определенное диагностическое решение для обеспечения безопасности пациентов.",
        expD: "Эффективность ресурсов важна для эксплуатации, но объяснимость - критический фактор клинической безопасности.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 156,
        text: "Организация внедряет автономную систему в производственной среде. Какая стратегия тестирования оптимальна? Выберите ОДИН ответ.",
        options: [
          "Тщательное тестирование взаимодействий с существующими системами",
          "Изолированное тестирование функций новой системы",
          "Фокус на валидации пользовательского интерфейса",
          "Поэтапное тестирование интеграции с постепенным расширением"
        ],
        correct: 0,
        expA: "Правильно! Автономные системы в производственной среде должны тщательно тестироваться на взаимодействие с существующими системами для обеспечения совместимости.",
        expB: "Изолированное тестирование недостаточно - не покажет, как автономная система будет работать в реальной среде с другими системами.",
        expC: "Интерфейс важен для взаимодействия, но для автономных систем критично тестирование системных взаимодействий и интеграции.",
        expD: "Поэтапный подход полезен, но приоритет должен быть на тщательности тестирования взаимодействий, а не только на постепенности.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 157,
        text: "При тестировании системы ИИ на смещение выборки что наиболее важно проверить? Выберите ОДИН ответ.",
        options: [
          "Общий размер обучающего набора данных",
          "Репрезентативность данных для всех групп пользователей",
          "Скорость обработки различных типов входных данных",
          "Формат структурированного хранения данных"
        ],
        correct: 1,
        expA: "Размер данных важен для качества обучения модели, но смещение выборки касается именно репрезентативности различных групп.",
        expB: "Именно! Смещение выборки возникает, когда обучающие данные не представляют все группы пользователей равномерно и справедливо.",
        expC: "Скорость обработки - это технический аспект производительности, не связанный с качеством репрезентативности данных для разных групп.",
        expD: "Формат хранения важен для технической реализации системы, но не влияет на смещение репрезентативности выборки данных.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 158,
        text: "Банк тестирует систему ИИ для кредитных решений. Какой аспект требует наибольшего внимания? Выберите ОДИН ответ.",
        options: [
          "Справедливость решений для всех групп заявителей",
          "Производительность обработки при пиковых нагрузках",
          "Интеграционная совместимость с банковскими системами",
          "Оптимизация вычислительных ресурсов для экономии затрат"
        ],
        correct: 0,
        expA: "Верно! В финансовых решениях справедливость и отсутствие дискриминации - критические требования для соблюдения законодательства и этических норм.",
        expB: "Производительность важна для пользовательского опыта, но справедливость решений критична для соответствия регулятивным требованиям.",
        expC: "Интеграционная совместимость необходима для функционирования, но справедливость решений - приоритет для регулируемых финансовых систем.",
        expD: "Оптимизация затрат важна для бизнеса, но справедливость решений - фундаментальное требование для финансовых ИИ-систем.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 159,
        text: "Команда тестирует систему ИИ, которая обучается на основе пользовательских взаимодействий. Какой подход критичен для контроля качества? Выберите ОДИН ответ.",
        options: [
          "Увеличение частоты релизов системы",
          "Непрерывный мониторинг поведения и адаптивные критерии оценки",
          "Уменьшение размера тестовой команды",
          "Стандартизация процессов тестирования без изменений"
        ],
        correct: 1,
        expA: "Частота релизов может помочь с обновлениями, но не решает проблему контроля качества эволюционирующей системы.",
        expB: "Правильно! Системы, которые обучаются в процессе работы, требуют непрерывного мониторинга и адаптивных критериев для контроля качества.",
        expC: "Уменьшение команды может снизить качество контроля, что критично для систем, обучающихся на пользовательских данных.",
        expD: "Стандартизация без адаптации неэффективна для систем, которые эволюционируют на основе пользовательских взаимодействий.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 160,
        text: "При тестировании вероятностной системы ИИ какой подход к созданию тестового оракула является оптимальным? Выберите ОДИН ответ.",
        options: [
          "Требование точного совпадения всех выходных данных",
          "Применение статистических критериев приемлемости результатов",
          "Измерение времени выполнения операций системы",
          "Использование детерминированных бинарных критериев оценки"
        ],
        correct: 1,
        expA: "Точное совпадение невозможно для вероятностных систем, которые выдают разные результаты для идентичных входных данных.",
        expB: "Именно! Вероятностные системы требуют статистических методов проверки вместо точного сравнения результатов для корректной оценки.",
        expC: "Время выполнения - метрика производительности, никак не связанная с проверкой корректности вероятностных результатов системы.",
        expD: "Детерминированные критерии слишком упрощены для вероятностных систем, которым нужна статистическая оценка распределений.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 161,
        text: "Что ЛУЧШЕ всего описывает адверсариальные примеры в контексте ИИ? Выберите ОДИН вариант.",
        options: [
          "Компоненты фронтенд-фреймворка React для пользовательского интерфейса",
          "Специально модифицированные входы для обмана ИИ-моделей",
          "Конфигурационные файлы Docker-контейнеров для развертывания",
          "Индексированные таблицы в реляционной базе данных PostgreSQL"
        ],
        correct: 1,
        expA: "React — это JavaScript библиотека для создания пользовательских интерфейсов, не связанная с безопасностью ИИ.",
        expB: "Точно! Адверсариальные примеры — это умышленно искаженные входные данные, разработанные для введения ИИ-систем в заблуждение.",
        expC: "Docker используется для контейнеризации приложений, что не относится к тестированию уязвимостей ИИ.",
        expD: "Индексы баз данных помогают с производительностью запросов, но не связаны с атаками на модели ИИ.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K1"
      },
      {
        id: 162,
        text: "Что ПРАВИЛЬНО описывает отравление данных в машинном обучении? Выберите ОДИН вариант.",
        options: [
          "Оптимизация производительности SQL-запросов в PostgreSQL",
          "Настройка кэширования данных в системе Redis",
          "Внедрение вредоносных данных в обучающую выборку модели",
          "Синхронизация данных между распределенными серверами"
        ],
        correct: 2,
        expA: "Оптимизация SQL относится к управлению базами данных, а не к безопасности машинного обучения.",
        expB: "Redis-кэширование улучшает скорость доступа к данным, но не связано с атаками на модели ИИ.",
        expC: "Правильно! Отравление данных происходит когда злоумышленники добавляют испорченные примеры в обучающий набор для компрометации модели.",
        expD: "Репликация данных — это техника обеспечения надежности, не связанная с атаками на ИИ.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K1"
      },
    
      // ============================================================================
      // K2 QUESTIONS (7) - AI DOMAIN WITH SUBTLE DISTINCTIONS
      // ============================================================================
      {
        id: 163,
        text: "Что НАИБОЛЕЕ точно описывает парное тестирование для ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Тестирует абсолютно все возможные комбинации входных параметров",
          "Обеспечивает покрытие каждой пары значений входных параметров",
          "Создает пары состязательных примеров для атак на модель",
          "Сравнивает производительность двух различных алгоритмов машинного обучения"
        ],
        correct: 1,
        expA: "Парное тестирование как раз экономит ресурсы, избегая полного комбинаторного взрыва всех вариантов.",
        expB: "Верно! Парное тестирование гарантирует, что каждая пара входных значений протестирована хотя бы один раз, балансируя покрытие и эффективность.",
        expC: "Состязательные примеры — это отдельная техника безопасности, не связанная с комбинаторным тестированием.",
        expD: "Сравнение алгоритмов — это задача бенчмаркинга, а не структурного тестирования входных комбинаций.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 164,
        text: "Какое утверждение о сравнительном тестировании ПРАВИЛЬНОЕ? Выберите ОДИН вариант.",
        options: [
          "Сравнивает результаты различных версий одной и той же модели",
          "Использует параллельные независимые реализации для взаимной верификации",
          "Фокусируется исключительно на измерении производительности различных алгоритмов",
          "Проверяет модели только на абсолютно идентичных наборах данных"
        ],
        correct: 1,
        expA: "Версионное сравнение — это регрессионное тестирование, а не классическое сравнительное тестирование.",
        expB: "Точно! Сравнительное тестирование использует независимые реализации одной функциональности для обнаружения расхождений и ошибок.",
        expC: "Производительность — только один аспект; сравнительное тестирование также проверяет корректность и согласованность результатов.",
        expD: "Эффективное сравнительное тестирование требует разнообразных наборов данных для выявления различий в поведении.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 165,
        text: "Что характеризует A/B тестирование в контексте ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Сравнивает две версии модели на реальных пользователях",
          "Автоматически переключается между алгоритмами в зависимости от нагрузки",
          "Тестирует модель поочередно на обучающих и валидационных данных",
          "Измеряет производительность алгоритма в двух различных вычислительных средах"
        ],
        correct: 0,
        expA: "Правильно! A/B тестирование сравнивает поведение разных версий системы ИИ на живых пользователях для оценки бизнес-метрик.",
        expB: "Адаптивная балансировка нагрузки — это техника производительности, а не методология сравнительного тестирования.",
        expC: "Разделение на обучающую/валидационную выборки — это стандартная практика ML, не специфичная для A/B тестирования.",
        expD: "Тестирование среды — это проверка инфраструктуры, а не пользовательского опыта и бизнес-результатов.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 166,
        text: "В чем основная ценность тестирования на основе опыта для ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Выявляет проблемы в областях с известными рисками и паттернами отказов",
          "Автоматически генерирует исчерпывающие наборы тестовых данных",
          "Заменяет потребность в структурированных техниках тестирования",
          "Гарантирует полное покрытие всех возможных сценариев использования"
        ],
        correct: 0,
        expA: "Верно! Опытные тестировщики могут предсказать проблемные области на основе знаний о типичных слабых местах ИИ-систем.",
        expB: "Автоматическая генерация тестов — это отдельная техника; тестирование на основе опыта полагается на человеческую экспертизу.",
        expC: "Опытное тестирование дополняет, а не заменяет систематические подходы к тестированию.",
        expD: "Никакая техника тестирования не может гарантировать абсолютно полное покрытие всех возможных сценариев.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 167,
        text: "Что отличает метаморфическое тестирование от традиционных подходов? Выберите ОДИН вариант.",
        options: [
          "Использует формальные математические доказательства корректности алгоритмов",
          "Проверяет отношения между различными входами и соответствующими выходами",
          "Фокусируется исключительно на тестировании граничных значений входных данных",
          "Требует точного знания ожидаемых выходных значений для всех тестов"
        ],
        correct: 1,
        expA: "Формальная верификация — это отдельная область; метаморфическое тестирование основано на эмпирических свойствах.",
        expB: "Точно! Метаморфическое тестирование проверяет, что определенные отношения между входами сохраняются в выходных данных, решая проблему оракула.",
        expC: "Граничные значения — лишь один аспект; метаморфическое тестирование может применяться к широкому диапазону входных отношений.",
        expD: "Главное преимущество метаморфического тестирования — оно работает даже когда точные ожидаемые результаты неизвестны.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 168,
        text: "Какую проблему решает метаморфическое тестирование в ИИ-системах? Выберите ОДИН вариант.",
        options: [
          "Недостаток вычислительных ресурсов для обучения больших моделей",
          "Отсутствие надежного тестового оракула для сложных задач",
          "Ограниченную скорость выполнения алгоритмов машинного обучения",
          "Сложность интеграции различных компонентов ИИ-системы"
        ],
        correct: 1,
        expA: "Вычислительные ресурсы — это ограничение инфраструктуры, а не проблема, решаемая метаморфическим тестированием.",
        expB: "Правильно! Метаморфическое тестирование решает проблему оракула, когда трудно определить правильный ответ для сложных ИИ-задач.",
        expC: "Производительность алгоритмов — отдельная проблема оптимизации, не связанная с верификацией корректности.",
        expD: "Интеграционные сложности решаются архитектурными и инженерными подходами, не техниками тестирования оракула.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 169,
        text: "Как лучше всего выбрать подходящие техники тестирования для ИИ-системы? Выберите ОДИН вариант.",
        options: [
          "Проанализировать характеристики системы и связанные риски",
          "Использовать только самые современные и передовые техники",
          "Применить все доступные техники тестирования одновременно",
          "Выбрать техники исключительно на основе скорости их выполнения"
        ],
        correct: 0,
        expA: "Точно! Систематический анализ характеристик системы и рисков позволяет выбрать наиболее подходящие и эффективные техники тестирования.",
        expB: "Передовые техники не всегда оптимальны для конкретных систем; выбор должен соответствовать специфическим потребностям.",
        expC: "Применение всех техник неэффективно и может не решать специфические риски данной системы.",
        expD: "Скорость выполнения не должна быть единственным критерием, особенно когда важны безопасность и надежность.",
        points: 1,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K2"
      },
    
      // ============================================================================
      // K3 QUESTIONS (6) - PROFESSIONAL APPROACHES STRATEGY
      // ============================================================================
      {
        id: 170,
        text: "Какой подход НАИБОЛЕЕ эффективен для тестирования метаморфических свойств ИИ-системы? Выберите ОДИН вариант.",
        options: [
          "Создание входных данных с заранее известными математическими трансформациями",
          "Использование исключительно случайно сгенерированных тестовых наборов данных",
          "Применение методов статической верификации исходного кода модели",
          "Концентрация тестирования только на крайних граничных значениях"
        ],
        correct: 0,
        expA: "Верно! Известные трансформации позволяют предсказать ожидаемые отношения между входами и выходами, что является основой метаморфического тестирования.",
        expB: "Случайная генерация может пропустить важные метаморфические отношения, которые требуют структурированного подхода.",
        expC: "Статическая верификация анализирует код, но не проверяет динамическое поведение системы на различных входных данных.",
        expD: "Граничные значения важны, но метаморфические свойства должны выполняться в широком диапазоне входных данных.",
        points: 2,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 171,
        text: "При применении парного тестирования к ИИ-системе, какая стратегия наиболее целесообразна? Выберите ОДИН вариант.",
        options: [
          "Тестировать все возможные комбинации параметров для полноты покрытия",
          "Сосредоточиться на парах параметров с наибольшим потенциальным риском",
          "Использовать только автоматически сгенерированные комбинации параметров",
          "Ограничиться тестированием пар с наивысшей вычислительной эффективностью"
        ],
        correct: 1,
        expA: "Полное комбинаторное тестирование практически невозможно для сложных ИИ-систем из-за экспоненциального роста.",
        expB: "Правильно! Фокус на рискованных парах параметров максимизирует вероятность обнаружения критических дефектов при ограниченных ресурсах.",
        expC: "Автоматическая генерация без учета рисков может пропустить важные проблемные комбинации параметров.",
        expD: "Вычислительная эффективность важна, но не должна быть единственным критерием выбора тестовых комбинаций.",
        points: 2,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 172,
        text: "Как оптимально применить A/B тестирование для новой рекомендательной ИИ-системы? Выберите ОДИН вариант.",
        options: [
          "Развернуть новую систему для всех пользователей одновременно",
          "Использовать градуальное развертывание с мониторингом ключевых метрик",
          "Протестировать систему только на внутренних сотрудниках компании",
          "Сравнивать производительность исключительно на исторических данных"
        ],
        correct: 1,
        expA: "Полное развертывание рискованно и не позволяет сравнить с предыдущей версией системы.",
        expB: "Отлично! Постепенное развертывание позволяет контролировать риски и получить статистически значимые данные сравнения.",
        expC: "Внутреннее тестирование ограничено и может не отражать поведение реальных пользователей системы.",
        expD: "Исторические данные не показывают влияние на текущий пользовательский опыт и бизнес-метрики.",
        points: 2,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 173,
        text: "При тестировании на основе опыта для ИИ-системы, какой подход НАИБОЛЕЕ продуктивен? Выберите ОДИН вариант.",
        options: [
          "Полагаться исключительно на автоматизированные инструменты анализа",
          "Использовать знания доменных экспертов о типичных проблемах ИИ",
          "Сосредоточиться только на общих техниках тестирования программного обеспечения",
          "Применять случайное тестирование без структурированного подхода"
        ],
        correct: 1,
        expA: "Автоматизированные инструменты полезны, но не заменяют человеческую экспертизу в понимании специфических рисков ИИ.",
        expB: "Верно! Доменная экспертиза помогает сфокусироваться на областях, где ИИ-системы исторически показывают наибольшую уязвимость.",
        expC: "Общие техники важны, но ИИ-системы требуют специализированных подходов к тестированию.",
        expD: "Случайное тестирование менее эффективно чем целенаправленное использование экспертных знаний.",
        points: 2,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 174,
        text: "Какая стратегия ОПТИМАЛЬНА для интеграции сравнительного тестирования в процесс разработки ИИ? Выберите ОДИН вариант.",
        options: [
          "Создать параллельные реализации критически важной функциональности",
          "Сравнивать только финальные версии готовых моделей машинного обучения",
          "Использовать сравнительное тестирование исключительно для оценки производительности",
          "Применять сравнения только при обнаружении серьезных дефектов"
        ],
        correct: 0,
        expA: "Правильно! Параллельные реализации критической логики позволяют непрерывно выявлять расхождения и потенциальные проблемы в процессе разработки.",
        expB: "Сравнение только готовых моделей упускает возможности раннего обнаружения проблем в процессе разработки.",
        expC: "Сравнительное тестирование ценно не только для производительности, но и для корректности и надежности.",
        expD: "Реактивное применение менее эффективно чем проактивная интеграция в жизненный цикл разработки.",
        points: 2,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 175,
        text: "При выборе техник тестирования для автономной ИИ-системы, что НАИБОЛЕЕ важно учесть? Выберите ОДИН вариант.",
        options: [
          "Минимизацию времени выполнения всех тестовых сценариев",
          "Максимальное использование автоматизированных инструментов тестирования",
          "Соответствие техник специфическим рискам безопасности системы",
          "Покрытие наибольшего количества строк кода модели"
        ],
        correct: 2,
        expA: "Скорость тестирования важна, но безопасность автономных систем требует тщательного подхода, даже если это занимает больше времени.",
        expB: "Автоматизация полезна, но автономные системы требуют специализированного тестирования, которое может потребовать ручного анализа.",
        expC: "Точно! Автономные системы несут особые риски безопасности, и техники тестирования должны быть адаптированы для их выявления и смягчения.",
        expD: "Покрытие кода — полезная метрика, но для ИИ-систем важнее покрытие поведенческих сценариев и рисков.",
        points: 2,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K3"
      },
    
      // ============================================================================
      // K4 QUESTIONS (5) - COMPLEX STRATEGIC THINKING
      // ============================================================================
      {
        id: 176,
        text: "Какая стратегия ОПТИМАЛЬНА для комплексного тестирования системы ИИ-модерации контента? Выберите ОДИН вариант.",
        options: [
          "Фокус исключительно на оптимизации метрик точности и полноты",
          "Комбинированный подход A/B тестирования с анализом смещений и адверсариальными тестами",
          "Использование только автоматизированных инструментов анализа контента",
          "Применение базовых функциональных проверок без учета социальных факторов"
        ],
        correct: 1,
        expA: "Метрики точности важны, но недостаточны для справедливости и безопасности в различных социальных контекстах.",
        expB: "Отлично! Комплексный подход учитывает пользовательский опыт, справедливость алгоритмов и устойчивость к атакам — все критически важные аспекты.",
        expC: "Автоматизированные инструменты не могут полностью оценить культурные нюансы и контекстную справедливость модерации контента.",
        expD: "Базовое функциональное тестирование игнорирует специфические вызовы ИИ-систем в социально-чувствительных областях.",
        points: 3,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 177,
        text: "В сложной ИИ-системе с несколькими взаимодействующими моделями, какая стратегия ОПТИМАЛЬНА? Выберите ОДИН вариант.",
        options: [
          "Тестировать каждую модель изолированно без интеграционного тестирования",
          "Сконцентрироваться только на тестировании финального объединенного результата",
          "Использовать многоуровневую стратегию с компонентным и интеграционным тестированием",
          "Применить исключительно сквозное тестирование через пользовательский интерфейс"
        ],
        correct: 2,
        expA: "Изолированное тестирование пропускает критически важные проблемы взаимодействия между компонентами системы.",
        expB: "Тестирование только финального результата затрудняет локализацию проблем в сложной многокомпонентной архитектуре.",
        expC: "Правильно! Многоуровневый подход обеспечивает как качество отдельных компонентов, так и корректность их интеграции и взаимодействия.",
        expD: "Сквозное тестирование важно, но недостаточно для понимания поведения внутренних компонентов сложной системы.",
        points: 3,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 178,
        text: "При разработке стратегии тестирования для критически важной медицинской ИИ-системы, что ПРИОРИТЕТНО? Выберите ОДИН вариант.",
        options: [
          "Максимизация скорости развертывания для быстрого выхода на рынок",
          "Фокус исключительно на функциональных требованиях без учета этических аспектов",
          "Комплексная валидация безопасности, справедливости и клинической эффективности",
          "Минимизация затрат на тестирование для увеличения рентабельности"
        ],
        correct: 2,
        expA: "Скорость развертывания не должна компрометировать безопасность пациентов и качество медицинской помощи.",
        expB: "В медицинских системах этические аспекты, включая справедливость и предвзятость, критически важны для равного доступа к помощи.",
        expC: "Точно! Медицинские ИИ-системы требуют всесторонней валидации всех аспектов, влияющих на здоровье и безопасность пациентов.",
        expD: "В медицинской сфере безопасность и эффективность важнее экономических соображений.",
        points: 3,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 179,
        text: "Как ОПТИМАЛЬНО сбалансировать различные техники тестирования в масштабном ИИ-проекте? Выберите ОДИН вариант.",
        options: [
          "Использовать только самые передовые и сложные техники тестирования",
          "Применять исключительно автоматизированные решения для экономии времени",
          "Создать риск-ориентированную стратегию с адаптивным выбором техник",
          "Стандартизировать единый набор техник для всех компонентов системы"
        ],
        correct: 2,
        expA: "Передовые техники не всегда оптимальны для каждого компонента; выбор должен соответствовать специфическим рискам.",
        expB: "Полная автоматизация может пропустить тонкие проблемы, требующие человеческого анализа и экспертизы.",
        expC: "Правильно! Риск-ориентированный подход позволяет эффективно распределить ресурсы и выбрать наиболее подходящие техники для каждой ситуации.",
        expD: "Различные компоненты ИИ-системы имеют разные характеристики риска и требуют адаптированных подходов к тестированию.",
        points: 3,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 180,
        text: "Какой подход НАИБОЛЕЕ системен для выбора техник тестирования ИИ-системы? Выберите ОДИН вариант.",
        options: [
          "Применение всех доступных техник тестирования одновременно для максимального покрытия",
          "Систематический анализ характеристик системы с выбором техник на основе рисков",
          "Использование только наиболее продвинутых техник независимо от контекста системы",
          "Выбор техник исключительно на основе скорости их выполнения для соблюдения дедлайнов"
        ],
        correct: 1,
        expA: "Применение всех техник неэффективно и может не решать специфические риски конкретной системы.",
        expB: "Отлично! Систематический анализ обеспечивает целенаправленное использование ресурсов и максимальную эффективность обнаружения критичных проблем.",
        expC: "Продвинутые техники не обязательно самые подходящие для каждой характеристики системы или типа риска.",
        expD: "Скорость выполнения не должна быть определяющим фактором, особенно когда критически важны безопасность и надежность.",
        points: 3,
        chapter: "Методы и техники тестирования систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 181,
        text: "Что отличает тестовые среды для ИИ от обычных? Выберите ОДИН вариант.",
        options: [
          "Использование реляционных баз данных",
          "Адаптация к непредсказуемым изменениям среды",
          "Применение микросервисной архитектуры", 
          "Контейнеризация приложений"
        ],
        correct: 1,
        expA: "Реляционные базы данных используются в традиционных системах, не специфичны для ИИ.",
        expB: "Именно! Самообучающиеся системы должны работать в условиях, которые нельзя полностью предугадать заранее.",
        expC: "Микросервисы - это архитектурный паттерн, не уникальный для тестовых сред ИИ.",
        expD: "Контейнеризация - общая практика DevOps, не связанная со спецификой ИИ-систем.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K1"
      },
      {
        id: 182,
        text: "Как лучше всего описать большие данные? Выберите ОДИН вариант.",
        options: [
          "Структурированные реляционные таблицы",
          "Данные, обрабатываемые в пакетном режиме",
          "Информация в формате JSON",
          "Огромные объемы разнородной информации"
        ],
        correct: 3,
        expA: "Структурированные таблицы - это традиционные базы данных, не обязательно большие данные.",
        expB: "Пакетная обработка - это метод, а не определение больших данных.",
        expC: "JSON - это формат данных, не связанный с концепцией больших данных.",
        expD: "Точно! Большие данные характеризуются объемом, скоростью и разнообразием информации.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K1"
      },
      {
        id: 183,
        text: "Что верно для тестирования автономных систем? Выберите ОДИН вариант.",
        options: [
          "Достаточно тестирования в контролируемых условиях",
          "Нужно испытывать системы в экстремальных условиях",
          "Приоритет имеет тестирование отдельных компонентов",
          "Фокус на проверке пользовательских интерфейсов"
        ],
        correct: 1,
        expA: "Контролируемые условия недостаточны для проверки автономности в реальных сценариях.",
        expB: "Верно! Только в сложных условиях можно понять, где система передает управление человеку.",
        expC: "Компонентное тестирование важно, но не проверяет автономное поведение системы в целом.",
        expD: "Интерфейсы важны, но не определяют способность системы к автономному принятию решений.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 184,
        text: "В чем проблема объяснимости при тестировании ИИ? Выберите ОДИН вариант.",
        options: [
          "Низкая точность алгоритмов",
          "Непонятно, как ИИ принимает решения",
          "Высокая вычислительная сложность",
          "Недостаток качественных данных для обучения"
        ],
        correct: 1,
        expA: "Точность - это показатель производительности, не связанный с объяснимостью решений.",
        expB: "Именно! Проблема объяснимости в том, что мы не понимаем логику принятия решений ИИ.",
        expC: "Вычислительная сложность влияет на производительность, а не на объяснимость.",
        expD: "Качество данных важно для обучения, но не решает проблему объяснимости решений.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 185,
        text: "Что означает дрейф концепций в ML? Выберите ОДИН вариант.",
        options: [
          "Изменение архитектуры нейронной сети",
          "Эволюция входных данных со временем",
          "Изменение паттернов данных со временем",
          "Модификация алгоритмов обучения"
        ],
        correct: 2,
        expA: "Изменение архитектуры - это инженерное решение, а не естественный дрейф.",
        expB: "Эволюция входных данных - более узкое понятие, чем дрейф концепций.",
        expC: "Правильно! Дрейф концепций означает изменение статистических паттернов данных во времени.",
        expD: "Модификация алгоритмов - это сознательное изменение, а не дрейф.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 186,
        text: "Как лучше управлять тестовыми данными в среде машинного обучения? Выберите ОДИН вариант.",
        options: [
          "Создать единый централизованный репозиторий данных",
          "Использовать версионирование наборов данных",
          "Применять случайную выборку для каждого теста",
          "Дублировать производственные данные"
        ],
        correct: 1,
        expA: "Централизация удобна, но не решает проблему отслеживания изменений в ML.",
        expB: "Правильно! Версионирование позволяет отслеживать изменения и воспроизводить результаты.",
        expC: "Случайная выборка не обеспечивает воспроизводимость экспериментов.",
        expD: "Дублирование данных создает проблемы приватности и согласованности.",
        points: 2,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 187,
        text: "Какой подход оптимален для мониторинга ИИ-систем в продакшене? Выберите ОДИН вариант.",
        options: [
          "Периодические ручные проверки результатов",
          "Непрерывный автоматизированный мониторинг показателей",
          "Ежемесячные аудиты системы пользователями",
          "Мониторинг только критических ошибок"
        ],
        correct: 1,
        expA: "Ручные проверки слишком медленны для обнаружения деградации ИИ-систем.",
        expB: "Верно! ИИ-системы требуют непрерывного мониторинга из-за возможного дрейфа и деградации.",
        expC: "Ежемесячные аудиты не успевают за быстрыми изменениями в поведении ИИ.",
        expD: "Мониторинг только критических ошибок пропускает постепенную деградацию качества.",
        points: 2,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 188,
        text: "Какая стратегия оптимальна для тестирования ИИ в критически важных системах? Выберите ОДИН вариант.",
        options: [
          "Полная автоматизация тестирования для скорости",
          "Многоуровневый подход с человеческим контролем",
          "Минимальное тестирование для быстрого развертывания",
          "Изолированное тестирование каждого компонента"
        ],
        correct: 1,
        expA: "Полная автоматизация рискованна в критических системах без человеческого надзора.",
        expB: "Правильно! Многоуровневый подход обеспечивает тщательность с сохранением человеческого контроля.",
        expC: "Минимальное тестирование неприемлемо для критически важных систем.",
        expD: "Изолированное тестирование не проверяет системные взаимодействия в критических сценариях.",
        points: 3,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 189,
        text: "Как обеспечить качество данных в тестовой среде ML? Выберите ОДИН вариант.",
        options: [
          "Валидация схемы и проверка распределений",
          "Использование только синтетических данных",
          "Копирование всех продакшен данных",
          "Случайная генерация тестовых образцов"
        ],
        correct: 0,
        expA: "Правильно! Валидация схемы и проверка распределений обеспечивают качество и репрезентативность данных.",
        expB: "Только синтетические данные могут не отражать реальные паттерны.",
        expC: "Копирование продакшен данных создает проблемы приватности и масштабируемости.",
        expD: "Случайная генерация не гарантирует репрезентативности для ML-задач.",
        points: 2,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 190,
        text: "Что характеризует симуляционные среды для ИИ? Выберите ОДИН вариант.",
        options: [
          "Точное воспроизведение реальных условий",
          "Контролируемое моделирование сценариев",
          "Упрощенные модели взаимодействий",
          "Статичные предопределенные сценарии"
        ],
        correct: 1,
        expA: "Абсолютная точность невозможна - симуляции всегда являются приближениями.",
        expB: "Верно! Главное преимущество симуляций - контролируемая вариативность сценариев для тестирования.",
        expC: "Упрощение может снизить ценность тестирования сложных ИИ-поведений.",
        expD: "Статичные сценарии не используют весь потенциал симуляционных сред.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 191,
        text: "Какой фактор критичен при выборе инфраструктуры для тестирования ИИ? Выберите ОДИН вариант.",
        options: [
          "Совместимость с облачными сервисами",
          "Масштабируемость вычислительных ресурсов",
          "Поддержка различных языков программирования",
          "Интеграция с системами мониторинга"
        ],
        correct: 1,
        expA: "Облачная совместимость важна, но не является определяющим фактором.",
        expB: "Именно! ИИ-модели требуют значительных и переменных вычислительных ресурсов.",
        expC: "Поддержка языков полезна, но вторична по сравнению с вычислительными возможностями.",
        expD: "Мониторинг важен, но базовые вычислительные ресурсы имеют приоритет.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 192,
        text: "Как лучше всего подготовить тестовые данные для обучения ИИ? Выберите ОДИН вариант.",
        options: [
          "Стратифицированное разделение с валидацией качества",
          "Случайное разделение на тренировочную и тестовую выборки",
          "Использование только последних данных",
          "Равномерное распределение всех классов"
        ],
        correct: 0,
        expA: "Правильно! Стратифицированное разделение с проверкой качества обеспечивает репрезентативность и надежность.",
        expB: "Случайное разделение может привести к несбалансированным или нерепрезентативным выборкам.",
        expC: "Только свежие данные могут не покрывать важные исторические паттерны.",
        expD: "Равномерное распределение искусственно и может не отражать реальное распределение.",
        points: 2,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 193,
        text: "Что означает A/B тестирование в контексте ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Сравнение двух алгоритмов машинного обучения",
          "Тестирование модели против базового решения",
          "Сравнение производительности в разных средах",
          "Параллельное тестирование версий в реальных условиях"
        ],
        correct: 3,
        expA: "Сравнение алгоритмов - это более общая практика, чем A/B тестирование.",
        expB: "Бенчмаркинг против базовых решений - отдельная методология тестирования.",
        expC: "Тестирование в разных средах - это стресс-тестирование, не A/B тестирование.",
        expD: "Точно! A/B тестирование означает параллельное сравнение версий на реальных пользователях.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 194,
        text: "Какой подход лучше для тестирования распределенных ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Тестирование каждого узла изолированно",
          "Комплексное тестирование всей системы в целом",
          "Поэтапное тестирование с увеличением нагрузки",
          "Фокус на тестировании коммуникационных протоколов"
        ],
        correct: 2,
        expA: "Изолированное тестирование не выявляет проблемы взаимодействия между узлами.",
        expB: "Комплексное тестирование сложно отлаживать в распределенных системах.",
        expC: "Правильно! Поэтапное масштабирование позволяет выявить проблемы координации и производительности.",
        expD: "Протоколы важны, но не покрывают логику распределенного принятия решений.",
        points: 2,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 195,
        text: "Что критично при создании тестовой среды для обучения с подкреплением? Выберите ОДИН вариант.",
        options: [
          "Высокопроизводительные графические процессоры",
          "Детерминированная среда взаимодействий",
          "Реалистичная симуляция окружения и наград",
          "Минимальное время отклика системы"
        ],
        correct: 2,
        expA: "GPU важны для производительности, но не определяют качество среды для RL.",
        expB: "Детерминизм может ограничить способность агента к обобщению.",
        expC: "Верно! Качество симуляции окружения и системы наград критически важно для эффективного обучения.",
        expD: "Время отклика влияет на скорость обучения, но не на его качество.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 196,
        text: "Как обеспечить воспроизводимость экспериментов в ML? Выберите ОДИН вариант.",
        options: [
          "Фиксация случайных семян и версий библиотек",
          "Использование одинакового оборудования",
          "Сохранение только финальных моделей",
          "Документирование результатов тестирования"
        ],
        correct: 0,
        expA: "Правильно! Фиксация семян и версий обеспечивает детерминированность и воспроизводимость.",
        expB: "Одинаковое оборудование помогает, но не гарантирует воспроизводимость без контроля других факторов.",
        expC: "Сохранение только моделей не позволяет воспроизвести процесс обучения.",
        expD: "Документирование важно, но не обеспечивает техническую воспроизводимость.",
        points: 2,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 197,
        text: "Какая стратегия оптимальна для управления рисками в тестовых средах ИИ? Выберите ОДИН вариант.",
        options: [
          "Максимальная изоляция от продакшн систем",
          "Градуальное внедрение с мониторингом рисков",
          "Полное копирование продакшн окружения",
          "Ограничение доступа к минимуму пользователей"
        ],
        correct: 1,
        expA: "Полная изоляция может снизить реалистичность тестирования.",
        expB: "Правильно! Градуальный подход позволяет контролировать риски при сохранении реалистичности.",
        expC: "Полное копирование создает проблемы безопасности и масштабируемости.",
        expD: "Ограничение доступа важно, но не решает технических рисков тестирования.",
        points: 3,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 198,
        text: "Что важно учитывать при тестировании федеративного обучения? Выберите ОДИН вариант.",
        options: [
          "Скорость сходимости алгоритма",
          "Приватность и безопасность данных участников",
          "Совместимость различных архитектур",
          "Эффективность агрегации моделей"
        ],
        correct: 1,
        expA: "Скорость важна, но не является главным вызовом федеративного обучения.",
        expB: "Именно! Федеративное обучение создано для сохранения приватности, это ключевой аспект для тестирования.",
        expC: "Совместимость важна, но вторична по сравнению с вопросами безопасности.",
        expD: "Эффективность агрегации - технический аспект, но не основной фокус тестирования.",
        points: 1,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K2"
      },
      {
        id: 199,
        text: "Как лучше всего организовать тестирование многомодальных ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Отдельное тестирование каждой модальности",
          "Интегрированное тестирование межмодальных взаимодействий",
          "Фокус на тестировании доминирующей модальности",
          "Последовательное добавление модальностей"
        ],
        correct: 1,
        expA: "Раздельное тестирование пропускает критические взаимодействия между модальностями.",
        expB: "Правильно! Многомодальные системы требуют тестирования именно взаимодействий между модальностями.",
        expC: "Фокус на одной модальности игнорирует сложность многомодальной интеграции.",
        expD: "Последовательное добавление может не выявить синергетические эффекты.",
        points: 2,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K3"
      },
      {
        id: 200,
        text: "Какой принцип должен лежать в основе стратегии тестирования ИИ-систем нового поколения? Выберите ОДИН вариант.",
        options: [
          "Максимизация покрытия тестов любой ценой",
          "Адаптивность к эволюционирующим характеристикам систем",
          "Стандартизация всех процессов тестирования",
          "Минимизация человеческого участия в процессе"
        ],
        correct: 1,
        expA: "Максимизация покрытия может привести к неэффективности без учета специфики ИИ.",
        expB: "Правильно! ИИ-системы эволюционируют, требуя адаптивных подходов к тестированию.",
        expC: "Чрезмерная стандартизация может ограничить гибкость, необходимую для ИИ-тестирования.",
        expD: "Человеческая экспертиза остается критично важной для интерпретации результатов ИИ.",
        points: 3,
        chapter: "Тестовые среды для систем на основе ИИ",
        difficulty: "K4"
      },
      {
        id: 201,
        text: "Что характерно для тестирования GUI с помощью ИИ? Выберите ОДИН вариант.",
        options: [
          "Автоматическое обнаружение изменений в интерфейсе",
          "Тестирование на основе заранее созданных скриншотов",
          "Проверка элементов через селекторы DOM",
          "Анализ структуры исходного кода интерфейса"
        ],
        correct: 0,
        expA: "Верно! ИИ автоматически находит изменения в интерфейсе, не требуя предварительного программирования каждого элемента.",
        expB: "Тестирование по скриншотам - более традиционный подход без возможностей машинного обучения.",
        expC: "DOM-селекторы требуют предварительной разметки и не используют преимущества ИИ.",
        expD: "Анализ кода не отражает реальное визуальное поведение интерфейса для пользователей.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K2"
      },
      {
        id: 202,
        text: "Какой метод машинного обучения лучше подходит для анализа логов? Выберите ОДИН вариант.",
        options: [
          "Веб-разработка для создания интерфейсов",
          "Кластеризация для группировки записей",
          "Управление базами данных",
          "Контейнеризация приложений"
        ],
        correct: 1,
        expA: "Веб-разработка - это отдельная область, не связанная с анализом логов.",
        expB: "Правильно! Кластеризация отлично группирует похожие записи и помогает найти аномалии в логах.",
        expC: "Управление БД - это администрирование данных, а не их анализ.",
        expD: "Контейнеризация решает задачи развертывания, не анализа логов.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K1"
      },
      {
        id: 203,
        text: "Какой способ лучше подходит для генерации тестовых данных с помощью ИИ? Выберите ОДИН вариант.",
        options: [
          "Генеративные модели для реалистичных данных",
          "Статистическая выборка из продакшен данных",
          "Шаблонная генерация по фиксированным правилам",
          "Синтетическая генерация случайных значений"
        ],
        correct: 0,
        expA: "Правильно! Генеративные модели создают реалистичные данные, учитывая сложные связи в реальных данных.",
        expB: "Статистическая выборка ограничена существующими данными и не создает новые сценарии.",
        expC: "Шаблонная генерация слишком предсказуема и не покрывает граничные случаи.",
        expD: "Случайная генерация не учитывает реальные закономерности и бизнес-правила.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K2"
      },
      {
        id: 204,
        text: "Что ИИ делает в первую очередь при анализе дефектов? Выберите ОДИН вариант.",
        options: [
          "Анализирует корреляции между типами ошибок",
          "Классифицирует дефекты по типу и важности",
          "Ищет статистические паттерны в распределении",
          "Сравнивает с историческими базами дефектов"
        ],
        correct: 1,
        expA: "Корреляционный анализ - более сложный этап, который следует после базовой классификации.",
        expB: "Верно! Сначала нужно понять, какие дефекты есть и насколько они важны, а уже потом их анализировать.",
        expC: "Поиск паттернов - это аналитический этап, который идет после первичной категоризации.",
        expD: "Сравнение с историей полезно, но сначала нужно классифицировать текущие дефекты.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K2"
      },
      {
        id: 205,
        text: "Как ИИ помогает создавать тестовые случаи? Выберите ОДИН вариант.",
        options: [
          "Извлекает требования из документации и кода",
          "Анализирует требования и код для создания тестов",
          "Парсирует спецификации для поиска тест-кейсов",
          "Изучает пользовательские сценарии и интерфейс"
        ],
        correct: 1,
        expA: "Извлечение требований - это подготовительный этап, а не создание тестов.",
        expB: "Правильно! ИИ изучает требования и код, чтобы автоматически создать подходящие тесты.",
        expC: "Парсинг спецификаций - более узкая задача, не охватывающая полный цикл создания тестов.",
        expD: "Изучение UX важно, но недостаточно для создания полноценных тестовых случаев.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K2"
      },
      {
        id: 206,
        text: "Чем полезен ИИ при регрессионном тестировании? Выберите ОДИН вариант.",
        options: [
          "Умно выбирает самые важные тесты",
          "Оптимизирует порядок выполнения тестов",
          "Предсказывает время выполнения тест-сьютов",
          "Автоматически обновляет устаревшие тесты"
        ],
        correct: 0,
        expA: "Правильно! ИИ смотрит, что изменилось в коде, и выбирает самые нужные тесты для проверки.",
        expB: "Оптимизация порядка полезна, но менее критична чем выбор релевантных тестов.",
        expC: "Предсказание времени помогает планированию, но не улучшает качество тестирования.",
        expD: "Обновление тестов важно, но приоритизация более актуальна для регрессии.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K2"
      },
      {
        id: 207,
        text: "Какие данные нужны ИИ для прогнозирования дефектов? Выберите ОДИН вариант.",
        options: [
          "История дефектов и характеристики кода",
          "Метрики производительности системы в runtime",
          "Данные о скорости разработки команды",
          "Информация об архитектуре и зависимостях"
        ],
        correct: 0,
        expA: "Верно! История дефектов и метрики кода дают ИИ нужную информацию для точных предсказаний.",
        expB: "Runtime-метрики важны для производительности, но недостаточны для предсказания дефектов.",
        expC: "Скорость разработки влияет на качество, но не является прямым предиктором дефектов.",
        expD: "Архитектурная информация полезна, но исторические данные о дефектах более критичны.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K2"
      },
      {
        id: 208,
        text: "Как ИИ находит изменения в интерфейсе? Выберите ОДИН вариант.",
        options: [
          "Сравнивает хеши элементов страницы",
          "Анализирует общие паттерны и структуру",
          "Отслеживает изменения в CSS-стилях",
          "Мониторит обновления JavaScript-кода"
        ],
        correct: 1,
        expA: "Сравнение хешей слишком чувствительно к мелким изменениям и может давать ложные срабатывания.",
        expB: "Правильно! ИИ смотрит на общие паттерны, что делает его устойчивым к незначительным изменениям.",
        expC: "Отслеживание CSS показывает стилевые изменения, но не логику взаимодействий.",
        expD: "Мониторинг JS-кода не отражает визуальные изменения интерфейса для пользователя.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K2"
      },
      {
        id: 209,
        text: "Какой метод машинного обучения группирует похожие дефекты? Выберите ОДИН вариант.",
        options: [
          "Обучение с учителем на размеченных данных",
          "Обучение с подкреплением через награды",
          "Полууправляемое обучение с частичной разметкой",
          "Кластеризация для поиска естественных групп"
        ],
        correct: 3,
        expA: "Обучение с учителем требует заранее размеченных категорий дефектов.",
        expB: "Обучение с подкреплением не подходит для группировки готовых данных.",
        expC: "Полууправляемое обучение полезно, но хуже находит скрытые группы дефектов.",
        expD: "Правильно! Кластеризация сама находит похожие дефекты без заранее заданных категорий.",
        points: 1,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K2"
      },
      {
        id: 210,
        text: "ИИ плохо распознает новые типы ошибок. Что делать? Выберите ОДИН вариант.",
        options: [
          "Дообучить модель на примерах новых дефектов",
          "Увеличить размер обучающей выборки",
          "Использовать более сложные алгоритмы",
          "Добавить человеческую экспертизу в процесс"
        ],
        correct: 0,
        expA: "Правильно! Дообучение поможет ИИ научиться распознавать новые типы дефектов.",
        expB: "Увеличение выборки поможет, если в ней есть примеры новых типов дефектов.",
        expC: "Сложные алгоритмы не решат проблему отсутствия примеров новых дефектов.",
        expD: "Человеческая экспертиза важна, но модель все равно нужно дообучить.",
        points: 2,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K3"
      },
      {
        id: 211,
        text: "На что обратить внимание при генерации тестовых данных с помощью ИИ? Выберите ОДИН вариант.",
        options: [
          "Данные должны соответствовать бизнес-правилам",
          "Необходимо максимизировать объем генерируемых данных",
          "Важно обеспечить высокую скорость генерации",
          "Нужно минимизировать потребление системных ресурсов"
        ],
        correct: 0,
        expA: "Правильно! Если данные не соответствуют бизнес-логике, тестирование будет бесполезным.",
        expB: "Большой объем без качества приведет к неэффективному тестированию.",
        expC: "Скорость важна, но качество и соответствие правилам приоритетнее.",
        expD: "Оптимизация ресурсов вторична по сравнению с корректностью данных.",
        points: 2,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K3"
      },
      {
        id: 212,
        text: "Как лучше тестировать мобильное приложение с помощью ИИ? Выберите ОДИН вариант.",
        options: [
          "Совместить компьютерное зрение и анализ структуры",
          "Использовать только визуальный анализ скриншотов",
          "Сосредоточиться на API-тестировании бэкенда",
          "Применить исключительно автоматизацию UI"
        ],
        correct: 0,
        expA: "Правильно! Комбинация визуального анализа и понимания структуры дает лучший результат.",
        expB: "Только визуальный анализ может пропустить логические ошибки в коде.",
        expC: "API-тестирование не проверяет пользовательский интерфейс и взаимодействия.",
        expD: "Классическая автоматизация UI не использует преимущества ИИ-подходов.",
        points: 2,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K3"
      },
      {
        id: 213,
        text: "ИИ хорошо приоритизирует тесты для новых функций, но плохо для рефакторинга. Как исправить? Выберите ОДИН вариант.",
        options: [
          "Обучить отдельные модели для разных типов изменений",
          "Использовать гибридный подход с ручной настройкой",
          "Дополнить модель данными о рефакторинге",
          "Переключиться на другие алгоритмы машинного обучения"
        ],
        correct: 2,
        expA: "Отдельные модели усложнят поддержку и могут создать противоречивые приоритеты.",
        expB: "Гибридный подход поможет, но не решит основную проблему недостатка данных.",
        expC: "Правильно! Дополнение данных о рефакторинге поможет модели лучше понимать такие изменения.",
        expD: "Смена алгоритмов не решит проблему недостатка обучающих данных.",
        points: 2,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K3"
      },
      {
        id: 214,
        text: "Как настроить прогнозирование дефектов для проекта с нестандартной архитектурой? Выберите ОДИН вариант.",
        options: [
          "Адаптировать признаки под специфику архитектуры",
          "Использовать стандартные метрики без изменений",
          "Полностью переобучить модель с нуля",
          "Применить готовые отраслевые решения"
        ],
        correct: 0,
        expA: "Правильно! Адаптация признаков под архитектурную специфику улучшит качество предсказаний.",
        expB: "Стандартные метрики могут не отражать особенности нестандартной архитектуры.",
        expC: "Полное переобучение слишком дорого и может потерять ценный опыт.",
        expD: "Готовые решения могут не подходить для уникальных архитектурных решений.",
        points: 2,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K3"
      },
      {
        id: 215,
        text: "Как определить уровень доверия к ИИ-инструменту тестирования? Выберите ОДИН вариант.",
        options: [
          "Основываться на точности в реальных проектах",
          "Опираться на производительность в лабораторных условиях",
          "Учитывать популярность инструмента в индустрии",
          "Следовать рекомендациям вендора"
        ],
        correct: 0,
        expA: "Правильно! Уровень доверия должен основываться на том, насколько хорошо ИИ показывает себя на практике.",
        expB: "Лабораторные условия не отражают сложности реальных проектов.",
        expC: "Популярность не гарантирует качества для конкретного случая применения.",
        expD: "Рекомендации вендора могут быть необъективными и маркетинговыми.",
        points: 2,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K3"
      },
      {
        id: 216,
        text: "Как использовать ИИ для тестирования медицинских систем? Выберите ОДИН вариант.",
        options: [
          "Полностью автоматизировать процесс тестирования",
          "Сочетать ИИ-анализ с экспертным контролем",
          "Ограничиться только некритическими функциями",
          "Использовать ИИ как замену медицинских экспертов"
        ],
        correct: 1,
        expA: "Полная автоматизация в медицине создает неприемлемые риски для пациентов.",
        expB: "Правильно! В медицине нужно сочетать эффективность ИИ с надежностью экспертного контроля.",
        expC: "Ограничение некритическими функциями не использует весь потенциал ИИ для улучшения качества.",
        expD: "ИИ не может заменить медицинскую экспертизу в вопросах безопасности пациентов.",
        points: 3,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K4"
      },
      {
        id: 217,
        text: "Как лучше внедрить ИИ в процесс тестирования? Выберите ОДИН вариант.",
        options: [
          "Пилотные проекты с постепенным масштабированием",
          "Немедленная замена всех существующих процессов",
          "Параллельное внедрение во всех командах",
          "Ожидание полной готовности технологии"
        ],
        correct: 0,
        expA: "Правильно! Пилотные проекты позволяют изучить технологию и постепенно расширить успешные решения.",
        expB: "Резкая замена всех процессов очень рискованна и может нарушить стабильность работы.",
        expC: "Параллельное внедрение без опыта может привести к системным проблемам.",
        expD: "Ожидание идеальной готовности может привести к потере конкурентных преимуществ.",
        points: 3,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K4"
      },
      {
        id: 218,
        text: "Как внедрить ИИ-анализ дефектов в 15 команд по всему миру? Выберите ОДИН вариант.",
        options: [
          "Идентичная реализация во всех локациях",
          "Полная автономия каждой команды в решениях",
          "Центральное управление с локальными адаптациями",
          "Фокус только на унификации отчетности"
        ],
        correct: 2,
        expA: "Идентичная реализация не учитывает особенности разных проектов и культур.",
        expB: "Полная автономия усложняет координацию и обмен лучшими практиками.",
        expC: "Правильно! Центральное управление с локальными адаптациями обеспечивает баланс консистентности и гибкости.",
        expD: "Фокус только на отчетности упускает возможности процессных улучшений.",
        points: 3,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K4"
      },
      {
        id: 219,
        text: "ИИ дает разные результаты в разных операционных системах. Что делать? Выберите ОДИН вариант.",
        options: [
          "Создать адаптивную модель для всех платформ",
          "Разработать отдельные модели для каждой ОС",
          "Нормализовать входные данные для кросс-платформенности",
          "Зафиксировать использование одной ОС"
        ],
        correct: 2,
        expA: "Адаптивная модель сложна в разработке и может не справиться с платформенными различиями.",
        expB: "Отдельные модели усложнят поддержку и координацию между платформами.",
        expC: "Правильно! Нормализация данных обеспечит консистентные результаты на всех платформах.",
        expD: "Ограничение одной ОС не покроет все реальные условия использования продукта.",
        points: 3,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K4"
      },
      {
        id: 220,
        text: "Клиент хочет ИИ-решение, которое адаптируется к изменениям бизнеса. Какая архитектура лучше? Выберите ОДИН вариант.",
        options: [
          "Модульная архитектура с конфигурируемыми компонентами",
          "Микросервисная архитектура с независимыми сервисами",
          "Монолитная система с гибкими параметрами",
          "Событийно-ориентированная архитектура"
        ],
        correct: 0,
        expA: "Правильно! Модульная архитектура позволяет гибко реагировать на изменения без полной перестройки.",
        expB: "Микросервисы обеспечивают масштабируемость, но могут усложнить координацию изменений.",
        expC: "Монолитная архитектура менее гибка для быстрых бизнес-изменений.",
        expD: "Событийная архитектура хороша для реактивности, но может быть избыточной для адаптации бизнес-логики.",
        points: 3,
        chapter: "Использование ИИ для тестирования",
        difficulty: "K4"
      },
      {
        id: 221,
        text: "Что наиболее точно характеризует узкий ИИ? Выберите ОДИН вариант.",
        options: [
          "ИИ, специализированный на конкретных задачах",
          "ИИ с ограниченными возможностями обучения",
          "ИИ, работающий с небольшими массивами данных",
          "ИИ, использующий упрощенные алгоритмы обработки"
        ],
        correct: 0,
        expA: "Верно! Узкий ИИ создается для решения конкретных задач в определенной области.",
        expB: "Узкий ИИ может иметь мощные возможности обучения в своей специализированной области.",
        expC: "Размер данных не определяет узость ИИ - некоторые узкие системы требуют больших данных.",
        expD: "Узкий ИИ может использовать сложные алгоритмы, специализация не означает простоту.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K2"
      },
      {
        id: 222,
        text: "Какая характеристика отличает традиционные системы от систем на основе ИИ? Выберите ОДИН вариант.",
        options: [
          "Использование реляционных баз данных",
          "Применение сетевых протоколов",
          "Возможность адаптироваться и изменяться со временем",
          "Потребность в регулярных обновлениях"
        ],
        correct: 2,
        expA: "Реляционные базы данных используются как в традиционных системах, так и в ИИ-системах.",
        expB: "Сетевые протоколы применяются в различных типах систем независимо от наличия ИИ.",
        expC: "Именно! Системы ИИ могут обучаться и адаптироваться, в отличие от традиционных систем.",
        expD: "Обновления нужны всем типам систем для поддержания актуальности и безопасности.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K1"
      },
      {
        id: 223,
        text: "Компания планирует внедрить систему ИИ для обработки клиентских запросов. Какой фактор важнее всего учитывать на начальном этапе? Выберите ОДИН вариант.",
        options: [
          "Качество и объем доступных обучающих данных",
          "Выбор архитектуры нейронной сети",
          "Определение метрик для оценки производительности",
          "Планирование процедур развертывания модели"
        ],
        correct: 0,
        expA: "Точно! Качественные данные — основа успешного обучения любой системы ИИ.",
        expB: "Архитектура важна, но без качественных данных даже лучшая сеть не даст результата.",
        expC: "Метрики критичны для оценки, но сначала нужны данные для обучения модели.",
        expD: "Развертывание - завершающий этап, который невозможен без предварительно обученной модели.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K2"
      },
      {
        id: 224,
        text: "Что такое эффект ИИ? Выберите ОДИН вариант.",
        options: [
          "Использование облачных вычислений",
          "Применение микросервисной архитектуры",
          "Перестают считаться ИИ после широкого распространения",
          "Интеграция с базами данных"
        ],
        correct: 2,
        expA: "Облачные вычисления - это инфраструктурное решение, не связанное с эффектом ИИ.",
        expB: "Микросервисы - архитектурный подход, не имеющий отношения к восприятию ИИ.",
        expC: "Правильно! Эффект ИИ - когда технологии перестают восприниматься как ИИ после широкого использования.",
        expD: "Интеграция с БД - техническая задача, не связанная с психологическим восприятием ИИ.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K1"
      },
      {
        id: 225,
        text: "Какой подход характерен для машинного обучения? Выберите ОДИН вариант.",
        options: [
          "Извлечение закономерностей из данных",
          "Использование предварительно заданных правил",
          "Применение детерминированных алгоритмов",
          "Создание статических моделей без обновления"
        ],
        correct: 0,
        expA: "Именно! Машинное обучение основано на извлечении закономерностей из данных.",
        expB: "Заданные правила больше характерны для экспертных систем, а не ML.",
        expC: "ML часто использует стохастические подходы и может адаптироваться.",
        expD: "ML-модели могут дообучаться и адаптироваться к новым данным.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K2"
      },
      {
        id: 226,
        text: "Почему качество обучающих данных критически важно для ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Определяет точность и надежность предсказаний модели",
          "Влияет на скорость выполнения алгоритмов обучения",
          "Регулирует потребление вычислительных ресурсов",
          "Контролирует сложность архитектуры нейронных сетей"
        ],
        correct: 0,
        expA: "Верно! Качество данных напрямую влияет на способность модели делать точные предсказания.",
        expB: "Качество данных может влиять на скорость, но это не главная причина его важности.",
        expC: "Ресурсы больше зависят от размера данных и сложности модели, чем от качества.",
        expD: "Архитектура выбирается исходя из задачи, а не из качества обучающих данных.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K2"
      },
      {
        id: 227,
        text: "В чем основное преимущество нейронных сетей перед традиционными алгоритмами? Выберите ОДИН вариант.",
        options: [
          "Способность обрабатывать сложные нелинейные зависимости",
          "Возможность работы с малыми объемами данных",
          "Высокая интерпретируемость результатов",
          "Быстрое обучение на ограниченных ресурсах"
        ],
        correct: 0,
        expA: "Верно! Нейронные сети эффективно моделируют сложные нелинейные отношения.",
        expB: "Нейронные сети обычно требуют больших объемов данных для качественного обучения.",
        expC: "Нейронные сети часто называют 'черными ящиками' из-за сложности интерпретации.",
        expD: "Обучение нейронных сетей обычно требует значительных вычислительных ресурсов.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K2"
      },
      {
        id: 228,
        text: "Компания хочет использовать ИИ для анализа отзывов клиентов. Какой подход поможет определить эмоциональную окраску текстов? Выберите ОДИН вариант.",
        options: [
          "Статистический анализ частотности слов",
          "Семантический анализ содержания текста",
          "Синтаксический разбор структуры предложений",
          "Анализ тональности с использованием обработки естественного языка"
        ],
        correct: 3,
        expA: "Частотный анализ показывает популярность слов, но не эмоциональную окраску.",
        expB: "Семантический анализ изучает смысл, но не специализирован на эмоциях.",
        expC: "Синтаксический анализ изучает структуру, а не эмоциональное содержание.",
        expD: "Точно! Анализ тональности специально создан для определения настроения в тексте.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K2"
      },
      {
        id: 229,
        text: "Какая технология ИИ больше всего подходит для распознавания объектов на изображениях? Выберите ОДИН вариант.",
        options: [
          "Рекуррентные нейронные сети для обработки последовательностей",
          "Генеративно-состязательные сети для создания изображений",
          "Сверточные нейронные сети для обработки изображений",
          "Трансформерные модели для анализа зависимостей"
        ],
        correct: 2,
        expA: "RNN лучше подходят для последовательных данных, таких как тексты или временные ряды.",
        expB: "GAN специализируются на генерации изображений, а не на распознавании объектов.",
        expC: "Правильно! Сверточные сети специально разработаны для анализа изображений.",
        expD: "Трансформеры эффективны для NLP задач, но менее подходят для компьютерного зрения.",
        points: 1,
        chapter: "Введение в ИИ",
        difficulty: "K2"
      },
      {
        id: 230,
        text: "Компания внедряет ИИ-систему рекомендаций. Как лучше оценить успешность проекта? Выберите ОДИН вариант.",
        options: [
          "Комбинировать технические метрики с бизнес-показателями",
          "Сосредоточиться только на точности алгоритма",
          "Оценивать исключительно по пользовательской активности",
          "Измерять только скорость работы системы"
        ],
        correct: 0,
        expA: "Правильно! Комплексная оценка включает и техническую точность, и бизнес-влияние.",
        expB: "Только технические метрики не показывают реальную ценность для бизнеса.",
        expC: "Активность важна, но может не отражать качество рекомендаций.",
        expD: "Скорость - важный фактор UX, но не показатель успешности рекомендаций.",
        points: 2,
        chapter: "Введение в ИИ",
        difficulty: "K3"
      },
      {
        id: 231,
        text: "Команда выбирает подход к внедрению ИИ в существующие процессы. Какая стратегия наиболее разумна? Выберите ОДИН вариант.",
        options: [
          "Постепенная интеграция с пилотными проектами",
          "Немедленная полная замена всех систем",
          "Создание параллельной ИИ-инфраструктуры",
          "Ожидание стабилизации технологий ИИ"
        ],
        correct: 0,
        expA: "Правильно! Пилотные проекты позволяют изучить технологию с минимальными рисками.",
        expB: "Полная замена создает высокие риски для стабильности бизнеса.",
        expC: "Параллельная инфраструктура дорога и может создать проблемы интеграции.",
        expD: "Ожидание может привести к потере конкурентных преимуществ.",
        points: 2,
        chapter: "Введение в ИИ",
        difficulty: "K3"
      },
      {
        id: 232,
        text: "Какой риск требует особого внимания при внедрении ИИ в финансовую отрасль? Выберите ОДИН вариант.",
        options: [
          "Высокая стоимость вычислительных ресурсов",
          "Сложность обучения персонала",
          "Алгоритмическая предвзятость в принятии решений",
          "Необходимость обновления IT-инфраструктуры"
        ],
        correct: 2,
        expA: "Стоимость ресурсов - операционный вопрос, не самый критический риск.",
        expB: "Обучение персонала - управляемый процесс, не главная угроза.",
        expC: "Точно! Алгоритмическая предвзятость может привести к серьезным правовым проблемам.",
        expD: "Обновление инфраструктуры - техническая задача, решаемая поэтапно.",
        points: 2,
        chapter: "Введение в ИИ",
        difficulty: "K3"
      },
      {
        id: 233,
        text: "Как лучше подойти к внедрению ИИ в критически важные бизнес-процессы? Выберите ОДИН вариант.",
        options: [
          "Постепенное внедрение с тщательным тестированием на каждом этапе",
          "Агрессивное развертывание для быстрых результатов",
          "Ограниченное внедрение только во вспомогательных процессах",
          "Отложенное внедрение до полной готовности технологий"
        ],
        correct: 0,
        expA: "Правильно! Поэтапный подход минимизирует риски и позволяет учиться на опыте.",
        expB: "Агрессивное развертывание создает неоправданные риски для критических процессов.",
        expC: "Ограничение вспомогательными процессами упускает потенциал ИИ для основного бизнеса.",
        expD: "Бесконечное ожидание может лишить конкурентных преимуществ.",
        points: 2,
        chapter: "Введение в ИИ",
        difficulty: "K3"
      },
      {
        id: 234,
        text: "Какой подход поможет команде выявить ограничения выбранного алгоритма ИИ? Выберите ОДИН вариант.",
        options: [
          "Тестирование алгоритма на разнообразных граничных случаях",
          "Анализ производительности только на обучающих данных",
          "Сравнение с теоретическими характеристиками алгоритма",
          "Оценка работы в идеальных условиях тестовой среды"
        ],
        correct: 0,
        expA: "Верно! Граничные случаи выявляют слабые места и ограничения алгоритма.",
        expB: "Тестирование только на обучающих данных может привести к переобучению и скрыть проблемы.",
        expC: "Теоретический анализ важен, но не заменяет практическое тестирование ограничений.",
        expD: "Идеальные условия не показывают, как алгоритм работает в реальных сценариях.",
        points: 2,
        chapter: "Введение в ИИ",
        difficulty: "K3"
      },
      {
        id: 235,
        text: "Команда разрабатывает чат-бота для клиентской поддержки. Какой показатель лучше отражает качество работы системы? Выберите ОДИН вариант.",
        options: [
          "Среднее время формирования ответа системой",
          "Количество поддерживаемых языков общения",
          "Процент запросов, решенных без привлечения человека",
          "Размер словаря, используемого ботом"
        ],
        correct: 2,
        expA: "Скорость важна для UX, но не показывает качество решения проблем клиентов.",
        expB: "Многоязычность расширяет аудиторию, но не гарантирует эффективность решения задач.",
        expC: "Отлично! Способность самостоятельно решать запросы — ключевой показатель эффективности.",
        expD: "Размер словаря влияет на возможности понимания, но не на результативность.",
        points: 2,
        chapter: "Введение в ИИ",
        difficulty: "K3"
      },
      {
        id: 236,
        text: "Компания внедряет ИИ для прогнозирования спроса на продукцию. Какой фактор критически важен для успеха проекта? Выберите ОДИН вариант.",
        options: [
          "Доступность исторических данных о продажах и трендах",
          "Выбор самого современного алгоритма машинного обучения",
          "Использование максимально мощной вычислительной инфраструктуры",
          "Привлечение экспертов с опытом в других отраслях"
        ],
        correct: 0,
        expA: "Верно! Качественные исторические данные — фундамент точного прогнозирования спроса.",
        expB: "Современный алгоритм важен, но без релевантных данных он не даст результата.",
        expC: "Мощная инфраструктура ускоряет вычисления, но не заменяет качественные данные.",
        expD: "Отраслевая экспертиза важнее общего опыта в других сферах для понимания специфики.",
        points: 2,
        chapter: "Введение в ИИ",
        difficulty: "K3"
      },
      {
        id: 237,
        text: "Организация разрабатывает стратегию внедрения ИИ. Какой подход обеспечит оптимальный баланс инноваций и управления рисками? Выберите ОДИН вариант.",
        options: [
          "Портфельный подход с проектами разного уровня риска",
          "Фокус на максимально инновационных решениях",
          "Консервативная стратегия с проверенными технологиями",
          "Копирование успешных практик конкурентов"
        ],
        correct: 0,
        expA: "Правильно! Портфельный подход позволяет балансировать риски и возможности инноваций.",
        expB: "Фокус только на инновациях создает высокие риски без гарантии окупаемости.",
        expC: "Излишний консерватизм может привести к потере конкурентных возможностей.",
        expD: "Копирование не учитывает уникальные особенности и потребности организации.",
        points: 3,
        chapter: "Введение в ИИ",
        difficulty: "K4"
      },
      {
        id: 238,
        text: "Как лучше управлять ожиданиями стейкхолдеров при внедрении ИИ-проектов? Выберите ОДИН вариант.",
        options: [
          "Обещать революционные изменения для мотивации поддержки",
          "Системный подход к обучению и постепенному внедрению",
          "Сосредоточиться только на технических аспектах внедрения",
          "Делегировать коммуникацию техническим специалистам"
        ],
        correct: 1,
        expA: "Завышенные ожидания приводят к разочарованию при столкновении с реальностью внедрения.",
        expB: "Правильно! Системный подход к обучению обеспечивает контролируемое внедрение.",
        expC: "Игнорирование бизнес-аспектов создает разрыв между техническими возможностями и бизнес-целями.",
        expD: "Технические специалисты могут не обладать навыками управления стейкхолдерами.",
        points: 3,
        chapter: "Введение в ИИ",
        difficulty: "K4"
      },
      {
        id: 239,
        text: "Компания рассматривает создание автономной системы управления складом. Какой фактор требует наибольшего внимания при планировании? Выберите ОДИН вариант.",
        options: [
          "Интеграция с существующими ERP-системами",
          "Анализ сценариев отказа системы и планирование восстановления",
          "Оптимизация алгоритмов для повышения скорости обработки",
          "Выбор поставщиков робототехнического оборудования"
        ],
        correct: 1,
        expA: "Интеграция с ERP важна для бизнес-процессов, но безопасность автономных систем критичнее.",
        expB: "Верно! Автономные системы требуют детального планирования аварийных сценариев.",
        expC: "Оптимизация скорости важна, но вторична по сравнению с надежностью и безопасностью.",
        expD: "Выбор оборудования важен, но планирование отказоустойчивости критичнее для автономных систем.",
        points: 3,
        chapter: "Введение в ИИ",
        difficulty: "K4"
      },
      {
        id: 240,
        text: "Организация выбирает стратегию инновационного развития с использованием ИИ. Какой подход обеспечит оптимальный баланс между инновациями и стабильностью? Выберите ОДИН вариант.",
        options: [
          "Агрессивная стратегия с максимальным внедрением ИИ",
          "Консервативная стратегия с фокусом на проверенные решения",
          "Сбалансированный набор проектов с разным уровнем риска",
          "Стратегия следования за лидерами рынка"
        ],
        correct: 2,
        expA: "Агрессивная стратегия создает неоправданные риски без гарантии результата.",
        expB: "Излишний консерватизм может привести к потере инновационного потенциала.",
        expC: "Именно! Сбалансированный набор проектов позволяет инновировать, контролируя риски.",
        expD: "Стратегия следования не позволяет создать уникальные конкурентные преимущества.",
        points: 3,
        chapter: "Введение в ИИ",
        difficulty: "K4"
      },
      {
        id: 241,
        text: "Какой из перечисленных факторов, связанных с тестовыми данными, СКОРЕЕ ВСЕГО усложнит тестирование ИИ-систем? Выберите ОДИН ответ.",
        options: [
          "Огромные объемы и сложность нужных тестовых данных",
          "Статичные требования к тестовым данным",
          "Упрощенные процессы подготовки данных",
          "Сниженные требования к хранению данных"
        ],
        correct: 0,
        expA: "Точно! ИИ-системы требуют больших, разнообразных и сложных наборов данных, что серьезно усложняет управление тестовыми данными.",
        expB: "Статичные требования как раз упрощают тестирование, а не усложняют его.",
        expC: "Упрощенные процессы снижают сложность, а не увеличивают ее.",
        expD: "Меньшие требования к хранению облегчили бы тестирование, а не усложнили.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K1"
      },
      {
        id: 242,
        text: "Какое из утверждений о больших данных СКОРЕЕ ВСЕГО является ПРАВИЛЬНЫМ? Выберите ОДИН ответ.",
        options: [
          "Большие данные упрощают подготовку тестовых данных",
          "Большие данные требуют специализированных подходов к тестированию",
          "Большие данные устраняют необходимость проверки данных",
          "Большие данные снижают вычислительные требования тестирования"
        ],
        correct: 1,
        expA: "На самом деле большие данные осложняют подготовку тестовых данных из-за объема и разнообразия.",
        expB: "Верно! Объем, скорость и разнообразие больших данных требуют специальных техник и инструментов тестирования.",
        expC: "Большие данные увеличивают потребность в проверке, а не устраняют ее.",
        expD: "Большие данные значительно увеличивают вычислительные требования.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K1"
      },
      {
        id: 243,
        text: "Какое из утверждений дает ЛУЧШЕЕ описание автоматического смещения при тестировании ИИ? Выберите ОДИН ответ.",
        options: [
          "Предпочтение простых ML алгоритмов сложным нейросетевым подходам",
          "Чрезмерное доверие к предсказаниям модели без критической оценки",
          "Автоматическая фильтрация данных без учета контекстных факторов",
          "Использование только автоматизированных метрик для валидации модели"
        ],
        correct: 1,
        expA: "Это описывает алгоритмическое предпочтение, а не автоматическое смещение в принятии решений.",
        expB: "Точно! Автоматическое смещение - это тенденция некритично доверять результатам ИИ без должной верификации.",
        expC: "Это проблема обработки данных, не связанная с автоматическим смещением в оценке результатов.",
        expD: "Использование только автоматизированных метрик - это ограничение подхода, а не смещение восприятия.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      {
        id: 244,
        text: "Что НАИБОЛЕЕ вероятно усложнит обеспечение воспроизводимости в тестировании ИИ? Выберите ОДИН ответ.",
        options: [
          "Стохастический характер алгоритмов машинного обучения",
          "Детерминистические процедуры инициализации весов нейросетей",
          "Фиксированные гиперпараметры в процессе обучения модели",
          "Консистентные условия среды выполнения при тестировании"
        ],
        correct: 0,
        expA: "Верно! Случайные элементы в ML алгоритмах (инициализация весов, стохастический градиентный спуск) делают воспроизведение точных результатов крайне сложным.",
        expB: "Детерминистические процедуры как раз способствуют воспроизводимости, а не препятствуют ей.",
        expC: "Фиксированные гиперпараметры улучшают воспроизводимость, делая эксперименты более предсказуемыми.",
        expD: "Консистентная среда выполнения - это основа для обеспечения воспроизводимых результатов.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      {
        id: 245,
        text: "Какая характеристика ЛУЧШЕ всего описывает смещение подтверждения при тестировании ИИ? Выберите ОДИН ответ.",
        options: [
          "Предпочтение данных, подтверждающих существующие гипотезы о модели",
          "Интерпретация неоднозначных результатов в пользу успешной работы",
          "Систематический отбор тестовых случаев, поддерживающих ожидания",
          "Фокус на метриках, демонстрирующих преимущества текущего подхода"
        ],
        correct: 2,
        expA: "Это описывает смещение в данных, но не полностью охватывает смещение подтверждения в тестировании.",
        expB: "Это интерпретационное смещение, но не основная характеристика смещения подтверждения.",
        expC: "Именно так! Смещение подтверждения проявляется в тенденции выбирать тесты, которые скорее всего подтвердят наши предположения.",
        expD: "Это метрическое смещение, которое является следствием, а не определяющей характеристикой.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      {
        id: 246,
        text: "Какой фактор БОЛЬШЕ ВСЕГО влияет на сложность валидации ИИ-систем по сравнению с традиционными системами? Выберите ОДИН ответ.",
        options: [
          "Количество строк кода в системе",
          "Отсутствие четких спецификаций ожидаемого поведения",
          "Использование объектно-ориентированного программирования",
          "Потребность в постоянных обновлениях системы"
        ],
        correct: 1,
        expA: "Количество строк кода влияет на сложность, но не является уникальным для ИИ-систем.",
        expB: "Правильно! ИИ-системы часто обучаются на данных без точных правил, что делает определение ожидаемого поведения крайне сложным.",
        expC: "ООП используется и в традиционных системах, не создавая ИИ-специфичных проблем валидации.",
        expD: "Потребность в обновлениях существует во многих типах систем, не только ИИ.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      {
        id: 247,
        text: "Какой из перечисленных подходов НАИБОЛЕЕ подходит для управления тестовыми данными в ИИ-проектах? Выберите ОДИН ответ.",
        options: [
          "Использование только синтетических данных",
          "Версионирование наборов данных с метаданными",
          "Хранение всех данных в одном репозитории",
          "Случайная выборка из производственных данных"
        ],
        correct: 1,
        expA: "Только синтетические данные могут не отражать реальные паттерны и ограничивают качество тестирования.",
        expB: "Точно! Версионирование данных с метаданными обеспечивает прозрачность, воспроизводимость и контроль качества данных.",
        expC: "Один репозиторий создает риски безопасности и усложняет управление доступом к различным типам данных.",
        expD: "Случайная выборка может нарушить конфиденциальность и не гарантирует репрезентативность.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      {
        id: 248,
        text: "Что ЛУЧШЕ всего описывает проблему оракула в контексте тестирования ИИ-систем? Выберите ОДИН ответ.",
        options: [
          "Неспособность получить доступ к данным для тестирования",
          "Отсутствие экспертов по машинному обучению в команде",
          "Сложность определения правильности результатов ИИ-системы",
          "Недостаточная производительность тестового оборудования"
        ],
        correct: 2,
        expA: "Проблемы доступа к данным - это логистическая проблема, а не проблема оракула.",
        expB: "Нехватка экспертов - организационная проблема, не связанная напрямую с проблемой оракула.",
        expC: "Верно! Проблема оракула в ИИ заключается в том, что часто невозможно однозначно определить, является ли результат правильным.",
        expD: "Производительность оборудования - техническое ограничение, не касающееся проблемы оракула.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      {
        id: 249,
        text: "Команда разрабатывает ИИ-систему распознавания медицинских изображений. Какой подход к тестированию ЛУЧШЕ всего подходит? Выберите ОДИН ответ.",
        options: [
          "Многоуровневая валидация с участием медицинских экспертов",
          "Автоматизированное тестирование на основе существующих наборов данных",
          "Кросс-валидация с использованием статистических метрик точности",
          "Регрессионное тестирование против предыдущих версий модели"
        ],
        correct: 0,
        expA: "Правильно! Медицинские ИИ-системы требуют экспертной оценки, клинической валидации и многоуровневого подхода для обеспечения безопасности пациентов.",
        expB: "Автоматизированное тестирование недостаточно для критически важных медицинских приложений, требующих экспертной оценки.",
        expC: "Статистические метрики важны, но недостаточны без клинической валидации и оценки медицинской релевантности.",
        expD: "Регрессионное тестирование полезно, но не является основным подходом для новых медицинских ИИ-систем.",
        points: 2,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      {
        id: 250,
        text: "При тестировании системы обработки естественного языка для анализа настроений, какой подход будет НАИБОЛЕЕ эффективным для оценки качества? Выберите ОДИН ответ.",
        options: [
          "Использование только количественных метрик точности",
          "Комбинация автоматизированных метрик с экспертной оценкой",
          "Тестирование только на англоязычных данных",
          "Фокус исключительно на скорости обработки текста"
        ],
        correct: 1,
        expA: "Только количественные метрики могут пропустить нюансы языка и контекстные ошибки анализа настроений.",
        expB: "Правильно! NLP системы требуют сочетания автоматических метрик и человеческой экспертизы для оценки качества понимания языка.",
        expC: "Ограничение одним языком не покрывает реальные сценарии использования и языковое разнообразие.",
        expD: "Скорость важна, но качество анализа настроений является приоритетным критерием для такой системы.",
        points: 2,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      {
        id: 251,
        text: "Для обеспечения честности (fairness) ИИ-системы рекрутинга, какая стратегия тестирования будет НАИБОЛЕЕ подходящей? Выберите ОДИН ответ.",
        options: [
          "Тестирование на разнообразных демографических группах с анализом смещений",
          "Использование только технических метрик производительности",
          "Тестирование исключительно на исторических данных компании",
          "Фокус на оптимизации скорости обработки заявок"
        ],
        correct: 0,
        expA: "Верно! Системы рекрутинга должны тестироваться на предмет дискриминации по демографическим признакам с анализом справедливости.",
        expB: "Технические метрики не выявляют социальные смещения и дискриминационные паттерны в решениях системы.",
        expC: "Исторические данные могут содержать существующие смещения, которые система может усилить.",
        expD: "Скорость вторична по отношению к честности и недискриминационности в системах рекрутинга.",
        points: 2,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      {
        id: 252,
        text: "Какой подход НАИБОЛЕЕ эффективен для тестирования устойчивости ИИ-системы к состязательным примерам? Выберите ОДИН ответ.",
        options: [
          "Генерация направленных состязательных возмущений для критических случаев",
          "Случайное тестирование с добавлением шума к входным данным",
          "Тестирование граничных случаев с максимальными значениями входов",
          "Градиентные атаки с оптимизированными параметрами возмущений"
        ],
        correct: 3,
        expA: "Направленные возмущения полезны, но менее систематичны чем градиентные методы для поиска уязвимостей.",
        expB: "Случайный шум может не найти специфические уязвимости, которые выявляют целенаправленные атаки.",
        expC: "Граничные значения тестируют пределы системы, но не моделируют реальные состязательные атаки.",
        expD: "Правильно! Градиентные атаки используют информацию о модели для создания наиболее эффективных состязательных примеров.",
        points: 2,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      {
        id: 253,
        text: "При тестировании рекомендательной системы электронной коммерции, какой фактор НАИБОЛЕЕ важен для оценки качества рекомендаций? Выберите ОДИН ответ.",
        options: [
          "Скорость генерации рекомендаций",
          "Количество рекомендованных товаров",
          "Balance между релевантностью и разнообразием рекомендаций",
          "Популярность рекомендованных товаров"
        ],
        correct: 2,
        expA: "Скорость важна, но качество рекомендаций является приоритетным критерием успеха системы.",
        expB: "Количество рекомендаций менее важно чем их качество и соответствие потребностям пользователя.",
        expC: "Точно! Хорошие рекомендации должны быть релевантными пользователю, но достаточно разнообразными для открытия новых товаров.",
        expD: "Популярность может привести к 'filter bubble' и снижению удовлетворенности пользователей.",
        points: 2,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      {
        id: 254,
        text: "Какой подход ЛУЧШЕ всего подойдет для тестирования ИИ-системы в автономном транспорте? Выберите ОДИН ответ.",
        options: [
          "Тестирование только в контролируемой лабораторной среде",
          "Комбинация симуляций, полигонных и ограниченных дорожных тестов",
          "Немедленное тестирование в реальном дорожном движении",
          "Использование только исторических данных дорожного движения"
        ],
        correct: 1,
        expA: "Только лабораторное тестирование не покрывает сложность и непредсказуемость реальных дорожных условий.",
        expB: "Правильно! Безопасность требует поэтапного подхода: от симуляций к полигонным тестам, затем к ограниченным дорожным испытаниям.",
        expC: "Немедленное тестирование на дорогах создает неприемлемые риски безопасности для общества.",
        expD: "Исторические данные не могут заменить тестирование реакций системы в реальном времени.",
        points: 2,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      {
        id: 255,
        text: "Организация планирует внедрение ИИ-системы для автоматизации кредитных решений. Какой подход к управлению рисками будет НАИБОЛЕЕ сбалансированным? Выберите ОДИН ответ.",
        options: [
          "Полная автоматизация с минимальным человеческим контролем",
          "Отказ от внедрения из-за потенциальных рисков",
          "Использование системы только для внутреннего анализа",
          "Гибридный подход с человеческим надзором и постепенным расширением автономии"
        ],
        correct: 3,
        expA: "Полная автоматизация в критичных финансовых решениях создает неприемлемые риски регулирования и репутации.",
        expB: "Полный отказ лишает организацию конкурентных преимуществ и возможностей инноваций.",
        expC: "Ограничение внутренним использованием не максимизирует бизнес-ценность и возврат инвестиций.",
        expD: "Верно! Поэтапное внедрение с человеческим контролем позволяет получить выгоды ИИ при управлении рисками.",
        points: 3,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      {
        id: 256,
        text: "Организация внедряет ИИ в критически важные бизнес-процессы. Как ЛУЧШЕ всего сбалансировать инновации и управление рисками? Выберите ОДИН ответ.",
        options: [
          "Поэтапное внедрение с непрерывным мониторингом и возможностью отката",
          "Агрессивная стратегия с фокусом на конкурентные преимущества",
          "Консервативный подход с минимизацией всех потенциальных рисков",
          "Изолированная среда тестирования без интеграции с основными процессами"
        ],
        correct: 0,
        expA: "Правильно! Поэтапное внедрение позволяет получать выгоды от инноваций при сохранении способности быстро реагировать на проблемы.",
        expB: "Агрессивный подход может привести к системным сбоям и репутационным потерям в критичных процессах.",
        expC: "Чрезмерно консервативный подход замедляет инновации и может привести к потере конкурентных позиций.",
        expD: "Изоляция не позволяет получить реальную бизнес-ценность от внедрения ИИ-технологий.",
        points: 3,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      {
        id: 257,
        text: "При создании стратегии тестирования для ИИ-системы финтех-компании, какой фактор должен иметь НАИВЫСШИЙ приоритет? Выберите ОДИН ответ.",
        options: [
          "Минимизация времени выхода продукта на рынок",
          "Максимизация автоматизации тестовых процессов",
          "Обеспечение соответствия регулятивным требованиям и управление рисками",
          "Оптимизация стоимости разработки и тестирования"
        ],
        correct: 2,
        expA: "Скорость выхода на рынок важна, но не может превышать приоритет соблюдения регулирования в финансовой сфере.",
        expB: "Автоматизация эффективна, но регулятивное соответствие требует экспертной оценки и человеческого контроля.",
        expC: "Верно! В финтехе регулятивное соответствие и управление рисками являются критическими для бизнеса и должны быть приоритетом номер один.",
        expD: "Оптимизация затрат важна, но нарушение регулирования может привести к гораздо большим финансовым потерям.",
        points: 3,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      {
        id: 258,
        text: "При оценке готовности ИИ-системы к промышленному использованию, какой подход обеспечит НАИБОЛЕЕ комплексную оценку? Выберите ОДИН ответ.",
        options: [
          "Мультикритериальная оценка с весовыми коэффициентами по доменам",
          "Фокус на технических метриках производительности и точности",
          "Интегрированная оценка рисков, производительности и готовности операций",
          "Приоритизация пользовательского опыта и интерфейса взаимодействия"
        ],
        correct: 2,
        expA: "Мультикритериальная оценка полезна, но может не учитывать взаимодействие между различными аспектами системы.",
        expB: "Технические метрики важны, но недостаточны без оценки операционной готовности и рисков.",
        expC: "Точно! Комплексная оценка должна учитывать технические, операционные и рисковые аспекты в их взаимодействии.",
        expD: "Пользовательский опыт критичен, но не может быть единственным критерием готовности к промышленному использованию.",
        points: 3,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      {
        id: 259,
        text: "Компания рассматривает внедрение ИИ для управления цепочками поставок. Какая стратегия оценки воздействия будет НАИБОЛЕЕ эффективной? Выберите ОДИН ответ.",
        options: [
          "Фокус только на прямых финансовых выгодах",
          "Оценка влияния на отдельные бизнес-процессы",
          "Анализ только технических рисков внедрения",
          "Холистическая оценка воздействия на экосистему партнеров и стейкхолдеров"
        ],
        correct: 3,
        expA: "Финансовые выгоды важны, но игнорирование других факторов может привести к неожиданным проблемам.",
        expB: "Оценка отдельных процессов не учитывает системные эффекты и взаимозависимости в цепочке поставок.",
        expC: "Технические риски составляют только часть общей картины воздействия на бизнес-экосистему.",
        expD: "Правильно! Управление цепочками поставок влияет на всю экосистему, требуя комплексной оценки воздействия на всех участников.",
        points: 3,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      {
        id: 260,
        text: "Какой фактор НАИБОЛЕЕ характерен для вызовов тестирования ИИ-систем по сравнению с традиционным ПО? Выберите ОДИН ответ.",
        options: [
          "Сложность языков программирования",
          "Размер команды разработчиков",
          "Стоимость инфраструктуры тестирования",
          "Недетерминистичное поведение и проблемы оракула"
        ],
        correct: 3,
        expA: "Сложность языков программирования не уникально характеризует вызовы тестирования ИИ-систем.",
        expB: "Размер команды - это фактор управления проектом, а не фундаментальный вызов тестирования, специфичный для ИИ-систем.",
        expC: "Стоимость инфраструктуры может быть выше, но не является уникальным концептуальным вызовом ИИ.",
        expD: "Точно! Недетерминистичное поведение ИИ усложняет определение ожидаемых результатов, создавая проблемы оракула.",
        points: 1,
        chapter: "Обзор Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      {
        id: 261,
        text: "Какое из следующих утверждений о тест-оракулах для вероятностных ИИ-систем является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Они используют статистические критерии приемлемости",
          "Они требуют точного совпадения выходных данных", 
          "Они полностью исключают любую неопределенность",
          "Они производят детерминированные результаты работы"
        ],
        correct: 0,
        expA: "Правильно! Вероятностные системы нуждаются в статистических методах для определения приемлемых диапазонов результатов.",
        expB: "Неверно. Вероятностные системы не могут использовать точное совпадение, поскольку результаты варьируются даже при одинаковых входных данных.",
        expC: "Неверно. Тест-оракулы не могут полностью исключить неопределенность - они помогают управлять ею систематически.",
        expD: "Неверно. Тест-оракулы для вероятностных систем должны работать с непредсказуемым поведением, а не производить детерминированные результаты.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K1"
      },
      {
        id: 262,
        text: "Что ЛУЧШЕ ВСЕГО описывает недопустимое смещение в ИИ-системах? Выберите ОДИН вариант.",
        options: [
          "Систематическую несправедливую дискриминацию определенных групп",
          "Технические ошибки в алгоритмах машинного обучения", 
          "Случайные вариации в предсказаниях модели",
          "Неоптимальное распределение вычислительных ресурсов"
        ],
        correct: 0,
        expA: "Правильно! Недопустимое смещение означает систематическую дискриминацию против защищенных групп или несправедливые паттерны обращения.",
        expB: "Неверно. Технические ошибки - это баги в коде, а не проблемы социального смещения.",
        expC: "Неверно. Случайные вариации - это нормальная неопределенность модели, не связанная с дискриминацией.",
        expD: "Неверно. Распределение ресурсов - это техническая проблема производительности, не связанная со справедливостью.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K1"
      },
    
      // K2 QUESTIONS - ИСПРАВЛЕНЫ: Все дистракторы из ИИ/МО области с техническими нюансами
      {
        id: 263,
        text: "Какой подход НАИБОЛЕЕ эффективен для тестирования самообучающихся систем? Выберите ОДИН вариант.",
        options: [
          "Непрерывный мониторинг с адаптивными эталонами производительности",
          "Периодическое тестирование с фиксированными наборами тестов",
          "Однократное комплексное тестирование после завершения обучения",
          "Исключительно ручная проверка без автоматизированных инструментов"
        ],
        correct: 0,
        expA: "Правильно! Самообучающиеся системы постоянно эволюционируют, требуя непрерывного мониторинга с адаптивными подходами к оценке.",
        expB: "Недостаточно. Периодическое тестирование может пропустить критические изменения между проверками.",
        expC: "Неэффективно. Однократное тестирование не может отследить эволюцию поведения самообучающейся системы.",
        expD: "Неприменимо. Ручная проверка не масштабируется для постоянно изменяющихся систем.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 264,
        text: "Что характеризует эффективное тестирование автономных систем в различных операционных средах? Выберите ОДИН вариант.",
        options: [
          "Тестирование только в лабораторных условиях с контролируемыми параметрами",
          "Моделирование разнообразных сценариев с различными условиями окружения",
          "Фокус исключительно на наихудших возможных сценариях",
          "Тестирование только наиболее вероятных рабочих условий"
        ],
        correct: 1,
        expA: "Недостаточно. Лабораторные условия не отражают реальную сложность операционной среды.",
        expB: "Правильно! Автономные системы должны работать в различных условиях, требуя всестороннего тестирования разнообразных сценариев.",
        expC: "Односторонний подход. Фокус только на крайних случаях игнорирует типичные операционные сценарии.",
        expD: "Ограниченно. Тестирование только типичных условий может пропустить важные граничные случаи.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 265,
        text: "Какой аспект НАИБОЛЕЕ важен при тестировании интерпретируемости ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Техническая точность внутренних вычислений модели",
          "Скорость генерации объяснений для пользователей",
          "Понятность и полезность объяснений для целевой аудитории",
          "Количество технических деталей в предоставляемых объяснениях"
        ],
        correct: 2,
        expA: "Вторично. Техническая точность важна, но без понятности не приносит пользы пользователям.",
        expB: "Важно, но не первично. Быстрые, но непонятные объяснения не решают задачу интерпретируемости.",
        expC: "Правильно! Интерпретируемость достигается когда объяснения понятны и полезны для принятия решений целевой аудиторией.",
        expD: "Контрпродуктивно. Избыток технических деталей может снизить понятность для нетехнических пользователей.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 266,
        text: "Что ЛУЧШЕ ВСЕГО описывает проблему оракула при тестировании непредсказуемых ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Сложность определения корректных ожидаемых результатов для сравнения",
          "Недостаток вычислительных ресурсов для выполнения тестов",
          "Отсутствие подходящих инструментов автоматизированного тестирования",
          "Ограниченное время, выделенное на процесс тестирования"
        ],
        correct: 0,
        expA: "Правильно! Проблема оракула заключается в сложности определения ожидаемых результатов для недетерминированных систем.",
        expB: "Неверно. Это проблема производительности тестирования, не связанная с определением корректности результатов.",
        expC: "Неверно. Это проблема инструментального обеспечения, не касающаяся определения ожидаемых результатов.",
        expD: "Неверно. Это проблема планирования проекта, не связанная с определением корректности поведения системы.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 267,
        text: "Какой подход НАИБОЛЕЕ эффективен для оценки объяснимости в системах глубокого обучения? Выберите ОДИН вариант.",
        options: [
          "Анализ только внутренних математических весов нейронной сети",
          "Пользовательская оценка понятности и практической применимости объяснений",
          "Измерение скорости генерации объяснений системой",
          "Подсчет количества слов в текстовых объяснениях"
        ],
        correct: 1,
        expA: "Недостаточно. Математические веса малопонятны пользователям и не отражают практическую объяснимость.",
        expB: "Правильно! Объяснимость должна оцениваться с точки зрения конечных пользователей и практической применимости.",
        expC: "Вторично. Быстрота не гарантирует качество и понятность объяснений.",
        expD: "Неинформативно. Количество слов не коррелирует с качеством и понятностью объяснений.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 268,
        text: "Что характеризует эффективную стратегию тестирования алгоритмического смещения? Выберите ОДИН вариант.",
        options: [
          "Тестирование только на общедоступных эталонных наборах данных",
          "Фокус исключительно на технической точности алгоритмов",
          "Анализ только наиболее представленных групп в данных",
          "Систематическое тестирование справедливости для различных демографических групп"
        ],
        correct: 3,
        expA: "Ограниченно. Общедоступные наборы могут не отражать специфику конкретного применения.",
        expB: "Недостаточно. Техническая точность не гарантирует отсутствие дискриминации.",
        expC: "Предвзято. Игнорирование меньшинств может усугубить проблемы смещения.",
        expD: "Правильно! Эффективное тестирование смещения требует систематического анализа справедливости для всех затронутых групп.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
      {
        id: 269,
        text: "Какой аспект НАИБОЛЕЕ критичен при тестировании прозрачности ИИ-решений? Выберите ОДИН вариант.",
        options: [
          "Скорость обработки запросов на объяснения",
          "Количество технических параметров в ответах",
          "Соответствие объяснений регуляторным требованиям",
          "Доступность и понятность процесса принятия решений"
        ],
        correct: 3,
        expA: "Вторично. Быстрые, но непонятные объяснения не обеспечивают прозрачность.",
        expB: "Контрпродуктивно. Избыток технических деталей может снижать, а не повышать прозрачность.",
        expC: "Важно, но не первично. Соответствие требованиям должно базироваться на понятности.",
        expD: "Правильно! Прозрачность достигается когда процесс принятия решений доступен и понятен заинтересованным сторонам.",
        points: 1,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K2"
      },
    
      // K3 QUESTIONS - ИСПРАВЛЕНЫ: Все варианты звучат как профессиональные рекомендации
      {
        id: 270,
        text: "При тестировании системы рекомендаций с высокими требованиями к справедливости, какой подход обеспечит НАИБОЛЕЕ комплексную оценку? Выберите ОДИН вариант.",
        options: [
          "Комбинированное тестирование с использованием множественных метрик справедливости и сценариев",
          "Фокус на единственной наиболее важной метрике справедливости",
          "Тестирование только на исторических данных без моделирования",
          "Ограничение тестирования технической функциональностью алгоритма"
        ],
        correct: 0,
        expA: "Правильно! Справедливость многоаспектна, требуя комплексного подхода с различными метриками и сценариями.",
        expB: "Неполно. Фокус на одной метрике может пропустить другие аспекты несправедливости.",
        expC: "Ограниченно. Исторические данные могут содержать скрытые смещения, требуя дополнительного моделирования.",
        expD: "Недостаточно. Техническая функциональность не охватывает аспекты социальной справедливости.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 271,
        text: "При внедрении автономной системы в критически важное окружение, какая стратегия тестирования НАИБОЛЕЕ эффективна? Выберите ОДИН вариант.",
        options: [
          "Исчерпывающее тестирование всех возможных сценариев перед запуском",
          "Поэтапное внедрение с постепенным расширением автономии и непрерывным мониторингом",
          "Немедленное полное развертывание с реактивным исправлением проблем",
          "Ограничение функциональности до минимально необходимой без расширения"
        ],
        correct: 1,
        expA: "Нереалистично. Исчерпывающее тестирование всех сценариев практически невозможно для сложных систем.",
        expB: "Правильно! Поэтапный подход позволяет управлять рисками и учиться на каждом этапе внедрения.",
        expC: "Рискованно. Реактивный подход в критических системах может привести к серьезным последствиям.",
        expD: "Консервативно. Чрезмерное ограничение функциональности может снизить ценность системы.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 272,
        text: "Для системы обнаружения аномалий с изменяющимися паттернами данных, какой подход к валидации НАИБОЛЕЕ подходящий? Выберите ОДИН вариант.",
        options: [
          "Статическая валидация на фиксированном наборе исторических данных",
          "Одноразовая комплексная проверка после завершения обучения модели",
          "Адаптивная валидация с единообразными метриками и обновляющимися эталонами",
          "Валидация только на синтетически сгенерированных данных"
        ],
        correct: 2,
        expA: "Неподходящий. Статическая валидация не отражает динамически изменяющуюся природу данных.",
        expB: "Недостаточно. Одноразовая проверка не учитывает эволюцию паттернов после развертывания.",
        expC: "Правильно! Изменяющиеся паттерны требуют адаптивной валидации с обновляющимися критериями оценки.",
        expD: "Ограниченно. Синтетические данные могут не отражать реальную сложность и изменчивость.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 273,
        text: "При тестировании системы персонализированных рекомендаций на предмет смещения, какой подход обеспечит НАИБОЛЕЕ точную оценку? Выберите ОДИН вариант.",
        options: [
          "Анализ только агрегированных показателей производительности всей системы",
          "Сегментированный анализ производительности по различным демографическим группам",
          "Тестирование исключительно на случайной выборке пользователей",
          "Фокус только на технических метриках алгоритма машинного обучения"
        ],
        correct: 1,
        expA: "Недостаточно. Агрегированные показатели могут скрывать дискриминацию отдельных групп.",
        expB: "Правильно! Сегментированный анализ выявляет различия в производительности между группами, показывая потенциальное смещение.",
        expC: "Неструктурированно. Случайная выборка может не обеспечить достаточное представительство всех групп.",
        expD: "Неполно. Технические метрики не отражают социальные аспекты справедливости и смещения.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 274,
        text: "При валидации автономной системы с возникающими поведениями, какая стратегия НАИБОЛЕЕ эффективна? Выберите ОДИН вариант.",
        options: [
          "Предварительное определение всех возможных сценариев поведения",
          "Фокус исключительно на запрограммированных функциях системы",
          "Статическое тестирование только основных операционных режимов",
          "Непрерывный мониторинг с адаптивными критериями оценки новых поведений"
        ],
        correct: 3,
        expA: "Нереалистично. Возникающие поведения по определению нельзя полностью предсказать заранее.",
        expB: "Недостаточно. Возникающие поведения выходят за рамки изначально запрограммированных функций.",
        expC: "Ограниченно. Статическое тестирование не может захватить динамическую природу возникающих поведений.",
        expD: "Правильно! Возникающие поведения требуют непрерывного наблюдения и адаптивных подходов к их оценке.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
      {
        id: 275,
        text: "Для обеспечения эффективной объяснимости в медицинской диагностической системе, какой подход НАИБОЛЕЕ подходящий? Выберите ОДИН вариант.",
        options: [
          "Предоставление только технических параметров модели специалистам",
          "Генерация объяснений исключительно на основе статистических корреляций",
          "Создание объяснений с учетом понимания пользователями и практической пользы",
          "Ограничение объяснений краткими автоматическими резюме"
        ],
        correct: 2,
        expA: "Неполно. Технические параметры могут быть непонятны медицинским специалистам без ИИ-экспертизы.",
        expB: "Недостаточно. Статистические корреляции не обязательно объясняют причинно-следственные связи.",
        expC: "Правильно! Объяснимость должна учитывать контекст пользователей и способствовать принятию обоснованных решений.",
        expD: "Ограниченно. Краткие резюме могут не предоставлять достаточной информации для критических решений.",
        points: 2,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K3"
      },
    
      // K4 QUESTIONS - ИСПРАВЛЕНЫ: Сложные сценарии требующие системного мышления
      {
        id: 276,
        text: "При разработке стратегии тестирования смещения для многокультурного применения ИИ, какой подход НАИБОЛЕЕ комплексный? Выберите ОДИН вариант.",
        options: [
          "Пересекающийся анализ справедливости с учетом взаимодействия множественных характеристик",
          "Последовательное тестирование каждой демографической характеристики изолированно",
          "Фокус исключительно на наиболее представленных группах в данных",
          "Применение универсальных метрик справедливости без культурной адаптации"
        ],
        correct: 0,
        expA: "Правильно! Пересекающийся анализ учитывает сложные взаимодействия между различными характеристиками и культурными контекстами.",
        expB: "Недостаточно. Изолированное тестирование пропускает важные взаимодействия между характеристиками.",
        expC: "Предвзято. Игнорирование меньшинств усугубляет проблемы репрезентативности и справедливости.",
        expD: "Неадекватно. Универсальные метрики могут не отражать специфические культурные понимания справедливости.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 277,
        text: "При внедрении автономных систем в динамически изменяющуюся среду, какая стратегия управления рисками НАИБОЛЕЕ эффективна? Выберите ОДИН вариант.",
        options: [
          "Фиксированные протоколы безопасности без возможности адаптации",
          "Реактивное управление рисками только после обнаружения проблем",
          "Адаптивное управление рисками с непрерывной оценкой и корректировкой стратегий",
          "Полное избегание неопределенных сценариев путем ограничения функциональности"
        ],
        correct: 2,
        expA: "Негибко. Фиксированные протоколы не могут адаптироваться к новым и непредвиденным угрозам.",
        expB: "Рискованно. Реактивный подход может позволить ущербу произойти до принятия мер.",
        expC: "Правильно! Динамическая среда требует адаптивного подхода с проактивной оценкой и корректировкой стратегий.",
        expD: "Консервативно. Чрезмерное ограничение функциональности может устранить пользу от автономности.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 278,
        text: "Для комплексной оценки надежности ИИ-системы критического назначения, какая стратегия тестирования НАИБОЛЕЕ всесторонняя? Выберите ОДИН вариант.",
        options: [
          "Изолированное тестирование каждого компонента с универсальными критериями",
          "Фокус исключительно на функциональном тестировании основных возможностей",
          "Многоуровневая оценка с критериями, специфичными для каждой модели и интеграционным тестированием",
          "Ограничение тестирования только наиболее вероятными сценариями использования"
        ],
        correct: 2,
        expA: "Неполно. Изолированное тестирование не выявляет проблемы взаимодействия компонентов.",
        expB: "Недостаточно. Функциональное тестирование не покрывает нефункциональные аспекты надежности.",
        expC: "Правильно! Комплексная оценка требует многоуровневого подхода с учетом специфики каждого компонента и их взаимодействий.",
        expD: "Ограниченно. Тестирование только типичных сценариев пропускает критические граничные случаи.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 279,
        text: "При создании стратегии валидации для диагностических ИИ-систем с высокой неопределенностью, какой подход НАИБОЛЕЕ адекватный? Выберите ОДИН вариант.",
        options: [
          "Стандартная валидация с фиксированными пороговыми значениями точности",
          "Фокус исключительно на максимизации общей точности системы",
          "Комплексная валидация с оценкой неопределенности, калибровкой и клиническим контекстом",
          "Валидация только на контролируемых лабораторных данных"
        ],
        correct: 2,
        expA: "Неподходящий. Фиксированные пороги не учитывают вариативность неопределенности в разных случаях.",
        expB: "Односторонний. Максимизация общей точности может игнорировать важные клинические нюансы.",
        expC: "Правильно! Диагностические системы требуют комплексного подхода, учитывающего неопределенность и клинический контекст.",
        expD: "Ограниченно. Лабораторные данные не отражают сложность реальной клинической практики.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 280,
        text: "При управлении тестированием ИИ-портфолио с различными требованиями к риск-толерантности, какая стратегия НАИБОЛЕЕ эффективна? Выберите ОДИН вариант.",
        options: [
          "Унифицированные протоколы тестирования для всех систем портфолио",
          "Сокращение функциональности всех систем до минимально рискованного уровня",
          "Полное избегание автоматизированного тестирования из-за сложности",
          "Риск-ориентированные методологии с адаптированной интенсивностью и непрерывным мониторингом"
        ],
        correct: 3,
        expA: "Неэффективно. Унифицированные протоколы не учитывают различные риск-профили систем.",
        expB: "Контрпродуктивно. Сокращение функциональности снижает бизнес-ценность вместо решения проблемы сложности.",
        expC: "Нерациональный. Автоматизация критически важна для управления сложностью ИИ-портфолио.",
        expD: "Правильно! Риск-ориентированные методологии позволяют индивидуальную интенсивность тестирования с непрерывным отслеживанием эволюции систем.",
        points: 3,
        chapter: "Тестирование характеристик качества, специфичных для ИИ",
        difficulty: "K4"
      },
      {
        id: 281,
        text: "Какое из следующих утверждений о регрессионном тестировании ИИ-систем является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Оно использует контейнеры Docker для изоляции тестовых сред",
          "Оно гарантирует неизменность предыдущей функциональности после обновлений",
          "Оно применяет PostgreSQL для хранения результатов тестирования",
          "Оно создает REST API для интеграции с Jenkins"
        ],
        correct: 1,
        expA: "Docker - это инструмент контейнеризации, не связанный напрямую с регрессионным тестированием ИИ.",
        expB: "Отлично! Регрессионное тестирование гарантирует, что изменения не нарушают существующую функциональность.",
        expC: "PostgreSQL - это система управления базами данных, не специфичная для регрессионного тестирования.",
        expD: "REST API и Jenkins - это инструменты DevOps, а не сущность регрессионного тестирования.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K1"
      },
      
      {
        id: 282,
        text: "Какое из следующих утверждений о тестовых оракулах в тестировании ИИ является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Они используют React для создания пользовательских интерфейсов",
          "Они предоставляют ожидаемые результаты для сравнения тест-кейсов",
          "Они применяют Kubernetes для оркестрации микросервисов",
          "Они интегрируются с MongoDB для хранения данных"
        ],
        correct: 1,
        expA: "React - это фронтенд-фреймворк, не связанный с концепцией тестовых оракулов.",
        expB: "Точно! Тестовые оракулы предоставляют ожидаемые результаты для сравнения с фактическими.",
        expC: "Kubernetes - это платформа оркестрации, не относящаяся к тестовым оракулам.",
        expD: "MongoDB - это NoSQL база данных, не связанная с функциональностью оракулов.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K1"
      },
      
      // ============================================================================
      // K2 ВОПРОСЫ (ID: 283-289) - СТРАТЕГИЯ: ВСЕ ИЗ AI/ML ОБЛАСТИ С ТОНКИМИ РАЗЛИЧИЯМИ
      // ============================================================================
      
      {
        id: 283,
        text: "Какое из следующих утверждений о разбиении на классы эквивалентности в тестировании ИИ является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Оно группирует похожие тест-кейсы для сокращения тестовых усилий",
          "Оно кластеризует данные обучения для улучшения производительности модели",
          "Оно классифицирует типы ошибок предсказаний по частоте возникновения",
          "Оно категоризирует метрики оценки по их чувствительности к выбросам"
        ],
        correct: 0,
        expA: "Правильно! Разбиение на классы эквивалентности группирует входные данные с ожидаемо одинаковым поведением.",
        expB: "Это описывает кластеризацию данных в машинном обучении, а не тестовую технику.",
        expC: "Это описывает анализ ошибок, а не технику разбиения на классы эквивалентности.",
        expD: "Это описывает категоризацию метрик, а не технику тестирования входных данных.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      
      {
        id: 284,
        text: "Что ЛУЧШЕ всего описывает анализ граничных значений в ИИ-системах? Выберите ОДИН вариант.",
        options: [
          "Тестирование экстремальных значений на границах входных параметров",
          "Анализ пороговых значений активации в нейронных сетях",
          "Определение границ доверительных интервалов в статистических моделях",
          "Валидация граничных условий в логике принятия решений моделью"
        ],
        correct: 0,
        expA: "Правильно! Анализ граничных значений тестирует экстремальные значения входных параметров.",
        expB: "Это описывает внутренние параметры нейронных сетей, а не тестовую технику.",
        expC: "Это описывает статистический анализ неопределенности, а не тестирование границ.",
        expD: "Это описывает логику ИИ-модели, а не технику граничного тестирования.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      
      {
        id: 285,
        text: "Какое из следующих утверждений о мутационном тестировании в ИИ-системах является ПРАВИЛЬНЫМ? Выберите ОДИН вариант.",
        options: [
          "Оно изменяет архитектуру нейронной сети для поиска оптимальной конфигурации",
          "Оно варьирует гиперпараметры обучения для максимизации точности модели",
          "Оно оценивает устойчивость ИИ путем внесения контролируемых изменений",
          "Оно адаптирует веса модели во время инференса для новых типов данных"
        ],
        correct: 2,
        expA: "Это описывает архитектурный поиск нейронных сетей, а не мутационное тестирование.",
        expB: "Это описывает оптимизацию гиперпараметров, а не технику мутационного тестирования.",
        expC: "Точно! Мутационное тестирование вносит небольшие изменения для оценки устойчивости системы.",
        expD: "Это описывает адаптивное обучение, а не мутационное тестирование.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      
      {
        id: 286,
        text: "Что ЛУЧШЕ всего описывает попарное тестирование в ИИ-системах? Выберите ОДИН вариант.",
        options: [
          "Тестирование всех комбинаций пар входных параметров",
          "Сравнение производительности двух конкурирующих ИИ-моделей",
          "Валидация корреляций между парами признаков в наборе данных",
          "Оценка согласованности предсказаний между парными ансамблевыми моделями"
        ],
        correct: 0,
        expA: "Правильно! Попарное тестирование проверяет все комбинации пар входных параметров.",
        expB: "Это описывает сравнительное тестирование моделей, а не технику попарного тестирования.",
        expC: "Это описывает корреляционный анализ данных, а не технику тестирования комбинаций.",
        expD: "Это описывает валидацию ансамблей, а не попарное комбинаторное тестирование.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      
      {
        id: 287,
        text: "Какое из следующих утверждений о метаморфном тестировании наиболее ПРАВИЛЬНО? Выберите ОДИН вариант.",
        options: [
          "Оно трансформирует входные данные для создания новых тест-кейсов",
          "Оно преобразует архитектуру модели для повышения интерпретируемости",
          "Оно конвертирует форматы данных между различными представлениями",
          "Оно модифицирует алгоритмы обучения для адаптации к новым доменам"
        ],
        correct: 0,
        expA: "Правильно! Метаморфное тестирование использует трансформации входов для создания связанных тест-кейсов.",
        expB: "Это описывает трансформацию модели для объяснимости, а не метаморфное тестирование.",
        expC: "Это описывает преобразование форматов данных, а не технику метаморфного тестирования.",
        expD: "Это описывает адаптацию алгоритмов, а не метаморфное тестирование входных данных.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      
      {
        id: 288,
        text: "Что ЛУЧШЕ всего характеризует A/B тестирование в контексте ИИ-систем? Выберите ОДИН вариант.",
        options: [
          "Сравнение двух версий ИИ-модели в реальных условиях использования",
          "Альтернативное обучение модели на различных подмножествах данных",
          "Бинарная классификация результатов тестирования как успешных или неуспешных",
          "Асимметричная оценка производительности на сбалансированных и несбалансированных данных"
        ],
        correct: 0,
        expA: "Правильно! A/B тестирование сравнивает две версии системы в реальных условиях эксплуатации.",
        expB: "Это описывает альтернативные стратегии обучения, а не A/B тестирование в продакшене.",
        expC: "Это описывает бинарную оценку результатов, а не методологию A/B тестирования.",
        expD: "Это описывает оценку на различных типах данных, а не A/B сравнение систем.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      
      {
        id: 289,
        text: "Какое утверждение ЛУЧШЕ всего описывает back-to-back тестирование в ИИ-системах? Выберите ОДИН вариант.",
        options: [
          "Последовательное обучение моделей на исторических данных в хронологическом порядке",
          "Параллельное выполнение одинаковых тест-кейсов на разных реализациях системы",
          "Реверсивное тестирование с восстановлением входных данных из выходных результатов",
          "Итеративное тестирование с возвратом к предыдущим конфигурациям при обнаружении ошибок"
        ],
        correct: 1,
        expA: "Это описывает последовательное обучение на временных данных, а не back-to-back тестирование.",
        expB: "Точно! Back-to-back тестирование сравнивает результаты одинаковых входов на разных реализациях.",
        expC: "Это описывает обратную инженерию или инверсное тестирование, а не back-to-back подход.",
        expD: "Это описывает итеративное тестирование с откатом, а не параллельное сравнение реализаций.",
        points: 1,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K2"
      },
      
      // ============================================================================
      // K3 ВОПРОСЫ (ID: 290-295) - СТРАТЕГИЯ: ПРОФЕССИОНАЛЬНЫЕ РЕКОМЕНДАЦИИ
      // ============================================================================
      
      {
        id: 290,
        text: "Команда тестирования ИИ-системы распознавания изображений обнаружила низкую точность на изображениях с плохим освещением. Какой подход к тестированию будет НАИБОЛЕЕ эффективным? Выберите ОДИН вариант.",
        options: [
          "Создать целевой набор данных с различными условиями освещения и применить граничное тестирование",
          "Увеличить общий объем тестовых данных без специализации на условиях освещения",
          "Использовать только синтетические данные для моделирования условий плохого освещения",
          "Применить случайное тестирование с надеждой на покрытие проблемных сценариев"
        ],
        correct: 0,
        expA: "Отлично! Целевой подход с граничным тестированием условий освещения наиболее эффективно выявит проблемы.",
        expB: "Общее увеличение данных менее эффективно, чем целевое тестирование специфических условий.",
        expC: "Только синтетические данные могут не покрыть всю сложность реальных условий освещения.",
        expD: "Случайное тестирование неэффективно для систематического выявления специфических проблем.",
        points: 2,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      
      {
        id: 291,
        text: "При тестировании чатбота с использованием NLP модели команда обнаружила неадекватные ответы на вопросы с двойным отрицанием. Какая стратегия тестирования будет НАИБОЛЕЕ подходящей? Выберите ОДИН вариант.",
        options: [
          "Увеличить размер обучающей выборки общими диалоговыми данными",
          "Применить метаморфное тестирование с трансформациями логической структуры вопросов",
          "Использовать только предопределенные шаблоны вопросов без вариаций",
          "Сосредоточиться исключительно на тестировании производительности системы"
        ],
        correct: 1,
        expA: "Общее увеличение данных не нацелено на специфическую проблему двойных отрицаний.",
        expB: "Отлично! Метаморфное тестирование с логическими трансформациями систематически выявит проблемы с отрицаниями.",
        expC: "Предопределенные шаблоны ограничивают покрытие возможных вариаций двойных отрицаний.",
        expD: "Тестирование производительности не решает проблему понимания логической структуры.",
        points: 2,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      
      {
        id: 292,
        text: "ИИ-система рекомендаций показывает смещение в пользу определенных демографических групп. Какой подход к тестированию НАИБОЛЕЕ эффективно выявит и измерит это смещение? Выберите ОДИН вариант.",
        options: [
          "Применить стандартное функциональное тестирование без учета демографических факторов",
          "Использовать только метрики общей точности системы на всем наборе данных",
          "Провести стратифицированное тестирование с анализом метрик справедливости по группам",
          "Сосредоточиться на тестировании технической производительности алгоритмов"
        ],
        correct: 2,
        expA: "Стандартное тестирование без учета демографических факторов не выявит смещения.",
        expB: "Общие метрики точности могут скрыть дисбаланс производительности между группами.",
        expC: "Правильно! Стратифицированное тестирование с метриками справедливости выявит и измерит смещение.",
        expD: "Техническое тестирование не адресует проблемы справедливости и социальных смещений.",
        points: 2,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      
      {
        id: 293,
        text: "Команда тестирует ИИ-систему медицинской диагностики, которая должна работать с данными из разных больниц. Какая стратегия тестирования ЛУЧШЕ всего подготовит систему к развертыванию? Выберите ОДИН вариант.",
        options: [
          "Тестировать только на данных из одной крупнейшей больницы-партнера",
          "Применить кросс-институциональную валидацию с анализом доменного сдвига",
          "Использовать исключительно синтетические медицинские данные",
          "Сосредоточиться на тестировании пользовательского интерфейса системы"
        ],
        correct: 1,
        expA: "Тестирование на данных одной больницы не подготовит к разнообразию реальных условий.",
        expB: "Отлично! Кросс-институциональная валидация выявит проблемы адаптации к различным источникам данных.",
        expC: "Только синтетические данные не покроют всю сложность реальных медицинских данных.",
        expD: "Тестирование интерфейса не адресует критические вопросы точности диагностики.",
        points: 2,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      
      {
        id: 294,
        text: "При тестировании автономной системы управления тестировщики обнаружили непредсказуемое поведение в пограничных сценариях. Какой подход НАИБОЛЕЕ эффективно обеспечит безопасность? Выберите ОДИН вариант.",
        options: [
          "Увеличить количество стандартных тест-кейсов без специализации",
          "Применить только симуляционное тестирование в контролируемой среде",
          "Использовать комбинацию сценарного тестирования и анализа отказоустойчивости",
          "Сосредоточиться исключительно на тестировании нормальных условий эксплуатации"
        ],
        correct: 2,
        expA: "Стандартные тест-кейсы не нацелены на критические пограничные сценарии.",
        expB: "Только симуляция может не покрыть всю сложность реальных непредвиденных ситуаций.",
        expC: "Правильно! Комбинация сценарного тестирования и анализа отказов наиболее полно обеспечит безопасность.",
        expD: "Тестирование только нормальных условий оставляет критические риски неопределенными.",
        points: 2,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      
      {
        id: 295,
        text: "ИИ-система обработки естественного языка показывает деградацию производительности на новых типах текста. Какая стратегия тестирования ЛУЧШЕ всего подготовит систему к эволюции данных? Выберите ОДИН вариант.",
        options: [
          "Использовать только исторические данные для валидации",
          "Применить адаптивное тестирование с непрерывным мониторингом дрейфа",
          "Сосредоточиться на тестировании архитектуры модели",
          "Увеличить частоту запуска существующих регрессионных тестов"
        ],
        correct: 1,
        expA: "Только исторические данные не подготовят к новым типам текста и эволюции языка.",
        expB: "Отлично! Адаптивное тестирование с мониторингом дрейфа выявит и адресует изменения в данных.",
        expC: "Тестирование архитектуры не решит проблему адаптации к новым типам контента.",
        expD: "Частое выполнение старых тестов не поможет с новыми типами данных.",
        points: 2,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K3"
      },
      
      // ============================================================================
      // K4 ВОПРОСЫ (ID: 296-300) - СТРАТЕГИЯ: СИСТЕМНОЕ МЫШЛЕНИЕ И СТРАТЕГИИ
      // ============================================================================
      
      {
        id: 296,
        text: "Организация планирует развертывание ИИ-системы в критически важной инфраструктуре. Множественные заинтересованные стороны имеют конфликтующие требования к тестированию. Какой стратегический подход ЛУЧШЕ всего сбалансирует эти требования? Выберите ОДИН вариант.",
        options: [
          "Приоритизировать требования крупнейшего заказчика над остальными",
          "Применить унифицированный минималистический подход ко всем требованиям",
          "Разработать риск-ориентированную матрицу с весовыми коэффициентами заинтересованных сторон",
          "Отложить развертывание до полного консенсуса всех участников"
        ],
        correct: 2,
        expA: "Приоритет одного заказчика игнорирует критические риски других заинтересованных сторон.",
        expB: "Минималистический подход может недооценить специфические критические требования.",
        expC: "Отлично! Риск-ориентированная матрица с весами систематически сбалансирует конфликтующие требования.",
        expD: "Ожидание полного консенсуса может привести к бесконечному откладыванию критического проекта.",
        points: 3,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      
      {
        id: 297,
        text: "Международная компания развертывает ИИ-систему модерации контента в регионах с различными культурными нормами и правовыми требованиями. Какая стратегия тестирования НАИБОЛЕЕ эффективно обеспечит глобальную применимость? Выберите ОДИН вариант.",
        options: [
          "Использовать единые глобальные стандарты для всех регионов",
          "Создать многоуровневую архитектуру тестирования с региональной адаптацией",
          "Сосредоточиться только на технических аспектах без культурных различий",
          "Применить децентрализованное тестирование без координации между регионами"
        ],
        correct: 1,
        expA: "Единые стандарты игнорируют критические региональные различия в культуре и законодательстве.",
        expB: "Правильно! Многоуровневая архитектура с региональной адаптацией оптимально балансирует консистентность и локальные требования.",
        expC: "Игнорирование культурных различий приведет к неприемлемым результатам в различных регионах.",
        expD: "Полная децентрализация без координации создаст несовместимые системы.",
        points: 3,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      
      {
        id: 298,
        text: "Крупная финансовая организация внедряет ИИ для кредитного скоринга в условиях жестких регулятивных требований. Система должна обеспечить прозрачность, справедливость и соответствие требованиям. Какой подход к тестированию ЛУЧШЕ всего адресует эти многофакторные вызовы? Выберите ОДИН вариант.",
        options: [
          "Применить агрессивную стратегию развертывания с реактивным управлением рисками",
          "Использовать консервативный подход с минимизацией функциональности системы",
          "Внедрить интегрированное тестирование с параллельной валидацией соответствия, справедливости и производительности",
          "Создать изолированную среду для экспериментального тестирования без внешних ограничений"
        ],
        correct: 2,
        expA: "Агрессивное развертывание в регулируемой среде создает недопустимые регулятивные и репутационные риски.",
        expB: "Консервативный подход с минимальной функциональностью не реализует потенциал бизнес-ценности ИИ.",
        expC: "Отлично! Интегрированный подход с параллельной валидацией оптимально адресует все критические требования.",
        expD: "Изолированное тестирование без учета реальных ограничений не подготовит к продакшен-среде.",
        points: 3,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      
      {
        id: 299,
        text: "Технологическая компания разрабатывает ИИ-систему для автоматической торговли на финансовых рынках. Система должна адаптироваться к изменчивости рынка при управлении рисками. Какая стратегия тестирования НАИБОЛЕЕ эффективна для таких динамических условий? Выберите ОДИН вариант.",
        options: [
          "Применить стандартные исторические данные для всех тестовых сценариев",
          "Комбинировать стресс-тестирование, мутационное тестирование и адаптивные эталоны",
          "Сосредоточиться исключительно на тестировании в нормальных рыночных условиях",
          "Использовать только симуляционное тестирование без реальных рыночных данных"
        ],
        correct: 1,
        expA: "Только исторические данные не подготовят к непредвиденным рыночным ситуациям.",
        expB: "Отлично! Комбинация стресс-тестирования, мутаций и адаптивных эталонов готовит к динамическим рыночным условиям.",
        expC: "Тестирование только нормальных условий оставляет систему неподготовленной к рыночной волатильности.",
        expD: "Только симуляции могут не отразить всю сложность реальных рыночных динамик.",
        points: 3,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K4"
      },
      
      {
        id: 300,
        text: "Глобальная технологическая корпорация разрабатывает мультимодальную ИИ-систему, работающую с текстом, изображениями и аудио в различных культурных контекстах. Какая стратегия тестирования НАИБОЛЕЕ эффективна? Выберите ОДИН вариант.",
        options: [
          "Тестировать каждую модальность отдельно без интеграционного тестирования",
          "Применить разбиение на классы эквивалентности с кросс-модальной и кросс-культурной валидацией",
          "Сосредоточиться только на доминирующих культурных контекстах",
          "Использовать случайное тестирование через произвольные комбинации контента"
        ],
        correct: 1,
        expA: "Отдельное тестирование упускает критические кросс-модальные взаимодействия и интеграционные проблемы.",
        expB: "Отлично! Системный подход с кросс-модальной и кросс-культурной валидацией обеспечивает комплексное покрытие.",
        expC: "Фокус на доминирующих контекстах игнорирует важные культурные различия в меньшинствах.",
        expD: "Случайное тестирование не обеспечивает систематического покрытия сложных мультимодальных взаимодействий.",
        points: 3,
        chapter: "Методы и Техники Тестирования ИИ-Систем",
        difficulty: "K4"
      }
]

// Export as fullQuestionPool for consistency
export const fullQuestionPool = examQuestionsBatch1RussianCorrected;